// Mainly for the main application, not the frontend
export default {
  customer_accounts: {
    tab: 'Sites & contacts',
    load_failed: 'Sites and contacts could not be loaded',
    save_failed: 'Saving failed',
    archive: 'Archive',
    archived: 'Archived',
    restore: 'Restore',
    show_archived: 'Show archived',
    sites: {
      title: 'Sites',
      subtitle:
        'Installation addresses of this customer. Every proposal, project and work order belongs to one site; the invoice always goes to the customer.',
      add: 'Add site',
      edit: 'Edit site',
      add_contact: 'Resident / contact on site',
      search: 'Search by address, label, reference or resident',
      no_results: 'No sites found',
      empty_title: 'No sites yet',
      empty_description: 'Add installation addresses, or paste a list of addresses from Excel at once.',
      created: 'Site added',
      updated: 'Site updated',
      updated_synced: 'Site updated, address applied to {count} open project(s)/work order(s)',
      archived: 'Site archived',
      restored: 'Site restored',
      archive_title: 'Archive {name}?',
      archive_description:
        'The site disappears from pickers. Existing proposals, projects and invoices stay unchanged.',
      archive_open_warning:
        'There are still {count} open work order(s) on this site. They remain, but the site disappears from pickers.',
      sync_hint:
        'An address change is applied to the open projects and work orders of this site ({count} open work order(s)).',
      usage: {
        proposals: 'Proposals: {count}',
        projects: 'Projects: {count}',
        open_work_orders: 'Open work orders: {count}',
      },
      fields: {
        label: 'Name / label',
        label_placeholder: 'E.g. Block A, House 12 or Office Utrecht',
        external_ref: 'Customer reference',
        external_ref_placeholder: 'E.g. lot number or project number',
        address: 'Installation address',
        access_notes: 'Access & details',
        access_notes_placeholder: 'Key with the caretaker, park at the back, ring at no. 14…',
        notes: 'Internal notes',
      },
      validation: {
        address_required: 'Enter at least a street, postal code or city',
      },
      bulk: {
        open: 'Paste multiple',
        title: 'Add multiple sites',
        intro:
          'One address per line. Paste straight from Excel (columns: label, street, house number, postal code, city) or type free text.',
        lines: 'Addresses',
        placeholder: 'Dorpsstraat 12, 1234 AB Utrecht',
        count: '{count} line(s)',
        submit: 'Add {count} site(s)',
        created: '{count} site(s) added',
        failed_title: '{count} line(s) not recognised',
        failed_hint: 'These lines are ready below for you to correct.',
      },
    },
    contacts: {
      title: 'Contacts',
      subtitle:
        'General contacts of the customer, like purchasing, accounts or site manager. Add residents on the site.',
      add: 'Add contact',
      edit: 'Edit contact',
      empty: 'No extra contacts yet. Emails go to the main address of {name}.',
      whole_customer: 'Whole customer (no specific site)',
      created: 'Contact added',
      updated: 'Contact updated',
      archived: 'Contact archived',
      restored: 'Contact restored',
      archive_title: 'Archive {name}?',
      archive_description:
        'This person no longer receives emails. Existing proposals and projects stay unchanged.',
      primary_hint_site: 'First point of contact on this site',
      primary_hint_customer: 'First point of contact for the whole customer',
      roles: {
        quote: 'Proposals',
        invoice: 'Invoices',
        planning: 'Planning',
      },
      role_hints: {
        quote: 'Receives proposals when no other recipient was chosen',
        invoice: 'Receives invoices when the customer has no separate billing email',
        planning: 'Receives appointment confirmations for work on site',
      },
      fields: {
        first_name: 'First name',
        last_name: 'Last name',
        email: 'Email',
        phone: 'Phone',
        job_title: 'Job title / role',
        job_title_placeholder: 'E.g. buyer, site manager, resident',
        site: 'Site',
        roles: 'Receives',
        is_primary: 'Primary contact',
        notes: 'Notes',
      },
      validation: {
        name_or_email: 'Enter a name or email address',
        invalid_email: 'Invalid email address',
      },
    },
    picker: {
      site: 'Installation address',
      site_none: 'Customer address',
      site_hint:
        'The invoice always goes to the customer; this address is shown as work address on the proposal.',
      contact: 'Attention of',
      contact_default: 'Default (proposal contact or main address)',
      updated: 'Site and contact updated',
      manage: 'Manage sites',
    },
    duplicate: {
      action: 'Duplicate to sites',
      title: 'Duplicate proposal to other sites',
      intro:
        'Each selected site gets its own proposal and deal with the same lines. The invoice later simply goes to the customer.',
      select_all: 'Select all',
      submit: 'Duplicate to {count} site(s)',
      created: '{count} proposal(s) created',
      partial: '{created} proposal(s) created, {failed} failed',
      none_available: 'There are no other sites. Add sites to the customer first.',
      current: 'current proposal',
    },
    project: {
      site: 'Site',
      contact: 'Contact on site',
      access_notes: 'Access',
      residents: 'Residents / contacts',
    },
    invoice: {
      installation_address: 'Work address',
    },
  },
  resources: {
    title: 'Equipment',
    description: 'Vans, scaffolding and tools: what you own, where it lives and when it is needed.',
    nav: 'Equipment',
    kinds: {
      vehicle: 'Van',
      equipment: 'Equipment',
      tool: 'Tool',
    },
    statuses: {
      available: 'Available',
      maintenance: 'In maintenance',
      lost: 'Lost / broken',
      retired: 'Retired',
    },
    requirement_statuses: {
      required: 'Required',
      reserved: 'Reserved',
      rented: 'Rented',
      on_site: 'On site',
      returned: 'Returned',
    },
    fulfillment: {
      own: 'Own equipment',
      rent: 'Rent',
    },
    tabs: {
      vehicles: 'Vans',
      equipment: 'Equipment',
      rentals: 'Rentals',
    },
    kpi: {
      vehicles: 'Vans',
      equipment: 'Equipment & tools',
      rented_now: 'Open rentals',
      conflicts: 'Conflicts (14 days)',
    },
    fields: {
      kind: 'Type',
      name: 'Name',
      code: 'Code',
      license_plate: 'License plate',
      category: 'Category',
      category_placeholder: 'E.g. scaffold, ladder, drill',
      category_hint: 'Work orders can ask for a category instead of a specific item.',
      quantity: 'Quantity',
      parent_vehicle: 'Default van',
      no_parent: 'Not in a van (warehouse)',
      height_mm: 'Working height (mm)',
      status: 'Status',
      status_until: 'Until',
      status_note: 'Note',
      status_note_placeholder: 'E.g. inspection, repair, last seen by',
      default_users: 'Default technicians',
      default_users_placeholder: 'Pick technicians',
      notes: 'Notes',
    },
    actions: {
      add: 'Add',
      add_vehicle: 'Add van',
      add_equipment: 'Add equipment',
      add_to_vehicle: 'Item in this van',
      add_requirement: 'Add equipment',
      derive: 'Derive from products',
      open_timeline: 'Timeline',
      mark_reserved: 'Reserve',
      mark_rented: 'Record rental',
      mark_on_site: 'On site',
      mark_returned: 'Returned',
      rental_details: 'Rental details',
      back_to_required: 'Back to required',
    },
    empty: {
      vehicles_title: 'No vans yet',
      vehicles_description: 'Add your vans to see what goes along each day.',
      equipment_title: 'No equipment yet',
      equipment_description: 'Add scaffolds, ladders and tools, loose or as van inventory.',
      rentals_title: 'No open rentals',
      rentals_description: 'Rented equipment that has not been returned shows up here.',
      no_results: 'No equipment matches these filters.',
    },
    messages: {
      load_failed: 'Could not load equipment',
      created: 'Equipment added',
      updated: 'Equipment updated',
      deleted: 'Equipment deleted',
      save_failed: 'Could not save',
      delete_failed: 'Could not delete',
      delete_title: 'Delete equipment?',
      delete_description: '"{name}" will be deleted. Inventory in this van is kept without a van.',
      delete_confirm: 'Yes, delete',
      requirement_added: 'Equipment added to work order',
      requirement_updated: 'Equipment updated',
      requirement_removed: 'Equipment removed from work order',
      requirement_failed: 'Could not update equipment',
      derived: '{count} line(s) derived from products',
      derived_none: 'No product rules found for this work order',
    },
    validation: {
      check_fields: 'Please check the fields',
      quantity_min: 'Quantity must be at least 1',
      resource_or_category: 'Pick a specific item or a category',
    },
    drawer: {
      inventory: 'Default inventory',
      no_inventory: 'Nothing in this van yet. Add equipment and pick this van as default location.',
      default_users: 'Default technicians',
      no_default_users: 'No default technicians',
      upcoming: 'Upcoming use',
      no_upcoming: 'No planned use in the next 30 days',
      in_vehicle: 'In van',
      loose: 'Loose (warehouse)',
      availability: 'Availability',
      until: 'until {date}',
    },
    requirement: {
      title: 'Equipment',
      subtitle: 'What needs to come along or be rented for this job?',
      empty: 'No equipment linked yet. Add manually or derive from the products.',
      source_product_rule: 'From product',
      source_manual: 'Manual',
      period: 'Period',
      days_before: 'Days before',
      days_after: 'Days after',
      days_hint: 'Relative to the appointment date; moves along when rescheduled.',
      mode_specific: 'Specific item',
      mode_category: 'Category',
      choose_resource: 'Pick equipment',
      choose_category: 'Pick category',
      quantity: 'Quantity',
      note: 'Note',
      fulfillment: 'Fulfilment',
      conflict: 'Conflict',
      conflict_detail: 'On {date}: {required} required, {capacity} available',
      conflict_with: 'Clashes with {count} other work order(s)',
      availability_ok: 'Available in this period',
      availability_conflict: 'Not fully available: {days} day(s) with conflict',
      availability_checking: 'Checking availability…',
      no_date: 'Work order has no appointment date yet; the period follows once scheduled.',
      remove_title: 'Remove equipment?',
      remove_description: '{label} will be removed from this work order.',
    },
    rental: {
      title: 'Rental details',
      supplier: 'Supplier',
      supplier_other: 'Other rental company',
      supplier_name: 'Rental company name',
      cost: 'Rental cost (excl. VAT)',
      reference: 'Rental reference',
      pickup_date: 'Pickup / delivery',
      return_date: 'Return date',
      create_task: 'Create a task to report the return',
      task_created: 'Return task created',
      save: 'Save rental',
      open_rentals: 'Open rentals',
      none_open: 'No open rentals',
      total_cost: 'Total rental cost',
      overdue: 'Return overdue',
      return_today: 'Return today',
      return_in_days: 'Return in {days} days',
      no_return_date: 'No return date',
      for_work_order: 'For work order',
    },
    timeline: {
      title: 'Equipment timeline',
      description: 'Who has what, when. Red = more requested than available.',
      today: 'Today',
      this_week: 'This week',
      weeks: '{count} weeks',
      no_resources: 'No equipment to show yet.',
      legend_planned: 'Planned',
      legend_rented: 'Rented',
      legend_unavailable: 'Unavailable',
      legend_conflict: 'Conflict',
      group_vehicles: 'Vans',
      group_equipment: 'Equipment',
      group_tools: 'Tools',
      category_demand: 'Demand per category',
      capacity: 'capacity {capacity}',
      load_failed: 'Could not load timeline',
    },
    planning: {
      conflict_badge: 'Equipment',
      conflict_tooltip: 'Equipment conflict: {detail}',
      conflicts_in_view: '{count} work order(s) with an equipment conflict',
    },
    load_list: {
      vehicle: 'Van',
      vehicles: 'Vans today',
      no_vehicle: 'No default van for these technician(s)',
      inventory: 'Default inventory',
      bring: 'Equipment to bring',
      nothing_to_bring: 'No extra equipment needed',
      rented: 'Rented — {supplier}',
      check_all: 'Check all',
    },
    project: {
      title: 'Equipment & rentals',
      description: 'Per work order what is needed and what the rental costs.',
      total_rental_cost: 'Total rental cost',
      no_requirements: 'No equipment linked to work orders in this project yet.',
      requirements_count: '{count} line(s)',
    },
    product: {
      title: 'Required equipment',
      description:
        'When a work order is created with this product, these lines are added automatically.',
      add_rule: 'Add rule',
      category: 'Category',
      specific: 'Specific item',
      min_height: 'From height (mm)',
      min_height_hint: 'Only apply when the installation height is at least this. Empty = always.',
      quantity: 'Quantity',
      days_before: 'Days before',
      days_after: 'Days after',
      no_rules: 'No equipment rules for this product.',
      saved: 'Equipment rules saved',
      save_failed: 'Could not save equipment rules',
    },
  },
  sales_orders: {
    amount: 'Amount',
    revisions: 'Revisions',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    cancel: 'Cancel',
    cancel_confirm: 'Yes, cancel sales order',
    cancel_keep: 'No, keep it',
    cancelled_done: 'Sales order cancelled',
    cancel_failed: 'Could not cancel the sales order',
    load_failed: 'Could not load the sales order',
    create: 'Create sales order',
    specs: 'Specifications',
    no_specs: 'No specifications on this version.',
    create_intro: 'Prices include VAT. This starts the project without a quote.',
    create_project_hint:
      'Without a quote, the project starts from a sales order. Enter the lines and the project becomes active.',
    create_failed: 'Could not create the sales order',
    line_description: 'Description',
    line_quantity: 'Quantity',
    line_price: 'Price incl. VAT',
    add_line: 'Add line',
    line_required: 'Add at least one product or line.',
    products: 'Products',
    other_lines: 'Other lines',
    add_product: 'Search and configure a product...',
    add_to_order: 'Add to sales order',
    reconfigure: 'Reconfigure',
    hide_from_customer: 'Hide from customer',
    show_to_customer: 'Show to customer',
    hidden_badge: 'Hidden',
    hidden_hint:
      'Not shown on the order confirmation or invoice; still on the work order, packing slip and purchase order.',
    line_total: 'Line total incl. VAT',
    total_incl: 'Total incl. VAT',
    pricing: 'Calculating price...',
    pricing_failed: 'Could not calculate price',
    price_server_hint:
      'Prices come from the catalog, including margin. These are the amounts that go on the sales order.',
    customer: 'Customer',
    customer_required: 'Choose a customer.',
    customer_placeholder: 'Search a customer...',
    new_project_from_proposal: 'Project from quote',
    confirm_and_start: 'Confirm and start project',
    save_configuration: 'Save configuration',
    no_products_yet: 'No products yet. Search for a product above to configure it.',
    other_lines_hint: 'For installation, call-out costs or anything not in the catalog.',
    wizard: {
      steps: 'Steps',
      step_of: 'Step {current} of {total}',
      summary: 'Summary',
      project: 'Project',
      review: 'Review',
      planning: 'Planning',
      customer_heading: 'Who is this sale for?',
      customer_hint: 'Pick an existing customer. Their address becomes the installation address.',
      products_heading: 'What is being sold?',
      products_hint:
        'Search for a product and configure it. Options that conflict with your choices are disabled.',
      project_heading: 'Project details',
      project_hint: 'Everything is optional and can be changed on the project later.',
      review_heading: 'Review and confirm',
      confirm_hint:
        'Confirming records the sales order and starts the project. Later changes go through a new version or extra work.',
      from_proposal_question: 'Is there already an accepted quote?',
      from_proposal_action: 'Start the project from the quote',
      no_customer: 'No customer selected yet',
      no_lines: 'No lines yet',
      line_count: '{count} line(s)',
    },
    reasons: {
      accept: 'Sales order confirmed',
      new_version: 'Revised',
      force_edit: 'Quote corrected',
      meerwerk: 'Extra work added',
      manual: 'Entered manually',
    },
  },

  // Customer journey (phase, who has the ball, next step)
  journey: {
    card_title: 'From deal to project',
    phase_of: 'Phase {current} of {total}',
    since_days: 'for {count} days',
    phase_skipped: 'skipped',
    phase_hints: {
      request: 'request received',
      proposal: 'create and send the quote',
      measurement: 'schedule and carry out the measurement',
      sold: 'customer has agreed',
      preparation: 'orders and work orders',
      execution: 'work on site',
      closing: 'invoicing and wrap-up',
    },
    phases: {
      request: 'Request',
      proposal: 'Quote',
      measurement: 'Measurement',
      sold: 'Sold',
      preparation: 'Preparation',
      execution: 'Execution',
      closing: 'Closing',
    },
    ball: {
      us: 'Our move',
      customer: 'Waiting on customer',
      supplier: 'Waiting on supplier',
      installer: 'With installer',
    },
    status: {
      open: 'In progress',
      completed: 'Journey completed',
      lost: 'Deal lost',
    },
    steps: {
      create_proposal: 'Create a quote',
      send_proposal: 'Send the quote',
      await_proposal_decision: 'Customer is deciding on the quote',
      follow_up_proposal: 'Follow up the quote, no response yet',
      renew_proposal: 'Quote has expired, renew it',
      create_measurement: 'Create a measurement',
      schedule_measurement: 'Schedule the measurement',
      perform_measurement: 'Carry out the measurement',
      create_definitive_proposal: 'Create the final quote',
      start_project: 'Start the project',
      start_preparation: 'Order materials or create a work order',
      place_order: 'Place the order with the supplier',
      create_work_order: 'Create a work order',
      schedule_work_order: 'Schedule the work order',
      await_delivery: 'Awaiting delivery',
      execute_work_order: 'Carry out the work',
      create_final_invoice: 'Create the final invoice',
      send_invoice: 'Send the invoice',
      await_payment: 'Customer is paying the invoice',
      send_payment_reminder: 'Payment overdue, send a reminder',
      complete_project: 'Complete the project',
    },
    proposal_steps: {
      proforma: {
        send_proposal: 'Send the preliminary quote',
        await_proposal_decision: 'Customer is deciding on the preliminary quote',
        follow_up_proposal: 'Follow up the preliminary quote, no response yet',
        renew_proposal: 'Preliminary quote has expired, renew it',
      },
      definitive: {
        send_proposal: 'Send the final quote',
        await_proposal_decision: 'Customer is deciding on the final quote',
        follow_up_proposal: 'Follow up the final quote, no response yet',
        renew_proposal: 'Final quote has expired, renew it',
      },
    },
    progress: {
      orders: '{done}/{total} purchase orders received',
      work_orders: '{done}/{total} work orders done',
    },
    open: {
      proposal: 'Open quote',
      project: 'Open project',
      order: 'Open purchase order',
      work_order: 'Open work order',
      invoice: 'Open invoice',
    },
    deal_actions: {
      create_proposal: 'Go to quotes',
      start_project: 'Create project',
    },
    board: {
      view: 'Journey',
      all: 'All',
      show_more: 'Show {count} more',
      empty_column: 'No deals in this phase',
    },
    actions: {
      title: 'Your move',
      description:
        'Next steps from running journeys, including deals with no owner. They disappear once the work is done.',
      inbox: 'For me',
      mine: 'My deals',
      unassigned: 'Unassigned',
      everyone: 'Everyone',
      mine_empty: 'Nothing assigned to you.',
      unassigned_empty: 'No deals without an owner.',
      empty: 'Nothing waiting on you. Everything is with the customer, supplier or installer.',
      show_all: 'Show all {count}',
      show_less: 'Show less',
    },
  },

  // Common

  // Statistics (reusable across dashboard components)
  stats: {
    periods: {
      last_30_days: 'Last 30 days',
      last_quarter: 'Last quarter',
      year_to_date: 'Year to date',
      all_time: 'All time',
      custom_range: 'Custom range',
      select_dates: 'Select dates',
    },
    vs_previous: 'vs previous period',
    no_data: 'No data available',
  },

  // Validation
  validation: {
    required: 'This field is required.',
    max_length: 'Maximum length is {max} characters.',
    min_length: 'Minimum length is {min} characters.',
    min_items: 'Minimum number of items is {min}.',
    email: 'Invalid email address.',
    min: 'Value must be at least {min}.',
    max: 'Value must be no more than {max}.',
    required_checkbox: 'At least one option must be selected.',
    kvk_nl: 'KVK number must be 8 digits.',
    vat_nl: 'VAT number must be in the form NL000000000B00.',
  },

  attribution: {
    title: 'Attribution',
    utm_source: 'Source',
    utm_medium: 'Medium',
    utm_campaign: 'Campaign',
    utm_content: 'Content',
    utm_term: 'Term',
    landing_page: 'Landing page',
    referrer: 'Referrer',
    gclid: 'Google click ID',
    fbclid: 'Meta click ID',
    ttclid: 'TikTok click ID',
    first_touch_at: 'First touch',
  },

  // Navigation & Layout
  navigation: {
    home: 'Home',
    dashboard: 'Dashboard',
    forms: 'All funnels',
    integrations: 'Integrations',
    analytics: 'Analytics',
    settings: 'Settings',
    support: 'Support',
    collapse_sidebar: 'Collapse',
    expand_sidebar: 'Expand',
    logout: 'Logout',
    main_menu: 'Main Menu',
    tools: 'Tools',
    resources: 'Resources',
    automations: 'Automations',
    documentation: 'Documentation',
    crm: 'CRM',
    stats: 'Stats',
    products: 'Products',
    catalog: 'Catalog',
    discounts: 'Discounts',
    account: 'Account',
    sign_out: 'Sign out',
    admin: 'Admin',
    member: 'Member',
    // Sidebar sections
    builder: 'Builder',
    leads: 'Leads',
    analysis: 'Analysis',
    group_crm: 'CRM',
    group_sales: 'Sales',
    group_operations: 'Operations',
    group_finance: 'Finance',
    group_setup: 'Setup',
    // Navigation items
    all_funnels: 'All funnels',
    proposals: 'Proposals',
    appointments: 'Appointments',
    requests: 'Requests',
    more: 'More',
    switch_organization: 'Switch organization',
    // Organization switcher
    choose_organization: 'Choose your organization',
    choose_organization_description: 'Choose which organization you would like to switch to',
    search_organizations_placeholder: 'Search an organization...',
    organizations_count: '{visible} of {total} organizations',
    current_organization: 'Current organization',
    no_organizations_found: 'No organizations found',
    add_another_organization: 'Add another organization',
    add_new_organization: 'Add a new organization',
    add_new_organization_description: 'Add a new organization to your account',
    operations: 'Operations',
    projects: 'Projects',
    orders: 'Purchase orders',
    jobs: 'Jobs', // Deprecated, kept for backward compatibility
    planning: 'Planning',
    service: 'Service',
    deals: 'Deals',
    invoices: 'Invoices',
    submissions: 'Requests',
    tasks: 'Tasks',
    my_account: 'My account',
    owner: 'Owner',
    anonymous_mode: 'Anonymous mode',
    anonymous_mode_on: 'Fictional names',
    anonymous_mode_off: 'For screen sharing',
  },

  // Telephony integration: callback list
  callbacks: {
    title: 'Callback list',
    description: 'Open callback requests from your phone system.',
    filter_open: 'Open',
    filter_completed: 'Completed',
    filter_all: 'All',
    empty_title: 'No open callback requests',
    empty_description: 'New callback requests will appear here as soon as they come in.',
    today: 'Today',
    tomorrow: 'Tomorrow',
    no_due_date: 'No due date',
    unknown_lead: 'Unknown lead',
    unassigned: 'Unassigned',
    from_telephony: 'Phone system',
    from_telephony_tooltip: 'Created by the telephony integration',
    action_call: 'Call',
    action_complete: 'Complete',
    action_reopen: 'Reopen',
    action_open_lead: 'Open lead',
    completed_toast: 'Callback completed',
    reopened_toast: 'Callback reopened',
    action_failed: 'Action failed',
    load_failed: 'Failed to load callbacks',
  },

  // Telephony integration: call activity rendering
  call_activity: {
    inbound_call: 'Inbound call',
    outbound_call: 'Outbound call',
    call: 'Call',
    summary: 'Summary',
    action_items: 'Action items',
    show_transcript: 'Show transcript',
    hide_transcript: 'Hide transcript',
    listen_recording: 'Listen to recording',
    via_phone_system: 'via phone system',
  },

  // Dashboard
  // Home (summary / day starter)
  home: {
    load_failed: 'Failed to load home overview',
    today: 'Today',
    tomorrow: 'Tomorrow',
    no_due_date: 'No due date',
    just_now: 'Just now',
    minutes_ago: '{n}m ago',
    hours_ago: '{n}h ago',
    days_ago: '{n}d ago',
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
      night: 'Good night',
    },
    tasks: {
      title: 'My tasks',
      view_all: 'All tasks',
      empty_title: 'No open tasks',
      empty_description: "You don't have any tasks waiting for you.",
    },
    requests: {
      title: 'New requests',
      view_all: 'All requests',
      empty_title: 'No new requests',
      empty_description: 'New requests from your funnels will appear here.',
      untitled: 'Request',
    },
    proposals: {
      title: 'Open proposals',
      view_all: 'All proposals',
      empty_title: 'No open proposals',
      empty_description: 'Sent and draft proposals will appear here.',
      untitled: 'Proposal',
    },
    drafts: {
      title: 'Proposals to send',
      view_all: 'All proposals',
      empty_title: 'No draft proposals',
      empty_description: 'Proposals that still need to be sent will appear here.',
      untitled: 'Proposal',
    },
    appointments: {
      title: 'Upcoming appointments',
      view_all: 'All appointments',
      empty_title: 'No upcoming appointments',
      empty_description: 'Scheduled appointments for this week will appear here.',
      untitled: 'Appointment',
    },
    chat: {
      placeholder: 'Ask anything about your workspace...',
      send: 'Send',
      send_failed: 'Failed to send message',
      new_conversation: 'New conversation',
      show_overview: 'Show overview',
      hide_overview: 'Hide overview',
      spike_notice: 'AI assistant · actions always require your confirmation.',
      suggestion_summary: 'Give me a summary of today',
      suggestion_invoices: 'How much have I invoiced this month?',
      suggestion_proposals: 'Which proposals are open >5 days?',
      suggestion_today: "What's on my schedule today?",
      action: {
        confirm: 'Confirm',
        dismiss: 'Cancel',
        confirmed: 'Done',
        expired: 'This action expired — ask again',
        dismissed: 'Cancelled',
        failed: 'Action failed',
        confirmed_toast: 'Action completed',
        confirm_failed: 'Action could not be completed',
        expired_toast: 'This action expired — ask the assistant again',
        tools: {
          create_task: 'Create task',
          complete_task: 'Complete task',
          move_deal: 'Move deal',
          send_invoice: 'Send invoice',
          generic: 'Suggested action',
        },
      },
      tool_result: {
        empty: 'No results',
        unknown: 'Result',
        truncated:
          'The full result was too large to display here — try asking for a more specific overview.',
        show_all: 'Show all ({n} more)',
        stats_range: 'Period: {from} to {to}',
        invoices: {
          label: 'Outstanding invoices',
          empty: 'No outstanding invoices — all clear!',
          view_all: 'All invoices',
        },
        tasks: {
          label: 'Open tasks',
          empty: 'No open tasks',
          view_all: 'All tasks',
        },
        overdue_tasks: {
          label: 'Overdue tasks',
        },
        submissions: {
          label: 'Recent requests',
          empty: 'No new requests',
          view_all: 'All requests',
        },
        proposals: {
          label: 'Open proposals',
          empty: 'No open proposals',
          view_all: 'All proposals',
        },
        appointments: {
          label: 'Upcoming appointments',
          empty: 'No upcoming appointments',
          view_all: 'All appointments',
        },
        leads: {
          label: 'Leads',
          empty: 'No leads found',
          view_all: 'Open CRM',
        },
        deals: {
          label: 'Deals',
          empty: 'No deals found',
          view_all: 'All deals',
        },
        invoice_stats: {
          label: 'Billing',
          invoiced: 'Invoiced',
          paid: 'Received',
          outstanding: 'Outstanding',
          open: 'open',
        },
        deal_stats: {
          label: 'Pipeline',
          total: 'Total',
          won: 'Won',
          pipeline: 'Pipeline',
          open: 'open',
        },
      },
    },
  },

  tasks_view: {
    title: 'Tasks',
    description: 'All tasks in one place, with deal or project context and deadlines at a glance.',
    search_label: 'Search',
    search_placeholder: 'Search by task name...',
    status_label: 'Status',
    status_all: 'All statuses',
    status_pending: 'Open',
    status_in_progress: 'In progress',
    status_completed: 'Completed',
    status_cancelled: 'Cancelled',
    assigned_to_label: 'Assigned to',
    assigned_to_all: 'Everyone',
    select_all: 'Select all',
    reset_filters: 'Clear filters',
    load_failed: 'Failed to load tasks',
    empty_title: 'No tasks found',
    empty_description: 'Tasks will appear here once they are created.',
    empty_context_title: 'No open tasks yet',
    empty_context_description: 'Create a task for this project.',
    no_due_date: 'No due date',
    unassigned: 'Unassigned',
    assign_success: 'Task assigned',
    assign_failed: 'Failed to assign task',
    create_task: 'Task',
    description_placeholder: 'Short note (optional)',
    help_deal: 'This task belongs to the deal (sales).',
    help_project: 'This task belongs to the project.',
    open_project_tasks: '{count} open tasks on the project',
    home_deal: 'Deal',
    home_project: 'Project',
    home_work_order: 'Work order',
    home_general: 'General',
    home_label: 'Context',
    view_deal: 'View deal',
    view_work_order: 'View work order',
    view_lead: 'View contact',
    bulk_selected: '{count} selected',
    bulk_action_label: 'Bulk action',
    bulk_action_placeholder: 'Choose action',
    bulk_complete: 'Complete',
    bulk_complete_success: 'Tasks completed',
    bulk_assign: 'Assign',
    bulk_assign_placeholder: 'Assign to...',
    bulk_assign_success: 'Tasks assigned',
    bulk_button_complete: 'Complete {count}',
    bulk_button_assign: 'Assign {count}',
    bulk_button_delete: 'Delete {count}',
    bulk_delete_success: 'Tasks deleted',
    bulk_delete_confirm_title: 'Delete tasks?',
    bulk_delete_confirm_description:
      'You are about to delete {count} selected tasks. This cannot be undone.',
    bulk_action_failed: 'Bulk action failed',
    fields: {
      name: 'Name',
      description: 'Description',
      type: 'Type',
      due_date: 'Due date',
      due_time: 'Time',
      assigned_to: 'Assigned to',
      priority: 'Priority',
    },
  },

  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome back',
    overview: 'Overview',
    recent_forms: 'Recent Forms',
    recent_submissions: 'Recent requests',
    quick_actions: 'Quick Actions',
    create_form: 'Create Form',
    view_analytics: 'View Analytics',
    no_forms: 'No forms created yet',
    no_submissions: 'No requests yet',
    insights_over_time: 'Insights over time',
    stats: {
      total_forms: 'Total Forms',
      total_submissions: 'Total requests',
      conversion_rate: 'Conversion Rate',
      avg_completion_time: 'Avg. Completion Time',
    },
  },

  // Forms
  forms: {
    title: 'Forms',
    create: 'Create Form',
    edit: 'Edit Form',
    duplicate: 'Duplicate',
    delete: 'Delete',
    publish: 'Publish',
    unpublish: 'Unpublish',
    preview: 'Preview',
    settings: 'Settings',
    submissions: 'Submissions',
    analytics: 'Analytics',
    status: {
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived',
    },
    empty_state: {
      title: 'No forms yet',
      description: 'Create your first form to get started',
      action: 'Create Form',
    },
  },

  // Form Card
  form_card: {
    edit_funnel: 'Edit funnel',
    open_funnel_title: 'Open funnel',
    open_funnel_description: 'How do you want to open this funnel?',
    open_normal: 'Open normal funnel',
    open_normal_description: 'Open the funnel as your customers see it',
    open_extended: 'Open extended funnel',
    open_extended_description: 'Open the funnel in extended mode with internal options and prices',
    type_configurator: 'Configurator',
    type_funnel: 'Funnel',
    copy_share_link: 'Copy share link',
    delete_funnel: 'Delete funnel',
    delete_flow_title: 'Delete flow',
    delete_flow_description:
      'Are you sure you want to delete this flow? This action cannot be undone.',
    delete_blocked_by_bookings:
      'This funnel cannot be deleted because it still has appointments. Delete or cancel the appointments first.',
    share_link_copied: 'Share link has been copied to clipboard',
  },

  // CRM
  crm: {
    title: 'CRM',
    description: 'View and manage all your leads in a table or pipeline view',
    table_view: 'Table View',
    pipeline_view: 'Pipeline View',
    lead_details: 'Lead Details',
    lead_status_updated: 'Lead status updated',
    lead_updated: 'Lead updated successfully',
    no_name_entered: 'No name entered',
    search_placeholder: 'Search by name, address, postal code, city, phone, email...',
    statuses: {
      new: 'New',
      contacted: 'Contacted',
      introduction: 'Introduction',
      qualified: 'Qualified',
      converted: 'Converted',
      lost: 'Lost',
    },
    create_lead: {
      button: 'Add Lead',
      title: 'Create new lead',
      edit_title: 'Edit customer details',
      description: 'Add a new lead to your CRM.',
      contact_info: 'Contact Information',
      name_placeholder: 'e.g. John Doe',
      email_placeholder: 'E-mail address',
      phone_placeholder: 'e.g. +1 234 567 890',
      address_placeholder: 'Street, number, postal code, city',
      save: 'Create Lead',
      save_edit: 'Save changes',
      success: 'Lead created successfully',
      update_success: 'Customer details updated',
      already_exists: 'Lead already exists',
      restored_from_archive: 'Lead restored from archive',
      error: 'An error occurred while creating the lead',
      update_error: 'An error occurred while updating the lead',
      customer_type_label: 'Customer type',
      customer_type_person_title: 'Individual',
      customer_type_person_description: 'A person without a business.',
      customer_type_company_title: 'Business',
      customer_type_company_description: 'A company or organisation with a registration number.',
      company_section: 'Company details',
      company_name: 'Company name',
      company_name_placeholder: 'e.g. ACME Ltd.',
      kvk_number: 'Registration number (KVK)',
      kvk_number_placeholder: '12345678',
      kvk_number_help: 'NL: 8 digits, found on kvk.nl.',
      vat_number: 'VAT number',
      vat_number_placeholder: 'NL000000000B00',
      vat_number_help: 'Optional. Required for VAT reverse charge within the EU.',
      legal_form: 'Legal form',
      legal_form_placeholder: 'Select legal form',
      legal_form_options: {
        bv: 'BV',
        nv: 'NV',
        vof: 'VOF',
        eenmanszaak: 'Sole proprietorship',
        stichting: 'Foundation',
        vereniging: 'Association',
        cv: 'CV',
        maatschap: 'Partnership',
        other: 'Other',
      },
      vat_reverse_charge: 'Reverse charge VAT (B2B EU outside NL)',
      vat_reverse_charge_help:
        'Tick for business EU customers outside the Netherlands where VAT is reverse-charged.',
      billing_section: 'Different billing details',
      billing_section_help:
        'Optional — use this when invoices should go to a different address or email than the contact details.',
      billing_email: 'Billing email',
      billing_email_placeholder: "billing{'@'}company.com",
      billing_address: 'Billing address',
      show_billing: 'Add different billing details',
      hide_billing: 'Hide different billing details',
    },
  },

  // Quotes
  quotes: {
    title: 'Quotes',
    description: 'View and manage all your quotes and proposals',
  },

  automations_page: {
    title: 'Automations',
    description: 'Automate follow-ups, tasks and integrations',
    add: 'New automation',
    add_group: 'Add group',
    empty_title: 'No automations yet',
    empty_description: 'Create your first automation to start automating workflows.',
    ungrouped: 'Ungrouped',
    columns: {
      name: 'Name',
      updated: 'Updated',
      runs: 'Runs',
      succeeded: 'Succeeded',
      failed: 'Failed',
      status: 'Status',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      draft: 'Draft',
    },
    group_name: 'Group name',
    group_placeholder: 'e.g. Quotes, Project, Aftercare',
    group_add: 'Add group',
    group_edit: 'Edit group',
    group_save: 'Save changes',
    group_delete_title: 'Delete group?',
    group_delete_description:
      'Automations in "{name}" will become ungrouped. This deletes the group, not the automations.',
    drop_hint: 'Drop automations here',
    new_in_group: 'New automation',
    toggle_on: 'Turn on',
    toggle_off: 'Turn off',
    delete: 'Delete',
    delete_title: 'Delete automation?',
    delete_description: 'Are you sure you want to delete "{name}"? This cannot be undone.',
    deleted: 'Automation deleted',
    delete_failed: 'Could not delete automation',
    toggled_on: 'Automation activated',
    toggled_off: 'Automation deactivated',
    toggle_failed: 'Could not update automation status',
    group_created: 'Group created',
    group_updated: 'Group updated',
    group_deleted: 'Group deleted',
    group_save_failed: 'Could not save group',
    group_delete_failed: 'Could not delete group',
    group_name_taken: 'A group with this name already exists',
    reorder_failed: 'Could not save order',
    runs: 'Runs',
    run_status: {
      pending: 'Queued',
      in_progress: 'Running',
      completed: 'Succeeded',
      failed: 'Failed',
      scheduled: 'Scheduled',
    },
    no_runs: 'This automation has not run yet.',
    run_error: 'Error',
    run_deal: 'Deal',
    run_proposal: 'Proposal',
    run_submission: 'Submission',
    run_steps: 'Steps',
    run_selected: 'Selected run',
    run_clear: 'Clear selection',
    save: 'Save',
    active: 'Active',
    back: 'Back',
  },

  // Deals
  deals: {
    title: 'Deals',
    description: 'Manage your sales pipeline and deals',
    untitled: 'Untitled deal',
    add_deal: 'Add deal',
    export: 'Export',
    export_success: 'Export started, the file is being downloaded',
    export_failed: 'Export failed',
    create_deal: 'Create deal',
    select_pipeline: 'Select pipeline',
    search_placeholder: 'Search by name, amount...',
    filter_owner_all: 'All owners',
    filter_tags: 'Tags',
    filter_by_tags: 'Filter by tags',
    filter_no_tags: 'No tags available',
    filter_reset: 'Clear',
    filter_clear_all: 'Clear filters',
    list_view: 'List',
    kanban_view: 'Board',
    statistics: 'Statistics',
    open_statistics: 'Open statistics',
    filter_owner: 'Owner',
    activity_just_now: 'just now',
    activity_minutes_ago: '{count}m ago',
    activity_hours_ago: '{count}h ago',
    activity_days_ago: '{count}d ago',
    age_minutes: '{count}m',
    age_hours: '{count}h',
    age_days: '{count}d',
    status_new_in_stage: 'New in stage',
    status_inactive: 'Inactive',
    status_proposal_viewed: 'Quote viewed',
    status_task_overdue: 'Task overdue',
    status_new_note: 'New note',
    status_more_signals: '{count} more alerts',
    assign_owner: 'Assign owner',
    unassigned: 'Unassigned',
    action_edit: 'Edit',
    action_select: 'Select',
    stage_actions: 'Stage actions',
    stage_deal_count: '{count} deals',
    stage_add_deal: 'Add deal',
    total_deals: 'Deals',
    total_value: 'Total value',
    weighted_value: 'Weighted value',
    selected_count: '{count} selected',
    bulk_move: 'Move',
    bulk_move_to: 'Move to',
    bulk_move_success: 'Deals moved',
    bulk_move_failed: 'Move failed',
    bulk_archive: 'Archive',
    bulk_archive_success: 'Deals archived',
    bulk_archive_failed: 'Archive failed',
    archive_column: 'Archive',
    archive_expand: 'Open archive',
    archive_collapse: 'Collapse archive',
    archive_empty: 'No archived deals',
    archive_drop: 'Drop a deal here to archive it',
    no_pipelines_title: 'No pipelines',
    no_pipelines_description: 'Create a pipeline first in settings',
    create_pipeline: 'Create pipeline',
    no_deals_in_stage: 'No deals in this stage',
    no_deals_filtered_title: 'No deals match your filters',
    no_deals_filtered_description: 'Try adjusting or clearing the filters to see more deals.',
    in_stage: 'in stage',
    // Lead deals
    empty_state_lead: {
      title: 'No deals yet',
      description: 'Create a deal to track progress with this lead.',
    },
    show_more_activities: '+{count} more activities',
    deal_details: 'Deal details',
    stage_updated: 'Deal moved',
    stage_update_failed: 'Move failed',
    deal_created: 'Deal created',
    deal_updated: 'Deal updated',
    update_failed: 'Update failed',
    deal_deleted: 'Deal deleted',
    delete_failed: 'Delete failed',
    delete_blocked_title: 'Deal cannot be deleted',
    delete_blocked_has_projects:
      'This deal has a linked project. A deal with a project cannot be deleted. Delete the project first, or mark the deal as lost if it is not going ahead.',
    delete_blocked_has_project_named:
      'This deal is linked to project {project}. A deal with a project cannot be deleted. Delete the project first, or mark the deal as lost if it is not going ahead.',
    delete_confirm: 'Are you sure you want to delete this deal?',
    no_deal_selected: 'No deal selected',
    select_deal_to_view: 'Select a deal to view details',
    mark_won: 'Won',
    mark_lost: 'Lost',
    reopen: 'Reopen',
    create_project: 'Create project',
    deal_won: 'Deal won',
    deal_lost: 'Deal lost',
    no_reason: 'No reason given',
    marked_as_won: 'Deal marked as won',
    marked_as_lost: 'Deal marked as lost',
    mark_won_failed: 'Mark as won failed',
    mark_lost_failed: 'Mark as lost failed',
    mark_won_confirm_title: 'Mark deal as won',
    mark_won_confirm_proposals:
      'There are {count} proposal(s) that are not yet accepted. Do you also want to mark them as accepted?',
    mark_won_accept_proposals: 'Yes, accept and mark as won',
    mark_won_skip_proposals: 'No, just mark deal as won',
    enter_lost_reason: 'Enter a reason for losing this deal (optional)',
    deal_reopened: 'Deal reopened',
    reopen_failed: 'Reopen failed',
    won: 'Won',
    lost: 'Lost',
    deal_value: 'Deal value',
    contact: 'Contact',
    lead: 'Lead',
    owner: 'Owner',
    expected_close_date: 'Expected close',
    pipeline: 'Pipeline',
    stage: 'Stage',
    select_stage: 'Select stage',
    select_contact: 'Select contact',
    select_lead: 'Select lead',
    contact_help: 'Optional - link an existing lead',
    lead_help: 'Every deal must be linked to a lead',
    select_owner: 'Select owner',
    title: 'Title',
    title_placeholder: 'e.g. Solar Panels Johnson Family',
    title_required: 'Title is required',
    lead_required: 'Lead is required',
    pipeline_required: 'Pipeline is required',
    stage_required: 'Stage is required',
    value: 'Value',
    value_placeholder: '0',
    internal_notes: 'Internal notes',
    internal_notes_placeholder: 'Notes for internal use...',
    danger_zone: 'Danger zone',
    delete_deal: 'Delete deal',
    tabs: {
      details: 'Details',
      submissions: 'Requests',
      proposals: 'Proposals',
      documents: 'Documents',
      activities: 'Activities',
      activity: 'Activity',
      tasks: 'Tasks',
      form_links: 'New proposal',
      project: 'Project',
      settings: 'Settings',
    },
    project_cancelled_with_deal: 'The project was cancelled because the deal was lost.',
    settings: {
      general: 'General',
      notes: 'Notes',
      deal_details: 'Deal details',
      deal_name: 'Deal name',
      source_locked: 'Filled in automatically by the funnel',
      merge_description: 'For duplicate requests from the same customer',
      delete_description: 'Quotes and activity on this deal go with it',
    },
    tags: {
      label: 'Tags',
      add: 'Tag',
      add_first: 'Add tag',
      search_placeholder: 'Search tags...',
      no_tags: 'No tags yet',
      create: 'Create',
      create_placeholder: 'New tag...',
      create_failed: 'Failed to create tag',
      update_failed: 'Failed to update tags',
    },
    source_placeholder: 'e.g. Website, LinkedIn, Referral...',
    danger_zone_description: 'Deleting this deal is permanent and cannot be undone.',
    no_submissions: 'No requests for this deal',
    no_proposals: 'No proposals for this deal',
    form_name: 'Form',
    contact_name: 'Contact',
    total_price: 'Total price',
    created_at: 'Created at',
    // Activities
    activities: 'Activities',
    log_activity: 'Log activity',
    no_activities: 'No activities',
    activity_type: 'Type',
    activity_subject: 'Subject',
    activity_subject_placeholder: 'e.g. Initial phone call',
    activity_description: 'Description',
    activity_description_placeholder: 'Optional details...',
    activity_outcome: 'Outcome',
    save_activity: 'Save',
    activity_logged: 'Activity logged',
    activity_log_failed: 'Log failed',
    activity_deleted: 'Activity deleted',
    activity_delete_failed: 'Delete failed',
    delete_activity_confirm: 'Are you sure you want to delete this activity?',
    auto_generated: 'Auto-generated',
    mail_inbox: 'Customer mail',
    mail_compose: 'Send email',
    mail_reply: 'Reply',
    mail_view: 'View',
    mail_send: 'Send',
    mail_sent: 'Email sent',
    mail_send_failed: 'Failed to send email',
    mail_subject: 'Subject',
    mail_to: 'To',
    mail_body: 'Message',
    mail_no_subject: '(no subject)',
    mail_bounced: 'Not delivered',
    mail_thread_empty: 'No messages in this conversation',
    mail_thread_empty_description: 'This email conversation could not be loaded.',
    mail_thread_no_body: '(no text)',
    mail_photo: 'Photo',
    mail_attachment: 'Attachment',
    mail_thread_load_failed: 'Email could not be loaded',
    mail_inbox_needs_reply: 'Needs reply',
    mail_inbox_unmatched: 'Unmatched',
    mail_inbox_empty: 'No emails',
    mail_inbox_empty_needs_reply: 'No customer emails waiting for a reply.',
    mail_inbox_empty_unmatched: 'All inbound emails are linked to a deal.',
    mail_inbox_load_failed: 'Inbox could not be loaded',
    mail_unknown_sender: 'Unknown sender',
    mail_search_deal: 'Search deal to link…',
    mail_linked: 'Email linked to deal',
    mail_link_failed: 'Failed to link email',
    activity_types: {
      call: 'Call',
      email: 'Email',
      whatsapp: 'WhatsApp',
      note: 'Note',
      meeting: 'Meeting',
    },
    outcomes: {
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
      no_answer: 'No answer',
    },
    system: 'System',
    add_note_placeholder: 'Add a note or log an activity...',
    quick_types: {
      note: 'Note',
      call: 'Called',
      email: 'Email',
      meeting: 'Meeting',
    },
    timeline: {
      stage_to: 'To {stage}',
      stage_from: 'from {stage}',
      stage_placed: 'Placed in stage',
      created_via: 'via {source}',
      view_submission: 'View submission',
      just_now: 'Just now',
      minutes_ago: '{count} min ago',
      one_hour_ago: '1 hour ago',
      hours_ago: '{count} hours ago',
      one_day_ago: '1 day ago',
      days_ago: '{count} days ago',
      source: {
        configurator: 'Configurator',
        form_submission: 'Form',
        manual: 'manual',
        import: 'import',
        merge: 'merge',
      },
    },
    // Form Links / Configurators
    form_links: 'Form links',
    form_links_description:
      'Generate unique links to forms that are automatically linked to this deal',
    create_form_link: 'Generate link',
    no_form_links: 'No form links',
    select_form: 'Select form',
    select_form_placeholder: 'Choose a form...',
    prefill_contact_data: 'Prefill contact data',
    prefill_contact_help: 'Automatically fills in known contact information',
    generate_link: 'Generate link',
    link_generated: 'Link generated',
    link_generated_description: 'Copy the link and share it with your customer:',
    open_link: 'Open',
    prefill_enabled: 'Prefill',
    times_used: 'Used {count}x',
    last_used: 'Last used: {time}',
    expires: 'Expires: {date}',
    create_link_failed: 'Generate link failed',
    delete_link_confirm: 'Are you sure you want to delete this link?',
    link_deleted: 'Link deleted',
    delete_link_failed: 'Delete failed',
    // Configurators
    create_proposal: 'Create proposal',
    create_proposal_description: 'Open a configurator to create a new proposal for this deal',
    no_configurators: 'No configurators available',
    configurator: 'Configurator',
    open_configurator: 'Open',
    // New proposal button
    new_proposal: 'New proposal',
    no_configurator_forms_hint: 'Create a configurator form first',
    create_proposal_hint: 'Create a new proposal using the button above',
    proposal_locked_title: 'This deal already has an accepted proposal',
    proposal_locked_description:
      'Create a new deal for a new request, so the revenue of both orders is preserved. Want to replace the existing proposal? Withdraw it first.',
    proposal_locked_create_deal: 'Create new deal',
    proposal_count_one: '1 quote on this deal',
    proposal_count_other: '{count} quotes on this deal',
    proposal_hints: {
      draft: 'This quote is still a draft. Send it to the customer once it is right.',
      sent: 'The quote is with the customer. Follow up if it stays quiet.',
      accepted: 'The quote has been accepted. Continue in the Project tab.',
      rejected: 'No quote is open anymore. Create a new quote or mark the deal as lost.',
      proforma_draft:
        'This pro forma is still a draft. Send it to the customer; once accepted you schedule the measurement and create the final quote.',
      proforma_sent:
        'The pro forma is with the customer. As soon as they accept, schedule the measurement.',
      proforma_accepted:
        'The pro forma is accepted. Schedule the measurement and then create the final quote.',
      definitive_draft:
        'The final quote is still a draft. Send it to the customer; it replaces the pro forma.',
      definitive_sent: 'The final quote is with the customer. Follow up if it stays quiet.',
    },
    // Tasks
    new_task: 'New task',
    task_placeholder: 'What needs to be done?',
    no_tasks: 'No tasks',
    task_created: 'Task created',
    task_create_failed: 'Failed to create task',
    task_completed: 'Task completed',
    task_reopened: 'Task reopened',
    task_update_failed: 'Failed to update task',
    completed_tasks: 'Completed tasks',
    overdue_tasks: 'Overdue',
    today_tasks: 'Today',
    upcoming_tasks: 'Upcoming',
    completed_by: 'Completed by',
    priority_high: 'High',
    priority_medium: 'Medium',
    priority_low: 'Low',
    task_type_general: 'General',
    task_type_callback: 'Callback',
    task_type_follow_up: 'Follow-up',
    task_ui: {
      quick_add_placeholder: 'New task, e.g. call back about the proposal',
      add: 'Add',
      me: 'Me',
      today: 'Today',
      tomorrow: 'Tomorrow',
      in_three_days: 'In 3 days',
      next_week: 'Next week',
      pick_date: 'Pick a date',
      more_options: 'More options',
      empty_title: 'No tasks for this deal yet',
      empty_description:
        'Plan a follow-up so the deal does not stall. A task also shows up on the home screen of the colleague you assign it to.',
      quick_callback: 'Call back tomorrow',
      quick_callback_title: 'Call back',
      quick_follow_up: 'Follow up proposal in 3 days',
      quick_follow_up_title: 'Follow up proposal',
      created_by: 'Created by {name}',
      created_at: 'Created on {date}',
      unknown_user: 'unknown',
      open_customer: 'Open customer card',
      save: 'Save',
      saved: 'Task updated',
      no_description: 'No additional information',
      description_placeholder: 'Additional information, agreements or context…',
    },
    customer_history: {
      tab: 'Customer',
      open_card: 'Open customer card',
      customer_since: 'Customer since {date}',
      requests: 'Requests',
      no_requests: 'No requests from this customer yet',
      deals: 'Deals for this customer',
      no_other_deals: 'No other deals for this customer',
      current_deal: 'This deal',
      no_customer: 'This deal is not linked to a customer.',
      unknown_form: 'Unknown form',
      load_failed: 'Failed to load customer history',
    },
    // Drawer
    no_industry: 'No industry',
    untitled_deal: 'Untitled deal',
    expected_date: 'Expected',
    in_pipeline: 'In pipeline',
    days: 'days',
    source: 'Source',
    unknown_source: 'Unknown source',
    call: 'Call',
    email: 'Email',
    schedule: 'Schedule',
    schedule_coming_soon: 'Scheduling feature coming soon',
    note: 'Note',
    task: 'Task',
    assign: 'Assign',
    days_in_stage: '{count}d in stage',
    previous_deal: 'Previous deal',
    next_deal: 'Next deal',
    more_actions: 'More actions',
    move_to_next_stage: 'To {stage}',
    move_to_stage: 'Move to stage',
    choose_stage: 'Choose a stage',
    current: 'current',
    added_to_favorites: 'Added to favorites',
    removed_from_favorites: 'Removed from favorites',
    favorite_failed: 'Failed to update favorite',
    // Merge
    merge_deals: 'Merge deals',
    merge_deals_description:
      'Select deals to merge into this deal. All activities, tasks, requests and proposals will be transferred.',
    search_deals_placeholder: 'Search by name, email or amount...',
    no_deals_found: 'No deals found',
    selected_deals: '{count} deal(s) selected',
    merge: 'Merge',
    merge_confirm_title: 'Merge deals?',
    merge_confirm_description:
      'The selected deals will be merged into this deal. This cannot be undone.',
    merge_success: 'Deals merged successfully',
    merge_failed: 'Merge failed',
    // Experimental banner
    experimental_banner_title: 'Experimental feature',
    experimental_banner_message:
      'This feature is new and still in development. We are working hard to improve it!',
  },

  // Settings - Pipelines
  pipelines: {
    title: 'Pipelines',
    description: 'Manage your sales pipelines and stages',
    create_pipeline: 'Create pipeline',
    create_pipeline_description: 'Create a new sales pipeline with custom stages',
    edit_pipeline: 'Edit pipeline',
    edit_pipeline_description: 'Update pipeline name and description',
    delete_pipeline: 'Delete pipeline',
    name: 'Name',
    name_placeholder: 'e.g. Default Pipeline',
    description_label: 'Description',
    description_placeholder: 'Optional description...',
    default: 'Default',
    set_as_default: 'Set as default',
    stages: 'stages',
    pipeline_created: 'Pipeline created',
    pipeline_updated: 'Pipeline updated',
    pipeline_deleted: 'Pipeline deleted',
    save_failed: 'Save failed',
    default_set: 'Default pipeline set',
    default_failed: 'Set as default failed',
    delete_confirm: 'Are you sure you want to delete this pipeline?',
    delete_failed: 'Delete failed',
    add_stage: 'Add stage',
    add_stage_description: 'Create a new stage in this pipeline',
    edit_stage: 'Edit stage',
    edit_stage_description: 'Update stage settings and properties',
    delete_stage: 'Delete stage',
    stage_name: 'Stage name',
    stage_name_placeholder: 'e.g. Negotiation',
    color: 'Color',
    probability: 'Probability',
    auto_trigger: 'Auto trigger',
    no_auto_trigger: 'No auto trigger',
    trigger_proposal_sent: 'Proposal sent',
    trigger_proforma_sent: 'Preliminary quote sent',
    trigger_proforma_accepted: 'Preliminary quote accepted',
    trigger_proposal_accepted: 'Proposal accepted',
    trigger_proposal_rejected: 'Proposal rejected',
    auto_trigger_help: 'Deal will automatically move to this stage on this event',
    is_won_stage: 'This is the "Won" stage',
    is_lost_stage: 'This is the "Lost" stage',
    won_stage: 'Won',
    lost_stage: 'Lost',
    stage_created: 'Stage created',
    stage_updated: 'Stage updated',
    stage_deleted: 'Stage deleted',
    stage_save_failed: 'Save failed',
    delete_stage_confirm: 'Are you sure you want to delete this stage?',
    stage_delete_failed: 'Delete failed',
    stages_reordered: 'Stages reordered',
    reorder_failed: 'Failed to reorder stages',
  },

  // Discounts (period campaigns)
  discounts: {
    title: 'Discounts',
    description: 'Set temporary discounts on products or categories.',
    overview: 'Discounts overview',
    create: 'Create discount',
    create_title: 'New discount',
    edit_title: 'Edit discount',
    search_placeholder: 'Search discounts...',
    empty_title: 'No discounts yet',
    empty_description: 'Create a period discount for products, categories, or everything.',
    load_failed: 'Failed to load discounts',
    created: 'Discount created',
    updated: 'Discount updated',
    deleted: 'Discount deleted',
    delete_failed: 'Failed to delete discount',
    delete_title: 'Delete discount?',
    delete_description: 'Are you sure you want to delete “{title}”?',
    columns: {
      title: 'Title',
      status: 'Status',
      method: 'Method',
      scope: 'Eligibility',
      type: 'Type',
      period: 'Period',
      uses: 'Used',
    },
    status: {
      active: 'Active',
      scheduled: 'Scheduled',
      expired: 'Expired',
      disabled: 'Paused',
    },
    method: {
      automatic: 'Automatic',
      code: 'Discount code',
    },
    type: {
      percentage: 'Percentage',
      fixed: 'Fixed amount',
    },
    scope: {
      all: 'All products',
      categories: '{n} categories',
      products: '{n} products',
    },
    period: {
      open: 'No end date',
      from: 'From {date}',
      until: 'Until {date}',
    },
    summary: {
      percentage: '{value}% off',
      percentage_capped: '{value}% off (max €{max})',
      fixed: '€{value} off',
    },
    form: {
      title: 'Title',
      title_placeholder: 'e.g. Summer sale 15%',
      method: 'Method',
      method_automatic: 'Automatic',
      method_code: 'Discount code',
      code: 'Discount code',
      code_placeholder: 'e.g. SUMMER10',
      code_hint: 'Customers enter this code on the quote. Letters, numbers and hyphens.',
      type: 'Type',
      type_percentage: 'Percentage',
      type_fixed: 'Fixed amount (€)',
      value_percentage: 'Percentage',
      value_fixed: 'Amount (€)',
      max_amount: 'Maximum discount (€)',
      max_amount_placeholder: 'e.g. 250',
      max_amount_hint: 'Optional. For a percentage, never more than this amount per product.',
      scope: 'Applies to',
      scope_all: 'All products',
      scope_categories: 'Categories',
      scope_products: 'Specific products',
      categories: 'Categories',
      products: 'Products',
      select_categories: 'Select categories...',
      select_products: 'Select products...',
      search_categories: 'Search categories',
      search_products: 'Search products',
      starts_at: 'Start date',
      ends_at: 'End date',
      period_hint:
        'Leave both empty to start immediately with no end date. Start only = scheduled. End only = active until that date.',
      is_active: 'Active',
      show_badge: 'Show discount badge in configurator',
      create: 'Create',
      save: 'Save',
      errors: {
        title_required: 'Title is required',
        value_invalid: 'Enter a valid value',
        max_amount_invalid: 'Enter an amount greater than 0, or leave it empty',
        code_invalid: 'Use 2–32 letters, numbers or hyphens',
        code_taken: 'This code already exists',
        categories_required: 'Select at least one category',
        products_required: 'Select at least one product',
        save_failed: 'Failed to save',
      },
    },
  },

  // Products
  products: {
    add_product: 'Add product',
    units: {
      none: 'No unit',
      piece: 'Pieces',
      pair: 'Pair',
      meter: 'Meter',
      square_meter: 'Square meter (m²)',
    },
    units_short: {
      piece: 'pcs',
      pair: 'pair',
      meter: 'm',
      square_meter: 'm²',
    },
    search: {
      placeholder: 'Search by name or code…',
      no_results: 'No products found',
      min_chars: 'Type at least 2 characters',
      error: 'Search failed',
    },
    import: {
      button: 'Import',
      title: 'Import products',
      steps_label: 'Import steps',
      step_upload: 'File',
      step_map: 'Columns',
      step_preview: 'Review',
      choose_file: 'Choose CSV or Excel',
      drop_hint: 'Or drop the file here.',
      download_template: 'Download template',
      change_file: 'Change file',
      row_count: '{n} rows',
      mapped_count: '{mapped} of {total} columns mapped',
      map_column: 'Map column {column}',
      no_sample: 'No sample',
      skip_column: 'Do not import',
      existing_products: 'If the product already exists in this feed',
      match_by: 'Match by',
      match_none: 'Do not match',
      match_sku: 'SKU',
      match_title: 'Title',
      on_duplicate: 'When matched',
      duplicate_skip: 'Skip',
      duplicate_update: 'Update',
      duplicate_create: 'Create anyway',
      create_missing_categories: 'Create missing categories',
      preview: 'Review',
      preview_loading: 'Preparing review…',
      confirm: 'Import',
      back: 'Back',
      close: 'Close',
      summary: '{created} to create, {updated} to update, {skipped} to skip',
      summary_done: '{created} created, {updated} updated, {skipped} skipped',
      summary_errors: '{n} rows with an error',
      created: 'Created',
      updated: 'Updated',
      skipped: 'Skipped',
      errors: 'Errors',
      row: 'Row',
      action: 'Action',
      status: 'Status',
      preview_truncated: 'First 50 of {n} rows',
      error_too_large: 'The file is larger than 5 MB.',
      error_unsupported: 'Use a CSV or Excel file.',
      error_empty: 'The file has no rows.',
      error_parse: 'The file could not be read.',
      error_title_required: 'Map a column to Title.',
      error_duplicate_fields: 'Each product field can only have one column.',
      error_preview: 'Failed to load the review.',
      error_import: 'Import failed.',
      empty_title: 'No products yet',
      empty_description: 'Add a product, or import a CSV or Excel file.',
      actions: {
        create: 'Create',
        update: 'Update',
        skip: 'Skip',
        error: 'Error',
      },
      fields: {
        title: 'Title',
        description: 'Description',
        url: 'URL',
        image_url: 'Image URL',
        price: 'Price',
        sale_price: 'Sale price',
        base_sku: 'SKU',
        label: 'Label',
        production_notes: 'Production notes',
        proposal_notes: 'Proposal notes',
        standard_hours: 'Standard hours',
        unit: 'Unit',
        usps: 'USPs',
        categories: 'Categories',
        vat_rate: 'VAT rate',
        target_margin_pct: 'Target margin %',
        min_margin_pct: 'Minimum margin %',
        prices_include_vat: 'Price includes VAT',
        position: 'Position',
      },
      success: '{created} created, {updated} updated',
    },
    product_feeds: 'Product feeds',
    product_feeds_description: 'View and manage all your product feeds',
    product_feed_description: 'View and manage all your products in this feed',
    add_feed: 'Add Feed',
    product_feeds_overview: 'Product feeds overview',
    feed_name: 'Feed name',
    feed_description: 'Feed description',
    load_more: 'Load more',
    remaining: 'remaining',
    copy_options: {
      button: 'Copy option',
      title: 'Copy options from product',
      intro:
        'Pick a product and select options or whole groups to copy. New IDs are created; you can edit them independently afterwards.',
      source_product: 'Source product',
      source_product_placeholder: 'Select a product…',
      loading: 'Loading options…',
      no_options: 'This product has no options.',
      select_all: 'Select all',
      clear_selection: 'Clear selection',
      selected_count: '{n} selected',
      choice_count: '{n} choices',
      ungrouped: 'Ungrouped',
      submit: 'Copy ({n})',
      success: '{n} option(s) copied',
    },
    supplier_mapping_statuses: {
      not_mapped: 'Not mapped',
      mapped: 'Mapped',
      partial: 'Partially mapped',
    },
    supplier_mapping: {
      save_success: 'Supplier mapping saved',
      save_failed: 'Failed to save supplier mapping',
    },
    pricing_rules: {
      title: 'Advanced Pricing Rules',
      description: 'Configure complex pricing calculations for your configurator',
      templates: 'Rule Templates',
      active_rules: 'Active Rules',
      no_rules: 'No pricing rules yet',
      no_rules_description: 'Add pricing rules to enable advanced calculations',
      add_first_rule: 'Add First Rule',
      add_rule: 'Add Rule',
      conditions: 'Conditions',
      pricing: 'Pricing',
      preview: 'Price Preview',
      total: 'Total',
      templates: {
        matrix: 'Matrix Pricing',
        matrix_desc: 'Width × Height calculations (€/m²)',
        tiered: 'Tiered Pricing',
        tiered_desc: 'Volume discounts and staffels',
        bundle: 'Bundle Pricing',
        bundle_desc: 'Combination discounts',
        formula: 'Formula Pricing',
        formula_desc: 'Custom calculation formulas',
      },
      types: {
        matrix: 'Matrix',
        tiered: 'Tiered',
        bundle: 'Bundle',
        formula: 'Formula',
        fixed: 'Fixed Amount',
        percentage: 'Percentage',
      },
    },
  },

  email_preview: {
    title: 'What the customer receives',
    description:
      'Check the email and attachments exactly as the customer gets them before sending.',
    from: 'From',
    to: 'To',
    bcc: 'BCC',
    reply_to: 'Reply to',
    subject: 'Subject',
    attachments: 'Attachments',
    no_attachments: 'No attachments',
    layout_unavailable:
      'The full email layout could not be loaded; only the content is shown below.',
    back: 'Back to editing',
    send: 'Send',
  },

  // Proposals
  proposals: {
    title: 'Proposals',
    stats_toggle: 'Statistics',
    add_proposal: 'Add Proposal',
    number: 'Number',
    title_field: 'Title',
    status: 'Status',
    total_amount: 'Amount (excl.)',
    contact: 'Contact',
    created_at: 'Created at',
    valid_until: 'Valid until',
    actions: 'Actions',
    edit: 'Edit',
    duplicate: 'Duplicate',
    send: 'Send',
    delete: 'Delete',
    view: 'View',
    resend: 'Resend',
    untitled: 'Untitled proposal',
    default_title: 'Proposal',
    // Statistics
    stats: {
      total_sent: 'Total sent',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      conversion_rate: 'Conversion',
      reject_reasons: 'Rejection reasons',
      ytd_total: 'This year',
      total_value: 'Total value',
      proposal_singular: 'proposal',
      proposal_plural: 'proposals',
      proposals_label: 'proposals',
    },
    create_new_proposal: 'Create new proposal',
    create_new_proposal_lead: 'Create a new proposal for this lead.',
    create_new_proposal_general: 'Create a new proposal.',
    open_configurator_title: 'Open configurator',
    open_configurator_description: 'How do you want to open the configurator for this proposal?',
    open_standard: 'Standard',
    open_standard_description: 'Open as the customer sees it',
    open_extended: 'Extended',
    open_extended_description: 'Show internal options and prices',
    open_stage_preliminary: 'Preliminary',
    open_stage_preliminary_description:
      'Not measured yet, e.g. in the showroom. Quote subject to measurement.',
    open_stage_definitive: 'Definitive',
    open_stage_definitive_description: 'Measured, with exact sizes. The quote is definitive.',
    open_extended_keeps_preliminary_description:
      'Show internal options and prices. The quote stays preliminary.',
    edit_proposal: 'Edit proposal',
    edit_proposal_description: 'Edit this proposal.',
    duplicate_proposal: 'Duplicate proposal',
    duplicate_proposal_description:
      'Create a variant of this proposal on the same deal (comparison option). ' +
      'A new deal is only created when the original deal is already won. ' +
      'For a new job with the same customer: create a new proposal/deal.',
    duplicate_for_lead: 'Duplicate for',
    copy_suffix: '(Copy)',
    view_proposal: 'View proposal',
    view_proposal_description: 'View this proposal.',
    delete_proposal: 'Delete proposal',
    delete_proposal_confirmation:
      'Are you sure you want to delete this proposal? This action cannot be undone.',
    proposal_duplicated: 'Proposal duplicated successfully',
    proposal_deleted: 'Proposal deleted',
    error_duplicating: 'Error duplicating proposal',
    error_deleting: 'Error deleting proposal',
    // Withdraw proposal
    withdraw: 'Withdraw',
    withdraw_proposal: 'Withdraw proposal',
    withdraw_proposal_confirmation:
      'Are you sure you want to withdraw this proposal? The proposal will no longer be active and will be marked as "withdrawn".',
    withdraw_reason_label: 'Reason for withdrawal (optional)',
    withdraw_reason_placeholder: 'E.g.: Prices updated, proposal no longer current...',
    proposal_withdrawn: 'Proposal withdrawn successfully',
    error_withdrawing: 'Error withdrawing proposal',
    // Reject proposal
    reject: 'Reject',
    reject_proposal: 'Reject proposal',
    reject_proposal_confirmation:
      'Are you sure you want to reject this proposal? The proposal will be marked as "rejected".',
    reject_reason_label: 'Reason for rejection',
    reject_reason_placeholder: 'E.g.: Customer chose different offer...',
    reject_reason_note_label: 'Additional details (optional)',
    reject_reason_note_placeholder: 'Add any extra details...',
    reject_reason_required: 'Please choose a reason',
    reject_reasons: {
      too_expensive: 'Too expensive',
      other_quote: 'Other quote',
      other_provider: 'Other provider',
      postponed: 'Project postponed',
      not_a_fit: 'Offer does not fit',
      lead_time: 'Lead time too long',
      other: 'Other',
      unknown: 'No reason',
    },
    proposal_rejected: 'Proposal rejected successfully',
    error_rejecting: 'Error rejecting proposal',
    // Restore proposal
    restore: 'Restore',
    restore_proposal: 'Restore proposal',
    restore_proposal_confirmation:
      'Are you sure you want to restore this proposal? The proposal will become active again with status "sent".',
    proposal_restored: 'Proposal restored successfully',
    error_restoring: 'Error restoring proposal',
    restore_to_sent: 'Restore to sent',
    restore_to_sent_confirmation:
      'Are you sure you want to restore this proposal to "sent" status? The current status will be undone.',
    restore_to_sent_from_accepted_confirmation:
      'Are you sure you want to restore this accepted proposal to "sent" status?',
    proposal_restored_to_sent: 'Proposal restored to sent',
    error_restoring_to_sent: 'Error restoring to sent',
    // Mark as accepted/rejected
    mark_accepted: 'Mark as accepted',
    mark_rejected: 'Mark as rejected',
    mark_accepted_title: 'Mark proposal as accepted',
    mark_accepted_confirmation: 'Are you sure you want to mark this proposal as accepted?',
    mark_rejected_title: 'Mark proposal as rejected',
    mark_rejected_confirmation: 'Are you sure you want to mark this proposal as rejected?',
    proposal_marked_accepted: 'Proposal has been marked as accepted',
    proposal_marked_rejected: 'Proposal has been marked as rejected',
    error_marking_accepted: 'Error marking as accepted',
    error_marking_rejected: 'Error marking as rejected',
    accept_reason_label: 'Reason (optional)',
    accept_reason_placeholder: 'Add a reason why this proposal is being marked as accepted',
    // Edit anyway
    edit_anyway: 'Edit anyway',
    edit_anyway_title: 'Edit proposal',
    edit_anyway_warning:
      'You are about to edit a proposal. The status will remain unchanged. Are you sure you want to continue?',
    edit_anyway_confirm: 'Yes, edit anyway',
    edit_sent_warning: 'You are editing a proposal. The status will remain unchanged.',
    title_section_locked_title: 'Proposal number and date locked',
    title_section_locked_warning:
      'The proposal number and proposal date can no longer be changed once the proposal has been sent. You can still adjust the expiration date here, for example to extend the proposal.',
    // Edit accepted (signed) proposal
    edit_accepted_title: 'Edit signed proposal?',
    edit_accepted_warning:
      'This proposal has been accepted by the customer. Changes will flow into the project specifications once the project is synced, and affect the deal value and revenue.',
    edit_accepted_hint:
      'Is this extra work on this project? Create an additional-work proposal — that keeps the signed proposal intact. A new request belongs on a new deal. Only edit to correct a mistake in this proposal.',
    edit_accepted_how_title: 'How does an additional-work proposal work?',
    edit_accepted_how_1: 'You create a separate proposal on the same deal.',
    edit_accepted_how_2: 'The signed proposal stays as the customer accepted it.',
    edit_accepted_how_3:
      'Once accepted, the extra lines are added to the project, separate from the original specification.',
    edit_accepted_how_4:
      'Invoicing adds this extra amount on top of what was already quoted or billed.',
    additional_price_hint_title: 'The price is going up',
    additional_price_hint:
      'Extra work belongs in an additional-work proposal. That keeps this signed proposal intact; after acceptance the extra lines land on the project. Only save here if you are correcting a mistake in this proposal.',
    additional_creating_title: 'Additional-work proposal',
    additional_creating_hint:
      'This is extra work on the same deal. The original signed proposal stays intact. After acceptance these lines are added to the project.',
    additional_leave_unsaved:
      'Opening an additional-work proposal. Changes to the signed proposal were not saved.',
    edit_accepted_confirm: 'Edit anyway',
    edit_accepted_additional: 'Create additional-work proposal',
    default_additional_title: 'Additional work',
    scope_sync: {
      title: 'Project updated',
      body: 'Project lines were updated to match this proposal.',
      additional_hint:
        'For extra work in the future: create an additional-work proposal instead of changing the signed proposal.',
      credit_hint:
        'Some lines are already on a sent invoice. The invoice itself was not changed. If too much was billed, issue a credit note from the project.',
      skipped_removals: '{count} already-billed line(s) were not removed.',
      over_invoiced: 'More has already been invoiced than the new project total.',
      create_additional: 'Create additional-work proposal',
      view_project: 'Go to project',
      close: 'Close',
    },
    unsaved_changes_title: 'Are you sure?',
    unsaved_changes_confirm: 'You have unsaved changes. Are you sure you want to close?',
    // Toolbar
    download: 'Download',
    download_bare: 'Download bare proposal',
    status: 'Status',
    pdf_downloaded: 'PDF downloaded successfully',
    error_downloading_pdf: 'Error downloading PDF',
    // Bulk delete
    delete_selected: 'Delete selected ({count})',
    bulk_delete_title: 'Delete proposals',
    bulk_delete_confirmation:
      'Are you sure you want to delete {count} proposal(s)? This action cannot be undone.',
    bulk_delete_skipped:
      '{count} selected proposal(s) will be skipped because only drafts can be deleted.',
    bulk_delete_no_drafts:
      'None of the selected proposals can be deleted. Only drafts can be deleted.',
    bulk_delete_success: '{count} proposal(s) deleted successfully',
    error_bulk_deleting: 'Error deleting proposals',
    // Bulk send
    send_selected: 'Send selected ({count})',
    bulk_send_title: 'Send proposals',
    bulk_send_confirmation:
      'Are you sure you want to send {count} proposal(s)? The client will receive an email with the proposal right away.',
    bulk_send_skipped:
      '{count} selected proposal(s) will be skipped because only drafts can be sent.',
    bulk_send_no_drafts: 'None of the selected proposals can be sent. Only drafts can be sent.',
    bulk_send_success: '{count} proposal(s) are being sent',
    bulk_send_failed: '{count} proposal(s) could not be sent and were reverted to draft.',
    bulk_send_taking_longer: '{count} proposal(s) are taking longer than expected to send.',
    bulk_send_skip_reason: {
      not_draft: '{count} proposal(s) skipped — only drafts can be sent.',
      no_recipient: '{count} proposal(s) skipped — the lead has no email address.',
      same_deal_conflict:
        '{count} proposal(s) skipped — a newer draft in the same deal was sent instead.',
      has_successor: '{count} proposal(s) skipped — a newer version already exists.',
      send_failed: '{count} proposal(s) could not be sent due to an error.',
      default: '{count} proposal(s) were skipped.',
    },
    error_bulk_sending: 'Error sending proposals',

    // Revise configuration
    revise_configuration: 'Revise configuration',
    revise_configuration_error: 'Could not open configuration',
    revise_configuration_line_hint: 'Reopen the configurator to adjust this configuration',
    revise_mode_title: 'Revise configuration',
    revise_mode_description: 'Choose how you want to open the configurator.',
    revise_has_successor_error:
      'This proposal has already been followed by a newer proposal. Open the successor proposal to continue.',
    revise_products_unavailable_error:
      'This proposal cannot be opened: {products} no longer exists in the product catalog. Remove or replace that line first.',
    revise_products_unavailable_error_unnamed:
      'This proposal cannot be opened: one or more products no longer exist in the product catalog. Remove or replace those lines first.',
    revise_accepted_title: 'Revise accepted proposal',
    revise_accepted_description:
      'This proposal has already been accepted and signed. If you revise the configuration, the current proposal will be replaced and must be resent and accepted again.',
    revise_accepted_confirm: 'Revise anyway',
    revise_ready_title: 'Configuration ready to open',
    revise_ready_description: 'Click the button below to open the configurator in a new tab.',
    open_configurator: 'Open configurator',
    error_opening_configurator: 'Could not open configurator',
    configurator: {
      title: 'Configure product',
      product: 'Product',
      select_option: 'Select an option',
      select_options: 'Select options',
      no_options: 'No configurable options for this product.',
      total: 'Total',
      add_to_proposal: 'Add to proposal',
      reconfigure: 'Reconfigure',
      product_not_found: 'Product not found',
      pricing_failed: 'Could not calculate the price. The product was not added.',
      choice_unavailable: 'Not available with the current choices',
      missing_required: '{count} required field(s) left',
      measure_out_of_range: '{label} must be between {min} and {max}',
      price_incl: 'Price incl. VAT',
      calculating: 'Calculating price...',
      price_failed: 'Could not calculate the price',
    },
    // Send Proposal
    send_modal: {
      title: 'Send proposal',
      description: 'Review this proposal and send it',
      expired_valid_until_title: 'Expiration date has passed',
      expired_valid_until_warning:
        "This proposal's expiration date is already in the past. It will be sent as-is — the date will not be changed automatically. Send anyway?",
      expired_valid_until_confirm: 'Send anyway',
      accepted_message: 'Your proposal has been accepted!',
      rejected_message: 'This proposal has been rejected.',
      withdrawn_message: 'This proposal has been withdrawn.',
      view_proposal: 'View proposal',
      sent_at: 'Sent at',
      accepted_at: 'Accepted at',
      accepted_by: 'Accepted by',
      rejected_at: 'Rejected at',
      rejection_reason: 'Reason for rejection',
      withdrawn_at: 'Withdrawn at',
      withdrawal_reason: 'Reason for withdrawal',
      ip_address: 'IP Address',
      sent_message: 'Proposal has been sent at',
      share_placeholder: 'Share your proposal to get a shareable link',
      copy: 'Copy',
      resend_proposal: 'Resend proposal',
      recipients: 'Recipients',
      recipients_placeholder: 'Enter an email address and press enter',
      email_subject: 'Email subject',
      email_subject_placeholder: 'Enter email subject',
      email_content: 'Email content',
      email_content_placeholder: 'Enter email content',
      send_button: 'Send proposal',
      resend_button: 'Resend proposal',
      proposal_sent_success: 'Proposal sent to your lead!',
      sending: 'Sending proposal…',
      pending_banner: 'Proposal is being sent — this usually takes a few seconds.',
      send_failed: 'Sending failed — please try again.',
      taking_longer: 'Sending is taking longer than expected. Check the proposal status later.',
      status_unknown: 'Could not retrieve sending status.',
      error_saving: 'There was an error saving the proposal',
      link_copied: 'Link copied!',
      whatsapp_title: 'Also send via WhatsApp?',
      whatsapp_description:
        'Would you like to also share the proposal via WhatsApp with the customer?',
      whatsapp_yes: 'Yes, open WhatsApp',
      send_whatsapp: 'Send via WhatsApp',
      share_proposal: 'Share proposal',
      resend_email: 'Send via email',
      copy_link: 'Copy link',
      no_phone_number: 'No phone number available for this customer',
      attachments: 'Attachments',
      attachments_hint:
        'PDF attachments are sent along with the email and can be downloaded on the proposal page.',
      add_attachment: 'Add PDF',
      default_attachment_badge: 'Default',
      default_attachment_tooltip:
        'Default attachment (configurable via Settings → Proposals). Use the cross to leave it out of this proposal.',
      product_attachment_badge: 'Product',
      product_attachment_tooltip:
        'This attachment belongs to a product on the proposal (configurable on the product). Use the cross to leave it out of this proposal.',
      attachment_excluded_badge: 'Not included',
      remove_attachment: 'Remove attachment',
      restore_attachment: 'Include again',
      attachments_total: 'Total attachments: {size} (max {max} per email)',
      attachments_over_limit:
        'The attachments are too large to send by email ({size}, max {max}). Remove one or more attachments.',
      attachment_upload_failed: 'Failed to upload attachment',
      attachment_only_pdf: 'Only PDF files are allowed',
      attachment_too_large: 'File is too large (max 5MB)',
      proposal_pdf_badge: 'Proposal',
      proposal_pdf_name: 'Proposal as PDF',
      proposal_pdf_tooltip: 'The proposal itself as a PDF (toggle via Settings → Organization)',
      proposal_pdf_pending: 'generated when sending',
      terms_badge: 'Terms',
      terms_tooltip: 'Terms and conditions (configurable via Settings → Organization)',
      review_button: 'Review and send',
      preview_loading: 'Loading preview…',
      preview_failed: 'Could not load the preview',
    },
    // Proposal form
    form: {
      fields: {
        address: {
          street: 'Street',
          house_number: 'House number',
          postal_code: 'Postal code',
          city: 'City',
          select_country: 'Country',
        },
      },
      basic_information: 'Basic information',
      proposal_subject: 'Proposal subject',
      lead: 'Lead',
      proposal_date: 'Proposal date',
      valid_for_days: 'Valid for (days)',
      valid_until_hint: 'Valid for {days} days',
      notes: 'Notes',
      client_notes: 'Client notes',
      internal_notes: 'Internal notes',
      items: 'Items',
      prices_include_vat: 'Prices include VAT',
      description: 'Description',
      configuration_details: 'Configuration details',
      quantity: 'Quantity',
      unit_price: 'Unit Price',
      vat_rate: 'VAT Rate',
      total: 'Total',
      clone: 'Clone',
      remove: 'Remove',
      hide_from_quote: 'Hide from quote',
      show_on_quote: 'Show on quote',
      hidden_line_badge: 'Hidden',
      hidden_line_hint:
        'This line is left off the quote, PDF and invoice. Its amount is folded into the price of the first visible product with the same VAT rate, so the customer-facing amounts keep adding up.',
      hidden_lines_summary:
        '{amount} in hidden costs is folded into the price of {carrier}. The customer sees a higher amount there, not a separate line.',
      hidden_lines_carrier_fallback: 'the first product',
      hidden_lines_unabsorbed:
        'Heads up: {amount} in hidden costs has nowhere to go, because no visible product shares its VAT rate. Add such a product or match the hidden line\u2019s VAT rate, otherwise the quote will not add up for the customer.',
      add_item: 'Add item',
      summary: 'Summary',
      subtotal: 'Subtotal',
      total_vat: 'Total VAT',
      save: 'Save',
      review_and_send: 'Review and send',
      save_first_message: 'Save your proposal first before sending',
      lead_information: 'Lead information',
      search_leads: 'Search leads...',
      no_leads_found: 'No leads found',
      select_lead: 'Select a lead',
      at_least_one_item_required: 'At least one item is required',
      description_required: 'Description is required',
      quantity_min_1: 'Quantity must be at least 1',
      unit_price_greater_than_0: 'Unit price must be greater than 0',
      proposal_updated: 'Proposal updated successfully',
      proposal_created: 'Proposal created successfully',
      proposal_duplicated_success: 'Proposal duplicated successfully',
      error_saving: 'There was an error saving the proposal',
      error_accepted_locked:
        'Items, discounts and VAT on an accepted proposal can only be changed after you confirm "Edit anyway".',
      lead_required_hint: 'Select a contact first',
      valid_until_before_proposal_date:
        'The expiration date cannot be earlier than the proposal date',
      proposal_date_pending_hint:
        'These dates are a preview based on today and are only finalized once you send the proposal.',
      proposal_date_override_title: 'Set proposal date manually',
      proposal_date_override_warning:
        'Are you sure you want to set the proposal date manually? If you leave this to Funnelflow, the date the proposal is sent will be used automatically.',
      proposal_date_override_button: 'Enable manual selection',
      error_preparing_send: 'Error preparing proposal for sending',
      // Discounts
      discounts: 'Discounts',
      add_discount: 'Add discount',
      no_discounts: 'No discounts added',
      discount_number: 'Discount {number}',
      discount_type: 'Type',
      discount_type_percentage: 'Percentage',
      discount_type_fixed: 'Fixed amount',
      discount_value: 'Value',
      discount_value_percentage: 'Percentage',
      discount_value_amount: 'Amount (€)',
      discount_description: 'Description (optional)',
      discount_description_placeholder: 'E.g. Early bird discount',
      remove_discount: 'Remove',
      subtotal_after_discounts: 'Subtotal after discounts (excl. VAT)',
      title_required: 'Title is required',
      lead_required: 'Please select a contact',
      items_required: 'Add at least one item',
      item_description_required: 'Each item must have a description',
    },
    // Proposal statuses
    statuses: {
      draft: 'Draft',
      sent: 'Sent',
      viewed: 'Viewed',
      accepted: 'Accepted',
      rejected: 'Rejected',
      superseded: 'Superseded',
      withdrawn: 'Withdrawn',
      sending: 'Sending',
    },
    // Proposal types (pro forma flow)
    types: {
      definitive: 'Definitive',
      proforma: 'Preliminary',
      additional: 'Additional work',
    },
    type_field: 'Type',
    succeeded_by: 'Succeeded by',
    based_on: 'Based on',
    revise_carries_lines:
      '{count} manually added line(s) will be carried over to the new quote automatically.',
    revise_carries_lines_with_hidden:
      '{count} manually added line(s) will be carried over, {hiddenCount} of which are hidden from the customer.',
    make_definitive: 'Make definitive',
    make_definitive_description:
      'Opens the configurator with original values so you can enter exact measurements.',
    auto_accepted_banner: 'This definitive proposal was automatically accepted.',
    auto_accepted_price_change:
      'Price change vs preliminary quote: {change}% (within tolerance {tolerance}%)',
    manual_approval_required: 'Manual approval required',
    manual_approval_description:
      'Price increase {change}% vs preliminary quote (above tolerance of {tolerance}%).',
    proforma_accepted_banner: 'Preliminary quote accepted',
    proforma_accepted_description:
      'The client has signed the preliminary quote. Schedule a measurement to create the definitive proposal.',
    create_project_and_measurement: 'Create project + measurement',
    create_project_only: 'Create project only',
    proforma_standalone_info:
      'This is a preliminary quote. After measurement, the client will receive a definitive proposal with exact specifications.',
    superseded_message: 'This proposal has been replaced by a newer version.',
    superseded_info: 'You can no longer edit or send this proposal.',
    open_successor: 'Open quote {number}',
    // Moneybird layout
    extra: 'Extra',
    change_status: 'Change status',
    days_open: 'days open',
    expires_on: 'Expires on',
    expired_on: 'Expired on',
    accepted_on: 'Accepted on',
    rejected_on: 'Rejected on',
    not_sent_yet: 'Not sent yet',
    validity_period: 'Validity period',
    of: 'of',
    days_passed: 'days passed',
    activities: 'Activities',
    signature_info: 'Signature',
    signed_by: 'Signed by',
    email: 'Email',
    ip_address: 'IP address',
    signed_at: 'Signed at',
    mark_as_sent_manually: 'Mark as sent manually',
    mark_as_sent_manually_checkbox: 'Mark as sent manually (no email sent)',
    mark_as_sent_manually_description: 'Mark this proposal as sent without sending an email.',
    marked_as_sent_manually: 'Proposal marked as sent manually',
    error_marking_sent: 'Error marking as sent',
    view_online: 'View online',
    pages: {
      title: 'Pages',
      navigation: 'Proposal pages',
      actions: 'Proposal actions',
      cover: 'Cover',
      proposal: 'Proposal',
      closing: 'Closing page',
      from_template: 'from template',
      layout_rail: 'Show pages in side rail',
      layout_dock: 'Show pages in bottom bar',
    },
    delete_proposal: 'Delete proposal',
    delete_proposal_confirmation:
      'Are you sure you want to delete this proposal? This action cannot be undone.',
    proposal_deleted: 'Proposal deleted',
    error_deleting: 'Error deleting proposal',
    withdraw: 'Withdraw',
    withdraw_proposal: 'Withdraw proposal',
    withdraw_confirmation:
      'If you withdraw the proposal, it will be invalidated for the customer. The customer will no longer be able to accept it.',
    withdraw_reason_placeholder: 'Reason for withdrawal (optional)',
    proposal_withdrawn: 'Proposal withdrawn',
    error_withdrawing: 'Error withdrawing proposal',
    delivery: {
      banner_title: 'Proposal not delivered to {recipients}',
      banner_title_reminder: 'Reminder not delivered to {recipients}',
      banner_title_failed: 'The proposal email could not be sent',
      banner_hint: "Check the client's email address and send the proposal again.",
      resend: 'Send again',
      toast: 'Note: the proposal was not delivered to {recipients}. Check the email address.',
      toast_failed: 'Note: the proposal email could not be sent.',
      reasons: {
        HardBounce: 'The email address does not exist or the mailbox is unreachable.',
        SoftBounce: 'The mailbox is temporarily unavailable (for example because it is full).',
        BadEmailAddress: 'The email address is invalid.',
        DnsError: 'The domain of the email address does not exist or cannot be reached.',
        Blocked: "The recipient's mail server blocked the email.",
        ManuallyDeactivated:
          'The address is blocked after earlier failed deliveries or a spam complaint.',
        DMARCPolicy: "The email was refused by the recipient's security policy.",
        inactive: 'This address bounced before and is blocked by our email provider.',
        failed: 'Something went wrong while sending the email.',
        default: 'The email could not be delivered.',
      },
      send_errors: {
        too_large: 'The email is too large: the attachments add up to more than 10 MB.',
        invalid_recipient: "The recipient's email address is invalid.",
        sender_not_allowed: 'The sender address is not allowed by our email provider.',
        rate_limited: 'Too many emails are being sent at the moment.',
      },
      hints: {
        too_large: 'Remove one or more attachments and send the proposal again.',
        retry: 'Please try again later. If it keeps failing, contact support.',
      },
    },
    activity: {
      created: 'Proposal created',
      sent: 'Proposal sent',
      marked_sent_manually: 'Proposal marked as sent manually',
      viewed: 'Proposal viewed',
      accepted: 'Proposal accepted',
      rejected: 'Proposal rejected',
      withdrawn: 'Proposal withdrawn',
      updated: 'Proposal edited',
      content_edited: 'Signed proposal edited',
      reminder_sent: 'Reminder sent to {recipient} (after {interval} days)',
      reminder_sent_no_recipient: 'Reminder sent (after {interval} days)',
      bounced: 'Proposal not delivered to {recipients}',
      reminder_bounced: 'Reminder not delivered to {recipients}',
      send_failed: 'Proposal email could not be sent',
      price_deviation: {
        price_held: 'Agreed price held: measurement {difference} ({pct}%), within margin {max}%',
        price_not_held:
          'Agreed price not held: measurement {difference} ({pct}%) is outside margin {max}%',
        price_hold_failed: 'Agreed price could not be held: measurement {difference} ({pct}%)',
        price_unchanged: 'Measurement matches the agreed price',
        price_difference: 'Price difference after measurement: {difference} ({pct}%)',
        remeasure: 'Re-measurement: price not held ({difference}, {pct}%)',
        auto_accepted: 'Automatically accepted',
        auto_accept_skipped: 'Not automatically accepted: {reason}',
        reasons: {
          above_tolerance: 'difference exceeds the margin, customer must approve',
          below_tolerance: 'difference exceeds the margin, customer must approve',
          hold_failed: 'agreed price could not be held, customer must approve',
          proforma_not_accepted: 'pro forma proposal was not accepted yet',
          not_from_proforma: 're-measurements always need customer approval',
          update_failed: 'technical error while accepting',
        },
      },
    },
    // Filter
    filter: {
      status: 'Status',
      filter_by_status: 'Filter by status',
      reset: 'Show all',
    },
    // Empty state
    empty_state: {
      title: 'No proposals yet',
      description: 'Get started by creating your first proposal.',
    },
    // Search
    search_placeholder: 'Search by title, number, contact...',
    no_more_results: 'All proposals loaded',
    search_no_results: 'No results found',
    search_no_results_description:
      'No proposals found matching your search query. Try a different search term.',
    error_loading: 'Error loading proposal',
  },

  // Projects
  projects: {
    title: 'Projects',
    add_project: 'Add Project',
    view_table: 'Table',
    journey_hint:
      'Running projects per phase and who has the ball. Projects without a linked deal only show in the table.',
    journey_search: 'Search by project number, title or customer...',
    address_sync_title: 'Update the address in running projects too?',
    address_sync_intro:
      '{count} running project still uses the old address. Projects keep a copy of the customer address, so it does not change along automatically.',
    address_sync_new_address: 'New customer address',
    address_sync_empty: 'No address',
    address_sync_work_orders: '{count} open work order(s)',
    address_sync_note:
      'Open work orders get the new address as well. Supplier orders already sent, packing slips and invoices stay unchanged.',
    address_sync_keep: 'Leave as is',
    address_sync_apply: 'Update projects',
    address_sync_success: '{count} project(s) updated',
    address_sync_partial: '{updated} updated, {failed} failed',
    address_sync_failed: 'Could not update the project addresses',
    details: 'Project Details',
    project_number: 'Project Number',
    sales_order: 'Sales order',
    proposal: 'Quote',
    customer_reference: 'Your reference',
    customer_reference_placeholder: 'e.g. PO-00297',
    customer_reference_help: 'Customer PO or order reference. Printed on the invoice.',
    title_field: 'Title',
    title_placeholder: 'Enter a project name',
    description: 'Description',
    description_placeholder: 'Short project description',
    status: 'Status',
    customer: 'Customer',
    proposal: 'Proposal',
    select_proposal: 'Select a proposal',
    orders_count: 'Purchase orders',
    invoicing: 'Invoicing',
    invoicing_tooltip: 'Invoiced / project total (incl. VAT)',
    invoicing_paid: 'Paid',
    invoicing_open: 'Open',
    expected_start: 'Expected Start Date',
    expected_completion: 'Expected Completion',
    installation_address: 'Installation Address',
    use_lead_address: 'Use lead address',
    use_custom_address: 'Custom address',
    street: 'Street + number',
    postal_code: 'Postal code',
    city: 'City',
    internal_notes: 'Internal notes',
    internal_notes_placeholder: 'Notes for internal use',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    create_project: 'Create Project',
    create_new_project: 'Create New Project',
    create_from_proposal: 'Create Project',
    create_from_deal: 'Create Project',
    view_project: 'View Project',
    project_created_success: 'Project created successfully',
    edit_project: 'Edit Project',
    delete_project: 'Delete Project',
    delete_project_confirmation: 'Are you sure you want to delete this project?',
    linked_deal: 'Linked deal',
    salesperson: 'Salesperson',
    no_project_yet: 'No project yet',
    no_project_yet_description:
      'A project is created automatically as soon as the final quote is accepted. Want to schedule work orders or manage purchase orders already? Create it manually.',
    create_project_for_deal: 'Create the project now',
    draft_banner: 'This project is a draft. Once the deal is won, the project becomes active.',
    planning_banner:
      'This project is awaiting measurement. After measurement, a definitive quote will be created.',
    proforma_zero_banner:
      'This is a preliminary quote. There is no definitive quote yet, so the project total is €0.',
    orders_not_available_draft: 'Purchase orders are only available when the deal is won.',
    reopen_project: 'Reopen Project',
    reopen_confirm: 'Do you want to reopen this project?',
    project_reopened: 'Project reopened',
    reopen_failed: 'Failed to reopen project',
    complete_project: 'Complete Project',
    complete_confirm: 'Are you sure you want to complete this project?',
    project_completed: 'Project completed',
    select_proposal_for_order: 'Select a proposal as source for the purchase order',
    no_accepted_proposals: 'No accepted proposals available.',
    deal: 'Deal',
    progress: 'Progress',
    work_orders_progress: '{completed}/{total} work orders',
    orders_progress: '{completed}/{total} purchase orders',
    statuses: {
      draft: 'Draft',
      planning: 'Measurement',
      active: 'Active',
      on_hold: 'On Hold',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    empty_state: {
      title: 'No projects yet',
      description: 'Start by creating your first project.',
    },
    filter: {
      status: 'Status',
      filter_by_status: 'Filter by status',
      reset: 'Show all',
    },
  },

  // Orders
  orders: {
    title: 'Purchase orders',
    add_order: 'Add purchase order',
    loose: {
      button: 'Order loose articles',
      title: 'Order loose articles',
      supplier: 'Supplier',
      supplier_placeholder: 'Choose a supplier',
      add_article: 'Add article',
      search_placeholder: 'Search by article code or name',
      empty: 'No articles yet. Search above by code or name.',
      quantity: 'Quantity',
      length_m: 'Length per piece (m)',
      note: 'Line note',
      note_placeholder: 'E.g. cut to size',
      remove: 'Remove',
      submit: 'Save and review',
      no_project: 'Loose order',
      length_required: 'Enter a length per piece for every meter article.',
      failed: 'Saving the order failed',
    },
    order_number: 'PO number',
    title_field: 'Title',
    title_placeholder: 'Enter a purchase order title',
    status: 'Status',
    project: 'Project',
    select_project: 'Select a project',
    customer: 'Customer',
    supplier: 'Supplier',
    select_supplier: 'Select a supplier',
    items: 'Products',
    expected_delivery: 'Expected Delivery',
    actual_delivery_date: 'Actual Delivery Date',
    appointment_date: 'Appointment',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    create_order: 'Create purchase order',
    request_failed: 'Purchase order action failed',
    order_created: 'Purchase order created',
    order_updated: 'Purchase order updated',
    order_status_updated: 'Status updated',
    order_deleted: 'Purchase order deleted',
    order_exported: 'Purchase order sent to supplier',
    proposal_must_be_accepted:
      'The proposal must be accepted first. Open it and choose Change status → Mark as accepted at the top right. Send a draft first.',
    proposal_not_accepted:
      'The linked proposal has not been accepted yet (status: {status}). Accept the proposal first.',
    proposal_accept_hint_draft:
      'This proposal is still a draft, so you cannot create a purchase order yet. Send it first. Then open it and choose Change status → Mark as accepted at the top right.',
    proposal_accept_hint_sent:
      'This proposal has been sent, but it is not accepted yet. Open it and choose Change status → Mark as accepted at the top right. You can create the purchase order after that.',
    proposal_accept_hint_rejected:
      'This proposal was rejected. Open it and choose Change status → Mark as accepted at the top right if the customer has agreed after all.',
    proposal_accept_hint_replaced:
      'This proposal no longer counts. Open the latest proposal and choose Change status → Mark as accepted at the top right. You can create the purchase order after that.',
    draft_project_no_orders: 'Purchase orders can only be placed after the deal is won.',
    create_new_order: 'Create new purchase order',
    edit_order: 'Edit purchase order',
    delete_order: 'Delete purchase order',
    delete_order_confirmation: 'Are you sure you want to delete this purchase order?',
    update_status: 'Update Status',
    export_to_supplier: 'Send order',
    resend_to_supplier: 'Resend to supplier',
    // Status update modal
    current_status: 'Current Status',
    new_status: 'New Status',
    select_status: 'Select a status',
    supplier_order_reference: 'Supplier Reference',
    supplier_order_reference_placeholder: 'e.g. ORDER-12345',
    delivery_notes: 'Delivery Notes',
    delivery_notes_placeholder: 'Notes about the delivery',
    installation_notes: 'Installation Notes',
    installation_notes_placeholder: 'Notes for the installation',
    cancellation_reason: 'Cancellation Reason',
    cancellation_reason_placeholder: 'Why is this purchase order being cancelled?',
    status_notes: 'Notes',
    status_notes_placeholder: 'Optional notes for this status change',
    auto_generate_work_order: 'Auto-generate work order',
    supplier_notes: 'Supplier Notes',
    supplier_notes_placeholder: 'Notes for the supplier',
    internal_notes: 'Internal Notes',
    internal_notes_placeholder: 'Notes for internal use',
    // Planning fields
    planning_optional: 'Planning (optional)',
    planning_hint:
      'You can already schedule a tentative appointment, even if the product has not arrived yet.',
    tentative_appointment: 'Tentative Appointment',
    statuses: {
      pending: 'Pending',
      ordered: 'Ordered',
      confirmed: 'Confirmed',
      received: 'Received',
      cancelled: 'Cancelled',
      cancelled_by_supplier: 'Cancelled by supplier',
      installed: 'Installed',
    },
    empty_state: {
      title: 'No purchase orders yet',
      description: 'Start by creating your first purchase order.',
    },
    details: 'Details',
    products: 'Products',
  },

  // Work Orders
  work_orders: {
    title: 'Work Orders',
    untitled: 'Work order',
    work_order_number: 'Work Order Number',
    types: {
      installation: 'Installation',
      measurement: 'Measurement',
      service: 'Service',
    },
    type_field: 'Type',
    type_changed: 'Work order type updated',
    type_change_failed: 'Could not change the type',
    type_in_measurement_title: 'Project is still in measurement',
    type_in_measurement_description:
      'No definitive quote has been accepted yet. Are you sure you want to change this work order to installation?',
    type_in_measurement_confirm: 'Yes, change to installation',
    description: 'Description',
    installer_notes: 'Notes for the installer',
    order: 'Purchase order',
    project: 'Project',
    customer: 'Customer',
    address: 'Address',
    installer: 'Installer',
    appointment_date: 'Appointment',
    status: 'Status',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    complete: 'Complete',
    generate_work_order: 'Generate Work Order',
    schedule: 'Schedule',
    scheduled_success: 'Work order scheduled',
    scheduled_error: 'Failed to schedule work order',
    statuses: {
      pending: 'Pending',
      scheduled: 'Scheduled',
      ready_for_installation: 'Ready for Installation',
      open: 'Open',
      in_progress: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    fill_form: 'Fill in form',
    select_form: 'Select form',
    open_form: 'Open in new tab',
    measurement_already_definitive:
      'A definitive proposal already exists. A new measurement creates a new version.',
    remeasure_confirm_title: 'Measure again',
    remeasure_confirm_description:
      'There is already an accepted definitive proposal. We will create a new version. ' +
      'If the price stays within the configured margin, it is accepted automatically. ' +
      'Otherwise the customer must approve it again.',
    remeasure_confirm_submit: 'Open configurator',
    empty_state: {
      title: 'No work orders yet',
      description: 'Create a work order to schedule tasks.',
    },
    products: {
      section_title: 'Products on this work order',
      select_products: 'Choose products',
      choose_title: 'Products for work order',
      choose_description:
        'Choose which project products are on this work order. ' +
        'The packing slip and installation use this selection.',
      all_products: 'All project products',
      select_all: 'Select all',
      deselect_all: 'Deselect all',
      none_selected: 'No products selected',
      no_products: 'This project has no products in scope (yet).',
      already_assigned: 'Already on {labels}',
      already_assigned_generic: 'Already on a work order',
      standard_hours: '{hours} h',
      estimated_duration: 'Estimated duration: {duration}',
      estimated_duration_fallback: 'No standard hours set — defaults to 2 hours when scheduling.',
      save: 'Save selection',
      updated: 'Products updated',
      update_error: 'Could not update products',
      // Sync
      sync: 'Re-sync',
      scope_changed:
        'The project scope changed after this work order. Re-sync to update ' + 'the products.',
      synced: 'Products synced with the project',
      sync_error: 'Sync failed',
      // Carry-over
      carry_over: 'Follow-up work order',
      carry_over_title: 'Create follow-up work order',
      carry_over_description:
        'Choose the products for a new follow-up work order (e.g. not ' +
        'completed or for later). Installer and date are not carried over.',
      carry_over_submit: 'Create follow-up',
      carry_over_success: 'Follow-up work order created',
      carry_over_error: 'Could not create follow-up work order',
      // Chain
      chain_title: 'Linked work orders',
      parent_label: 'Follow-up of',
      child_label: 'Follow-up work order',
    },
    outcomes: {
      hint: 'Indicate per product whether the installation succeeded.',
      installed: 'Done',
      failed: 'Not completed',
      reason_label: 'Reason',
      reason_placeholder: 'Select a reason...',
      notes_placeholder: 'Notes (optional)...',
      reasons: {
        product_missing: 'Product not present',
        product_damaged: 'Product damaged',
        situation_different: 'Situation different than expected',
        other: 'Other',
      },
      follow_up_notice:
        'A follow-up work order will be created automatically for {count} product(s).',
      complete_with_exceptions: 'Complete with exceptions',
      completed_with_follow_up: 'Work order signed off! Follow-up work order {number} created.',
      completed_with_exceptions_banner: 'Work order completed with exceptions',
      outcomes_title: 'Outcome per product',
      follow_up_filter: 'Follow-up actions',
    },
  },

  // Submissions
  submissions: {
    title: 'Requests',
    all_submissions: 'All requests',
    all_forms: 'All Forms',
    view_all_submissions: 'View and manage all requests across your organization',
    view_form_submissions: 'View and manage submissions for this form',
    no_submissions: 'No submissions yet',
    no_submissions_description: 'No requests have been received yet.',
    submission_details: 'Request details',
    lead: 'Lead',
    last_updated: 'Last updated',
    form_data: 'Form data',
    no_value_provided: 'No value provided',
    form_submission: 'Form Submission',
    status: {
      new: 'New',
      reviewed: 'Reviewed',
      processed: 'Processed',
      archived: 'Archived',
      partial: 'Draft',
      complete: 'Complete',
    },
    filter_all: 'All requests',
    filter_complete: 'Complete',
    filter_incomplete: 'Incomplete',
    export_to_csv: 'Export to CSV',
    exporting: 'Exporting...',
    // Filter dropdown
    filter: {
      status: 'Status',
      form: 'Form',
      filter_by_status: 'Filter by status',
      filter_by_form: 'Filter by form',
      reset: 'Show all',
      all_forms: 'All forms',
    },
    // Stats
    stats: {
      total: 'Total',
      completed: 'Completed',
      partial: 'In progress',
      failed: 'Failed',
      processing: 'Processing',
      completion_rate: 'Completion rate',
    },
  },

  // Lead Details
  lead_details: {
    overview: 'Overview',
    proposals: 'Proposals',
    submissions: 'Requests',
    appointments: 'Appointments',
    deals: 'Deals',
    activity: 'Activity',
    contact_details: 'Contact details',
    no_description_provided: 'Click to edit',
    attribution: 'Attribution',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    description: 'Description',
    marketing_opt_in: 'Marketing opt-in',
    activity_feed: 'Activity Feed',
    leave_note_placeholder: 'Leave a note on the timeline...',
    form_submissions: 'Requests',
    no_submissions: 'No requests yet',
    no_submissions_description: 'This lead has not submitted any forms yet.',
    no_appointments: 'No appointments scheduled',
    no_appointments_description: 'This lead has no appointments scheduled yet.',
    lead_not_found: 'Lead not found',
    lead_not_found_description: 'The requested lead could not be found.',
    unnamed_lead: 'Unnamed Lead',
    created_at: 'Created',
    loading: 'Loading...',
    no_lead_selected: 'No lead selected',
    select_lead_to_view: 'Select a lead from the table to view details.',
    view_and_manage_lead: 'View and manage lead information, requests, and proposals.',
    no_address_provided: 'No address provided',
    no_phone_provided: 'No phone number provided',
    add_note: 'Add Note',
    form_submission: 'Form submission',
    lead_created: 'Lead created',
    updated_lead_fields: 'Updated lead fields',
    status_updated: 'Status updated',
    updated_lead_field: 'Updated lead field',
    update_field_failed: 'Failed to update field',
    email_already_exists: 'A lead with this email already exists: {name} ({email})',
    note_added: 'Note added',
    lead_details: 'Lead details',
    edit_details: 'Edit customer details',
    customer_type: {
      person: 'Individual',
      company: 'Business',
    },
    company_details: 'Company details',
    company_name: 'Company name',
    kvk_number: 'Registration number',
    vat_number: 'VAT number',
    legal_form: 'Legal form',
    vat_reverse_charge_active: 'VAT reverse-charged',
    billing_details: 'Billing details',
    billing_email: 'Billing email',
    billing_address: 'Billing address',
    no_billing_details: 'No different billing details',
    // Archive/Restore/Delete
    archive_lead: 'Archive lead',
    archive_lead_confirm:
      'Are you sure you want to archive this lead? The lead will be hidden but all data will be preserved.',
    archive: 'Archive',
    lead_archived: 'Lead archived',
    archive_failed: 'Failed to archive',
    restore_lead: 'Restore lead',
    lead_restored: 'Lead restored',
    restore_failed: 'Failed to restore',
    delete_lead: 'Delete lead',
    delete_lead_confirm:
      'Are you sure you want to permanently delete this lead? This cannot be undone.',
    delete: 'Delete',
    lead_deleted: 'Lead deleted',
    delete_failed: 'Failed to delete',
  },

  // Table View
  table_view: {
    leads_overview: 'Leads overview',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    last_updated_at: 'Last updated at',
  },

  // Form List
  form_list: {
    title: 'Your funnels',
    description: 'View and manage all your stored funnels',
    new_flow: 'New flow',
    new_configurator: 'New configurator',
    empty_state: {
      title: 'No funnels yet',
      description: 'Get started by creating your first funnel.',
      action: 'Create new flow',
    },
    modal: {
      title: 'Create a new flow',
      description: 'Let us know how you would like to create your new flow 👏',
    },
    configurator_modal: {
      title: 'Create a new configurator',
      description:
        'Create a product configurator that automatically generates forms based on your products 🛠️',
    },
  },

  // Appointments
  appointments: {
    title: 'Appointments',
    refresh: 'Refresh',
    export: 'Export',
    filters: {
      status: 'Status',
      form: 'Form',
      all_statuses: 'All statuses',
      all_forms: 'All forms',
    },
    statuses: {
      booked: 'Booked',
      available: 'Available',
      unavailable: 'Unavailable',
      confirmed: 'Confirmed',
      pending: 'Pending',
      cancelled: 'Cancelled',
      completed: 'Completed',
    },
    default_title: 'Appointment',
    attendees: 'attendees',
    forms: {
      intake: 'Intake Form',
      demo: 'Demo Request',
      consultation: 'Consultation',
    },
    details: {
      date_time: 'Date & Time',
      status: 'Status',
      location: 'Location',
      description: 'Description',
      attendees: 'Attendees',
      calendar: 'Calendar',
      assigned_to: 'Assigned to',
      calendar_event: 'Calendar event',
    },
    location_types: {
      online: 'Online meeting',
      fixed: 'Fixed location',
      custom: 'Customer location',
    },
    actions: {
      restore: 'Restore',
      cancel: 'Cancel',
      view_in_calendar: 'View in calendar',
    },
    errors: {
      restore_failed: 'An error occurred while restoring the appointment.',
    },
  },

  planning_page: {
    revenue: {
      this_day: 'This day',
      this_week: 'This week',
      this_month: 'This month',
      avg_per_day: 'Avg. per day',
      excl_vat: 'excl. VAT',
    },
    helpers_busy: {
      title: 'Colleague not available',
      intro: '{technician} is free on {date} at {time}, but {helpers} is already booked that day:',
      intro_unassigned:
        'The job fits on {date} at {time}, but {helpers} is already booked that day:',
      with_technician: 'with {name}',
      option_without: 'Schedule without {helpers}',
      option_without_hint: 'Only {technician}, {range}',
      option_without_hint_moved: 'Only {technician}, {range} (next free time)',
      option_overlap: 'Schedule with {helpers} anyway',
      option_overlap_hint: 'Double booking for {helpers}, {range}',
      submit: 'Schedule',
      cancel: 'Cancel',
      ghost: 'Colleague busy: drop for options',
      toast_without: 'Scheduled at {time} without {helpers}',
      toast_overlap: 'Scheduled at {time}, overlapping for {helpers}',
    },
  },

  // Settings
  settings: {
    title: 'Settings',
    organization: 'Organization',
    profile: 'Profile',
    billing: 'Billing',
    team: 'Team',
    team_no_members: 'No team members yet. Invite someone to get started.',
    team_no_members_title: 'No team members',
    general: 'General',
    branding: 'Branding',
    notifications: 'Notifications',
    language: 'Language',
    language_description: 'Choose your preferred language for the dashboard interface.',
    save: 'Save Changes',
    saving: 'Saving...',
    saved: 'Settings saved successfully',
    // Proposal workflow
    proposal_workflow: 'Proposal workflow',
    proposal_workflow_direct: 'Direct',
    proposal_workflow_direct_description:
      'Standard workflow. Every proposal is immediately definitive.',
    proposal_workflow_measurement: 'With measurement',
    proposal_workflow_measurement_description:
      'Preliminary quote → Measurement → Definitive proposal.',
    price_deviation: {
      title: 'Price difference after measurement',
      mode_hold: 'Keep agreed price',
      mode_adjust_accept: 'Accept new price',
      mode_off: 'Off',
      help_hold:
        'If the definitive proposal comes out higher or lower within the margin, the customer total stays equal to the accepted preliminary proposal and the proposal is accepted automatically. You absorb the difference. Outside the margin the customer must approve again.',
      help_adjust_accept:
        'The definitive proposal gets the new price. If it is lower, or higher but within the margin, it is accepted automatically. For a larger increase the customer must approve again.',
      help_off: 'The customer always has to accept the definitive proposal again.',
      help_legacy:
        'Not set yet: your earlier auto-accept and commercial cap settings still apply. Pick an option to switch.',
      max_percent: 'Maximum difference',
      max_percent_help:
        'Compared with the accepted preliminary proposal. Only applies from preliminary to definitive; a re-measurement always needs customer approval.',
    },
    auto_win_deal: 'Automatically mark deal as won after definitive acceptance',
    send_proposal_pdf: 'Attach proposal as a PDF',
    send_proposal_pdf_title: 'Proposal PDF in the email',
    send_proposal_pdf_help:
      'Adds a PDF copy of the proposal to the email. Without the attachment, the client opens the proposal via the button in the email, so you can see when it has been viewed.',
    proposal_price_visibility: 'Price visibility on proposal',
    proposal_price_visibility_line_items: 'All line prices',
    proposal_price_visibility_main_products: 'Main product totals only',
    proposal_price_visibility_configuration_subtotals: 'Subtotal per configuration',
    proposal_price_visibility_grand_total: 'Grand total only',
    proposal_price_visibility_inherit: 'Organization default',
    planning: {
      tab: 'Planning',
    },
    appointment_email_notice: {
      title: 'Appointment confirmation',
      description:
        'This text appears in the email when an installation appointment is confirmed, rescheduled, or reminded. You can customize it per organization.',
      label: 'Appointment confirmation notice',
      variables: 'Available variables: [lead_first_name], [lead_last_name], [organization_name]',
    },
    deal_email: {
      label: 'Send mail from CRM',
      help: "Send proposals and deal emails from a FunnelFlow address (e.g. akogo{'@'}reply.funnelflow.nl) and log replies on the deal. Off by default. Requires an organization slug.",
    },
    sender_contact: {
      label: 'Sender photo and name under emails',
      help: 'Proposal emails always include a contact block with the sender photo and name. Put [handtekening_gebruiker] in the mail body to choose the position; without that variable the block sits above the buttons. This toggle does the same for other deal emails.',
      preview: 'This signature is added under the email.',
    },
    api_keys: {
      tab: 'API',
      title: 'Manage API keys',
      description:
        'Your API keys authenticate requests to FunnelFlow. Keep them secure and never share them publicly.',
      generate: 'Generate New API Key',
      name_label: 'Name',
      name_placeholder: 'e.g. Ads Hub',
      create: 'Create key',
      create_modal_title: 'New API key',
      create_modal_help:
        'Give the key a recognizable name, for example the integration you will use it with.',
      loading: 'Loading keys…',
      empty_title: 'No API keys yet',
      empty_description: 'Generate a key to connect external systems.',
      status_active: 'Active',
      status_revoked: 'Revoked',
      created_at: 'Created',
      last_used_at: 'Last Used',
      revoked_at: 'Revoked',
      show_revoked: 'Show revoked keys',
      revoke: 'Revoke',
      revoke_title: 'Revoke API key?',
      revoke_description:
        'Key “{name}” will stop working immediately. Integrations using this key will fail.',
      cancel: 'Cancel',
      done: 'Done',
      copy: 'Copy to clipboard',
      copied_clipboard: 'Copied to clipboard',
      copy_failed: 'Copy failed',
      toggle_visibility: 'Show / hide',
      copy_once_help:
        'Copy the key to your clipboard now. This is the only time the full key is shown.',
      create_success: 'API key created',
      create_failed: 'Failed to create API key',
      fetch_failed: 'Failed to load API keys',
      revoke_success: 'API key revoked',
      revoke_failed: 'Failed to revoke API key',
    },
    planning_work_time: {
      title: 'Planning work hours',
      description:
        'Default work hours for route planning and bulk scheduling. Technicians are scheduled within these windows.',
      workday_start: 'Workday start',
      workday_end: 'Workday end',
      break_minutes: 'Break between jobs (min)',
      timezone: 'Timezone',
    },
    planning_customer: {
      title: 'Customer communication (planning)',
      description:
        'What the customer automatically receives around the order and the appointment. Everything is off by default; enable only what fits your workflow.',
      order_confirmation: {
        label: 'Order confirmation after a definitive quote is accepted',
        help: 'Replaces the default "your signed proposal" email. The customer receives the specifications, the total amount and the signed quote as PDF.',
        intro_label: 'Order confirmation intro text',
        intro_help: 'Shown at the top of the email, above the specifications.',
      },
      preference: {
        label: 'Customer may share a planning preference',
        help: 'Adds a "Share your preference" button to the order confirmation. The customer only picks preferred weekdays and dayparts (soft); you stay in control.',
      },
      handshake: {
        label: 'Send tentative appointments to the customer for confirmation',
        help: 'For a tentative appointment the customer receives "Does this suit you?" with Accept / Decline. Declining never changes anything automatically; the work order moves to the top of the call list.',
        silent_accept_hours: 'Auto-accept after (hours)',
        silent_accept_help:
          'No reply within this time = appointment confirmed and the regular confirmation email is sent. 0 = never auto-confirm.',
      },
    },
    // Weekly digest email (per user × organization)
    weekly_digest: {
      page_title: 'Notifications',
      page_description: 'Manage which email notifications you receive per organization.',
      section_title: 'Weekly digest',
      intro:
        'The weekly digest is sent every Monday morning and includes KPIs, forecast, funnel and open proposals. You configure it separately for each organization.',
      toggle_label: 'Receive the weekly digest by email',
      helper:
        'Every Monday morning you receive an email with KPIs, funnel and open proposals for {orgName}. Only for this organization.',
      current_org_badge: 'Current organization',
      switch_to_edit: 'Switch to this organization to change the setting.',
      switch_action: 'Switch & edit',
      super_admin_note: 'Super admins do not receive the weekly digest.',
      status_on: 'On',
      status_off: 'Off',
      save_success: 'Notification setting updated',
      save_error: 'Failed to update notification setting',
      load_error: 'Could not load notification settings',
      switch_success: 'Switched to {orgName}',
      switch_error: 'Failed to switch organization',
      empty: 'You are not a member of any organization yet.',
      roles: {
        owner: 'Owner',
        admin: 'Admin',
        member: 'Member',
        installer: 'Installer',
        super_admin: 'Super admin',
      },
    },
    // Configurator settings tabs
    tabs: {
      appearance: 'Appearance',
      behaviour: 'Behaviour',
      notifications: 'Notifications',
      language: 'Language',
      parameters: 'Parameters',
      products: 'Products',
      design: 'Design',
      tools: 'Tools',
    },
    forecast: {
      title: 'Forecast & targets',
      description:
        'Set an annual revenue target and choose how it gets distributed across the months',
      year_label: 'Year',
      target_configured: 'Target configured',
      no_target_for_year: 'No target configured for this year yet',
      annual_target_card: 'Revenue target',
      annual_target_help:
        'Set the expected revenue target for this year. The amount is distributed across the months according to the chosen strategy.',
      annual_target_label: 'Annual target {year} (excl. VAT)',
      annual_target_info: 'The amount you expect to sell in {year} — excluding VAT',
      notes_label: 'Note (optional)',
      distribution_card: 'Monthly distribution',
      distribution_help:
        'Decide how the annual target is spread across the twelve months. A seasonal benchmark works well for most industries; your own historical data is always more accurate.',
      strategy: {
        benchmark: {
          title: 'Based on seasonal benchmark',
          description: 'Use a SmartFlow-curated pattern that fits your industry',
          dropdown_label: 'Industry',
        },
        historical: {
          title: 'Based on your historical data',
          description: 'Compute the distribution from your own accepted proposals (last 24 months)',
          fallback:
            '{available} months of data available — build {needed} more months to use your own pattern. Until then the system falls back to the benchmark.',
        },
        custom: {
          title: 'Custom monthly distribution',
          description:
            "Provide a percentage per month. The total doesn't need to be exactly 100% — we normalise.",
          total_label: 'Total',
          normalisation_hint: '(automatically rescaled to 100%)',
        },
        flat: {
          title: 'Flat (1/12 per month)',
          description: 'Distribute the annual target equally over every month',
        },
      },
      preview_card: 'Preview distribution',
      preview_set_target_first: 'Set an annual target to see the distribution',
      preview_save_for_historical: 'Save the target once to preview the historical distribution',
      preview_peak: 'Peak month',
      preview_low: 'Lowest month',
      preview_pattern: 'Pattern used',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      delete_confirm_title: 'Delete target?',
      delete_confirm_description:
        'This will remove the revenue target for {year}. The dashboard will fall back to an empty state until you configure a new target.',
      toast: {
        saved: 'Revenue target saved',
        deleted: 'Revenue target deleted',
      },
      errors: {
        load_failed: 'Could not load revenue target',
        save_failed: 'Save failed — please try again',
        delete_failed: 'Delete failed',
      },
      manual_revenue: {
        card_title: 'Historical revenue',
        help: 'Add sold revenue from before Funnelflow (excl. VAT). This counts toward Sold and the forecast on the dashboard — no invoices are created.',
        note_label: 'Note (optional)',
        total_label: 'Manual total',
        save: 'Save historical revenue',
        toast: {
          saved: 'Historical revenue saved',
        },
        errors: {
          load_failed: 'Could not load historical revenue',
          save_failed: 'Failed to save historical revenue',
        },
      },
    },
  },

  // Common UI Elements
  common: {
    session_access_revoked:
      'Your access to this organization has been revoked. Please contact your administrator.',
    session_account_not_provisioned:
      'Your account is not fully set up yet. Please contact your administrator.',
    organization_suspended: {
      title: 'This account is suspended',
      body: 'This organization is temporarily blocked. If this is a mistake, contact support at {email}.',
      cta: 'Contact support',
      mail_subject: 'Account suspended',
    },
    anonymous_read_only: 'Anonymous mode is view-only. Turn it off to make changes.',
    add: 'Add',
    save: 'Save',
    save_changes: 'Save changes',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    create: 'Create',
    creating: 'Creating...',
    update: 'Update',
    close: 'Close',
    copy: 'Copy',
    copied: 'Copied',
    copied_to_clipboard: 'Copied to clipboard',
    clear_selection: 'Clear selection',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    open_full_page: 'Open Full Page',
    page_of: 'Page {current} of {total}',
    minutes: 'min',
    loading: 'Loading...',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    actions: 'Actions',
    name: 'Name',
    description: 'Description',
    created: 'Created',
    updated: 'Updated',
    status: 'Status',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    updated_at: 'Updated at',
    created_at: 'Created at',
    pull_to_refresh: 'Pull to refresh',
    release_to_refresh: 'Release to refresh',
    refreshing: 'Refreshing...',
    refresh: 'Refresh',
    add_image: 'Add image',
    remove: 'Remove',
    of: 'of',
    // Time related
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    just_now: 'Just now',
    hours_ago: '{count} hours ago',
    days_ago: '{count} days ago',
  },

  builder: {
    base: 'Base',
    label: 'Label',
    caption: 'Caption',
    answer_required: 'Answer is required',
    default_value: 'Default value',
  },

  // Scheduling Settings
  scheduling: {
    // Section headers
    calendar_settings: 'Calendar settings',
    round_robin: 'Round Robin',
    locations: 'Locations',
    meeting_settings: 'Meeting settings',
    // Round Robin
    enable_round_robin: 'Enable Round Robin',
    round_robin_description: 'Distribute appointments automatically across multiple team members.',
    team_members: 'Team Members',
    add_member: 'Add Member',
    no_team_members: 'No team members added yet. Add a Google Calendar integration to get started.',
    display_name: 'Display name',
    calendar: 'Calendar',
    available_at_locations: 'Available at locations:',
    custom_working_hours: 'Custom working hours',
    default_availability: 'Default availability',
    // Locations
    locations_description:
      'Define where appointments can take place. Team members can be assigned to specific locations.',
    choose_location_type: 'Choose a location type',
    name_this_location: 'Name this location',
    your_locations: 'Your locations',
    unnamed_location: 'Unnamed location',
    add_location: 'Add Location',
    add_location_fixed: 'Add fixed address location',
    add_location_custom: 'Add home visit',
    add_location_online: 'Add online location',
    no_locations:
      'No locations defined. Appointments will be scheduled without location selection.',
    location_name: 'Location name',
    location_type: 'Type',
    location_address: 'Address',
    require_location_selection: 'Require location selection',
    location_types: {
      fixed: 'Fixed address',
      fixed_description: 'At your own address, such as a showroom or office',
      online: 'Online meeting',
      online_description: 'Video appointment',
      custom: 'Home visit',
      custom_description: 'You visit the client at their address',
    },
    location_type_already_added:
      'This type already exists in this form. Want to offer another department or appointment type? Create a separate form.',
    service_regions: 'Service areas',
    service_regions_hint:
      'PC2 regions where this location offers home visits. Nothing selected means nationwide.',
    member_service_regions: 'Service areas',
    member_service_regions_hint:
      'No areas selected means this team member does not participate for this location. You can use the location areas or add extra PC2 regions.',
    edit_service_regions: 'Choose service areas',
    service_regions_nationwide: 'Nationwide',
    member_service_regions_nationwide_hint:
      'This location has no service areas yet, so this team member works nationwide. Pick areas to restrict the team member.',
    service_regions_none: 'No service areas selected',
    service_regions_summary: '{count} service areas selected',
    service_regions_search: 'Search',
    service_regions_search_placeholder: 'Search by code or place name',
    service_regions_select_all: 'Select all',
    service_regions_clear_all: 'Clear all',
    service_regions_no_results: 'No regions found.',
    service_regions_selected_count: '{count} selected',
    service_regions_save: 'Save',
    calendar_link: 'Calendar connection',
    multiple_calendars: 'Multiple calendars (round robin)',
    single_calendar_description: 'All appointments are booked in one calendar.',
    select_agenda: 'Select calendar',
    add: 'Add',
    unnamed: 'Unnamed',
    remove: 'Remove',
    per_location: 'Per location',
    per_location_hours: 'Different working hours per location',
    use_location_hours: 'Use location opening hours',
    copy_location_hours: 'Copy location opening hours as a starting point',
    location_hours: 'Location',
    slot_settings: 'Slot settings',
    appointment_length: 'Appointment length',
    buffer_before: 'Buffer before appointment',
    buffer_after: 'Buffer after appointment',
    minimum_advance: 'Minimum notice before booking',
    minimum_advance_hint:
      'How far ahead must an appointment be booked? At 24 hours, customers can only book for the day after tomorrow or later.',
    until: 'to',
    opening_hours: 'Opening hours',
    opening_hours_hint:
      'When this location is open. These hours are the basis for availability per calendar.',
    location_name_placeholder: 'e.g. Showroom, Online, At the customer',
    location_name_required: 'Give this location a name',
    no_calendar_integration:
      'No calendar integration (Google or Outlook) is active for this form. Enable an integration first.',
    none: 'None',
    no_buffer: 'No buffer',
    minutes: '{count} minutes',
    hour: '{count} hour',
    hours: '{count} hours',
    one_day: '1 day (24 hours)',
    days: '{count} days ({hours} hours)',
    one_week: '1 week (168 hours)',
    meeting_title: 'Appointment title',
    meeting_body: 'Appointment text in the calendar',
    add_meet_link: 'Add Google Meet link',
    add_address_to_meeting: 'Add address to the appointment',
    meeting_address: 'Appointment address',
    meeting_address_placeholder: 'Enter an address or choose an address field...',
    weekdays: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    // Address fields
    address: {
      search: 'Location address',
      search_placeholder: 'Search by street, house number or postcode',
      searching: 'Searching...',
      no_results: 'No address found. Try street and house number or the postcode.',
      required: 'Pick an address from the list',
      selected: 'Selected:',
      clear: 'Clear address',
      manual_entry: 'Enter manually',
      street: 'Street',
      number: 'Number',
      postal_code: 'Postal code',
      city: 'City',
      country: 'Country',
    },
    // Legacy/Single calendar
    select_calendar: 'Select calendar integration',
    no_calendar_warning:
      'No Google Calendar integration is currently enabled for this form. Please enable it first or create one.',
    setup_modal_title: 'Connect a calendar',
    setup_modal_description:
      'Choose an existing calendar integration and select the calendar for this scheduler field.',
    setup_select_integration: 'Google integration',
    setup_select_calendar: 'Calendar',
    setup_select_calendar_placeholder: 'Choose a calendar...',
    setup_no_integrations:
      'You have not connected a calendar yet. Add one using the link below.',
    setup_not_connected:
      'This integration is not connected yet. Open integration settings to connect.',
    setup_open_integration_settings: 'Open integration settings',
    setup_loading_calendars: 'Loading calendars...',
    setup_integration_required: 'Select a calendar integration.',
    setup_calendar_required: 'Select a calendar.',
    setup_save: 'Create',
    setup_save_failed: 'Could not save the calendar link. Please try again.',
    setup_load_integrations_failed: 'Could not load integrations.',
    setup_load_calendars_failed: 'Could not load calendars. Check the connection.',
    setup_create_integration_title: 'Add Google Calendar integration',
    setup_create_integration_description:
      'Connect Google and choose the calendar you want to use for appointments.',
    setup_edit_integration_title: 'Edit integration {name}',
    setup_integration_name: 'Integration name',
    setup_integration_name_placeholder: 'E.g. Amsterdam calendar',
    setup_add_calendar_link: 'Add calendar',
    setup_choose_provider: 'Choose which calendar you want to connect.',
    setup_popup_blocked: 'The popup was blocked. Allow popups and try again.',
    setup_outlook_unavailable: 'Outlook is temporarily unavailable.',
    setup_back: 'Back',
    setup_connect_failed: 'Could not connect the calendar. Please try again.',
    setup_connect_success: '{name} is connected.',
    setup_edit_integration_description: 'Connect Google and select the correct calendar.',
  },

  // Error Messages
  errors: {
    generic: 'Something went wrong. Please try again.',
    network: 'Network error. Please check your connection.',
    unauthorized: 'You are not authorized to perform this action.',
    not_found: 'The requested resource was not found.',
    validation: 'Please check your input and try again.',
    required_field: 'This field is required',
    invalid_email: 'Please enter a valid email address',
    password_too_short: 'Password must be at least 8 characters',
    language_update_failed: 'Failed to update language. Please try again.',
  },

  // Success Messages
  success: {
    saved: 'Changes saved successfully',
    created: 'Created successfully',
    updated: 'Updated successfully',
    deleted: 'Deleted successfully',
    language_updated: 'Language updated successfully',
  },

  // Confirmation Messages
  confirmations: {
    delete: 'Are you sure you want to delete this item?',
    unsaved_changes_title: 'Are you sure?',
    unsaved_changes_leave: 'Leave page',
    unsaved_changes_stay: 'Keep editing',
    unsaved_changes: 'You have unsaved changes. Are you sure you want to leave?',
  },

  // Date & Time
  date: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    this_week: 'This week',
    this_month: 'This month',
    last_month: 'Last month',
    just_now: 'Just now',
    hours_ago: '{count} hours ago',
    days_ago: '{count} days ago',
    formats: {
      short: 'MM/DD/YYYY',
      long: 'MMMM D, YYYY',
      time: 'h:mm A',
      datetime: 'MM/DD/YYYY h:mm A',
    },
  },

  conditions: {
    when_statement_true: 'When the following statement is true',
    when: 'When',
    all: 'ALL',
    any: 'ANY',
    of_following_true: 'of the following are true',
    where: 'Where',
    select_field: 'Select field',
    equals: 'Equals',
    not_equals: 'Not equals',
    greater_than: 'Greater than',
    greater_or_equal: 'Greater or equal',
    less_than: 'Less than',
    less_or_equal: 'Less or equal',
    select_value: 'Select value',
    true: 'True',
    false: 'False',
    enter_number: 'Enter number',
    enter_value: 'Enter value',
    add_filter: 'Add filter',
    add_group: 'Add group',
  },

  // Authentication
  auth: {
    welcome_back: 'Welcome back!',
    login_subtitle: 'Sign in to continue with your leads, deals and proposals.',
    or: 'or',
    google_sign_in: 'Sign in with Google',
    google_connect_calendar: 'Connect Google Calendar',
    google_connected: 'Connected with Google',
    google_disconnect: 'Disconnect',
    showcase_configurator_title: 'Customers configure their own product',
    showcase_configurator_description:
      'Your customer sees a price estimate right away and you receive a complete request.',
    showcase_pipeline_title: 'Every request clearly in one overview',
    showcase_pipeline_description:
      'See per stage which requests need attention and who is working on them.',
    showcase_proposals_title: 'All your proposals in one overview',
    showcase_proposals_description:
      'See instantly which proposals were viewed, accepted or not opened yet.',
    showcase_planning_title: 'Measurements and installations in one calendar',
    showcase_planning_description:
      'Schedule your installers per week and see how much revenue is planned.',
    showcase_pro_forma_title: 'From pro forma to final without retyping',
    showcase_pro_forma_description:
      'After measuring, create the final proposal in one click, with the real sizes and a recalculated price.',
    showcase_work_order_title: 'Your installer knows exactly what to do',
    showcase_work_order_description:
      'Planning, address and packing slip on one work order. Your customer gets an automatic update.',
    no_account: 'No account yet?',
    create_account: 'Create one today!',
    email: 'Email',
    password: 'Password',
    forgot_password: 'Forgot password?',
    sign_in: 'Sign in',
    login_error_title: 'Login failed',
    login_error_description: 'Cannot login. Please try again.',
    no_organization_title: 'No access',
    no_organization_description:
      'Your account is no longer linked to an organization. Please contact your administrator.',
    accept_invite_success_title: 'Success!',
    accept_invite_success_description: 'You have successfully joined the organization.',
    accept_invite_failed_title: 'Could not accept invitation',
    accept_invite_failed_description:
      'Something went wrong accepting the invitation. Please try again.',
    accept_invite_email_mismatch:
      'This invitation is for a different email address. Please log in with the account it was sent to.',
    reset_email_required_title: 'Email required',
    reset_email_required_description: 'Enter your email to reset your password.',
    reset_rate_limit_title: 'Too many attempts',
    reset_rate_limit_description: 'Please wait a few minutes before trying again.',
    reset_error_title: 'Error',
    reset_error_description: 'Cannot reset password. Please check your email and try again.',
    reset_sent_title: 'Reset link sent',
    reset_sent_description:
      "Check your email to reset your password. If you don't see it, check your spam folder.",
  },

  // Invoices
  invoices: {
    title: 'Invoices',
    description: 'Manage all your invoices, payments and credit notes in one place.',
    tabs: {
      drafts: 'Drafts',
    },
    add_invoice: 'Create invoice',
    untitled: 'Invoice',
    due: 'Due',
    overdue_by_day: '{n} day overdue',
    overdue_by_days: '{n} days overdue',
    search_placeholder: 'Search by invoice number or customer…',
    search_no_results: 'No results found',
    search_no_results_description: 'Try a different search or clear the filters.',
    no_more_results: 'All invoices loaded',
    stats_toggle: 'Statistics',
    bulk_delete: 'Delete selected ({count})',
    bulk_delete_no_drafts: 'Only drafts can be deleted.',
    bulk_delete_title: 'Delete selected drafts',
    bulk_delete_confirmation: 'Are you sure you want to delete {count} draft invoice(s)?',
    bulk_delete_skipped: 'Non-drafts ({count}) will be skipped.',
    bulk_delete_success: '{count} invoice(s) deleted.',
    bulk_delete_partial_failure: '{count} invoice(s) could not be deleted.',
    bulk_delete_error: 'Bulk delete failed.',
    bulk_remind: 'Send reminder ({count})',
    bulk_remind_title: 'Send reminder',
    bulk_remind_confirmation: 'Send a payment reminder for {count} invoice(s)?',
    bulk_remind_skipped: 'Non-remindable invoices ({count}) will be skipped.',
    bulk_remind_success: 'Reminder sent for {count} invoice(s).',
    bulk_remind_partial_failure: '{count} reminder(s) could not be sent.',
    bulk_remind_error: 'Failed to send reminders.',
    bulk_remind_none: 'Select open invoices to send a reminder.',
    remind_title: 'Send reminder',
    remind_confirmation: 'Send a payment reminder for invoice {number}?',
    remind_success: 'Reminder sent.',
    remind_error: 'Failed to send reminder.',
    remind_no_email: 'This invoice has no email address.',
    remind_no_balance: 'This invoice has no outstanding balance.',

    statuses: {
      draft: 'Draft',
      sending: 'Sending',
      sent: 'Sent',
      viewed: 'Viewed',
      partially_paid: 'Partially paid',
      paid: 'Paid',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
      credit_note_issued: 'Credit note issued',
    },

    types: {
      full: 'Full',
      deposit: 'Deposit',
      partial: 'Partial',
      final: 'Final',
      credit_note: 'Credit note',
      proforma: 'Proforma',
    },

    columns: {
      number: 'Number',
      type: 'Type',
      status: 'Status',
      customer: 'Customer',
      invoice_date: 'Invoice date',
      due_date: 'Due date',
      amount: 'Amount',
      balance_due: 'Balance due',
    },

    filter: {
      status: 'Status',
      type: 'Type',
      all: 'All',
      open: 'Outstanding',
      other: 'Other',
      filter_by_status: 'Filter by status',
      filter_by_type: 'Filter by type',
      reset: 'Reset',
      types_short: {
        full: 'Invoice',
        deposit: 'Deposit',
        partial: 'Partial',
        final: 'Final',
        credit_note: 'Credit',
        proforma: 'Proforma',
      },
    },

    stats: {
      total_invoiced: 'Total invoiced',
      total_paid: 'Total paid',
      total_outstanding: 'Outstanding',
      total_overdue: 'Overdue',
      total_to_refund: 'To refund',
      avg_days_to_paid: 'Avg. days to paid',
    },

    empty_state: {
      title: 'No invoices yet',
      description: 'Create your first invoice to get started.',
    },

    create: {
      title: 'Create invoice',
      lead: 'Customer',
      select_lead: 'Select a customer',
      lead_required: 'Please select a customer.',
      project: 'Project',
      select_project: 'Select a project',
      project_required: 'Please select a project first.',
      no_projects_for_lead: 'This customer has no active projects yet.',
      billable_items: 'Items to invoice',
      items_summary: '{available} of {total} items available',
      no_billable_items: 'No items to invoice for this project.',
      already_billed_in: 'Already billed in {number}',
      billable_items_error: 'Could not load billable items.',
      additional_items: 'Additional lines',
      additional_items_hint: 'Only discounts, surcharges or text lines are allowed.',
      add_additional: 'Add line',
      additional_type: 'Type',
      types: {
        discount: 'Discount',
        surcharge: 'Surcharge',
        text: 'Text',
      },
      invoice_type: 'Type',
      currency: 'Currency',
      invoice_date: 'Invoice date',
      due_date: 'Due date',
      customer_reference: 'Your reference',
      customer_reference_placeholder: 'e.g. PO-00297',
      items: 'Line items',
      items_required: 'Select at least one item or add an additional line.',
      client_notes: 'Notes for customer',
      client_notes_placeholder: 'Optional notes that will appear on the invoice…',
      internal_notes: 'Internal notes',
      internal_notes_placeholder: 'Not visible to the customer…',
      create_invoice: 'Create invoice',
      success: 'Invoice created successfully.',
      error: 'Could not create invoice.',
      errors: {
        project_required: 'Please select a project first.',
        item_already_billed:
          'One or more items have already been billed. The list has been refreshed — please try again.',
      },
    },

    merge: {
      title: 'Merge drafts',
      button: 'Merge ({count})',
      intro: 'Combine multiple draft invoices for the same customer into one new draft invoice.',
      lead: 'Customer',
      submit: 'Merge ({count})',
      no_drafts: 'No mergeable draft invoices for this customer.',
      load_error: 'Could not load drafts.',
      success: 'Draft invoices merged.',
      error: 'Merge failed.',
      different_leads: 'Please only select drafts from the same customer.',
    },

    detail: {
      title: 'Invoice',
      hidden_line_badge: 'Hidden',
      hidden_line_hint:
        'This amount is billed, but not as its own line: it is folded into the price of the first product with the same VAT rate on the invoice PDF and the payment page.',
      not_found: 'Invoice not found',
      not_found_description: 'This invoice does not exist or you do not have access.',
      load_error: 'Could not load invoice.',
      download_pdf: 'Download PDF',
      send: 'Send',
      resend: 'Resend',
      send_reminder: 'Send reminder',
      record_payment: 'Record payment',
      mark_sent: 'Mark as sent',
      mark_paid: 'Mark as paid',
      marked_sent: 'Invoice marked as sent.',
      change_status: 'Change status',
      extra: 'More',
      view_online: 'View online',
      view_project: 'View project',
      view_proposal: 'View proposal',
      public_url_unavailable: 'No public link available for this invoice.',
      edit: 'Edit',
      edit_not_implemented: 'Editing is not yet available.',
      credit_note: 'Issue credit note',
      delete: 'Delete',
      delete_title: 'Delete draft',
      delete_description: 'Are you sure you want to delete this draft?',
      deleted: 'Draft deleted.',
      delete_error: 'Delete failed.',
      cancel_invoice: 'Cancel invoice',
      cancel_title: 'Cancel invoice',
      cancel_description: 'Are you sure you want to cancel this invoice?',
      cancel_reason_label: 'Reason',
      cancel_reason_placeholder: 'Optional reason…',
      cancelled: 'Invoice cancelled.',
      cancel_error: 'Could not cancel invoice.',
      cancellation_reason: 'Cancellation reason',
      has_credit_note: 'Has credit note',
      credits_invoice: 'Credits invoice',
      locked: 'This invoice is locked and can no longer be edited.',
      total: 'Total',
      balance_due: 'Balance due',
      days_until_due: 'days until due',
      days_overdue: 'days overdue',
      customer: 'Customer details',
      customer_name: 'Name',
      company: 'Company',
      kvk: 'CoC',
      vat_number: 'VAT number',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      vat_reverse_charge: 'VAT reverse charge',
      items: 'Line items',
      totals: 'Totals',
      vat: 'VAT',
      discount: 'Discount',
      deposit_deduction: 'Deposit deducted',
      client_notes: 'Customer notes',
      internal_notes: 'Internal notes',
      internal_notes_placeholder: 'Not visible to the customer…',
      no_internal_notes: 'No notes',
      notes_saved: 'Notes saved.',
      dates_saved: 'Dates saved.',
      payment_terms: 'Payment terms',
      payment_term_label: 'Payment term (days)',
      days_unit: 'days',
      info: 'Invoice info',
      invoice_number: 'Invoice number',
      invoice_date: 'Invoice date',
      due_date: 'Due date',
      customer_reference: 'Your reference',
      no_customer_reference: 'No reference',
      customer_reference_saved: 'Reference saved.',
      price_visibility: 'Customer price display',
      price_visibility_inherit: 'Same as proposal',
      price_visibility_line_items: 'All line prices',
      price_visibility_main_products: 'Main product totals only',
      price_visibility_configuration_subtotals: 'Subtotal per configuration',
      price_visibility_grand_total: 'Grand total only',
      price_visibility_saved: 'Price display saved.',
      price_visibility_save_failed: 'Could not save price display.',
      price_visibility_internal_hint: 'You see all prices here. The customer sees: {mode}.',
      sent_at: 'Sent at',
      viewed_at: 'Viewed at',
      paid_at: 'Paid at',
      project: 'Project',
      proposal: 'Proposal',
      payments: 'Payments',
      history: 'Status history',
      activities: 'Activity',
      activity: {
        created: 'Draft created',
        sent: 'Sent to customer',
        viewed: 'Viewed by customer',
        payment_received: 'Payment received ({amount})',
        paid: 'Fully paid',
        cancelled: 'Cancelled',
        credit_note_issued: 'Credit note issued',
        reminder_sent: 'Reminder sent to {recipient}',
        reminder_sent_generic: 'Reminder sent',
        reminder_sent_count: '{count} reminders sent',
      },
      reminders: 'Reminders',
      reminders_sent: 'Reminders sent',
      last_reminder: 'Last reminder',
      pdf_error: 'Could not download PDF.',
      to: 'To',
      notes_label: 'Notes',
      total_due: 'Total due',
      transfer_to: 'Transfer to',
      payment_reference: 'Reference',
      pay_before: 'Pay before',
      reference_subtitle: 'Invoice reference',
      payment_term_days: 'Payment term {days} days',
      account_holder: 'Account holder: {name}',
    },

    editor: {
      description: 'Description',
      description_placeholder: 'e.g. Solar panel installation',
      quantity: 'Qty',
      unit_price: 'Unit price',
      vat_rate: 'VAT',
      line_total: 'Line total',
      no_items: 'No line items added yet.',
      add_line: 'Add line',
      subtotal_excl_vat: 'Subtotal excl. VAT',
      vat_amount: 'VAT',
      total: 'Total incl. VAT',
      prices_include_vat: 'Prices include VAT',
    },

    payments: {
      record_payment: 'Record payment',
      invoice_number: 'Invoice number',
      total_amount: 'Invoice amount',
      already_paid: 'Already paid',
      balance_due: 'Balance due',
      amount: 'Amount',
      amount_required: 'Please enter a valid amount.',
      payment_date: 'Payment date',
      payment_method: 'Payment method',
      reference: 'Reference',
      reference_placeholder: 'e.g. transaction id',
      notes: 'Notes',
      notes_placeholder: 'Optional notes…',
      full_balance: 'Fill outstanding amount',
      success: 'Payment recorded.',
      error: 'Could not record payment.',
      delete: 'Delete payment',
      delete_title: 'Delete payment',
      delete_description: 'Are you sure you want to delete the payment of {amount}?',
      deleted: 'Payment deleted.',
      empty: 'No payments recorded yet.',
      methods: {
        bank_transfer: 'Bank transfer',
        cash: 'Cash',
        card: 'Card',
        mollie_ideal: 'iDEAL (Mollie)',
        mollie_qr: 'QR (Mollie)',
        mollie_pos: 'POS (Mollie)',
        mollie_other: 'Mollie',
        other: 'Other',
        credit_note: 'Settled with credit note',
      },
    },

    send: {
      title: 'Send invoice',
      intro: 'Send invoice {number} via email.',
      resend_intro:
        'Send invoice {number} again using the original invoice email. The status stays unchanged.',
      resent_success: 'Invoice is being resent.',
      to: 'To',
      to_placeholder: "customer{'@'}example.com",
      subject: 'Subject',
      subject_placeholder: 'Leave empty for the default subject',
      message: 'Message',
      message_placeholder: 'Leave empty for the default text',
      message_hint:
        'Your message replaces the default text. The "View invoice" and "Pay now" buttons are always added.',
      bcc_hint: 'BCC to {emails} (invoicing settings)',
      review: 'Review and send',
      preview_failed: 'Could not load the preview',
      number_pending: 'The invoice number is assigned when sending.',
      invoice_pdf_badge: 'Invoice',
      invoice_pdf_pending: 'generated when sending',
      default_attachment_badge: 'Default',
      submit: 'Send',
      success: 'Invoice sent.',
      error: 'Sending failed — please try again.',
      sending: 'Sending invoice…',
      pending_banner: 'Invoice is being sent — this usually takes a few seconds.',
      taking_longer: 'Sending is taking longer than expected. Check the invoice status later.',
      status_unknown: 'Could not retrieve sending status.',
    },

    credit_note: {
      title: 'Issue credit note',
      intro: 'Issue a credit note for invoice {number}.',
      reason: 'Reason',
      reason_placeholder: 'Provide a reason for the credit note…',
      full: 'Full credit note',
      full_description: 'Credit the entire amount of this invoice.',
      partial: 'Partial credit note',
      partial_description: 'Credit specific lines or amounts.',
      items: 'Items to credit',
      reason_required: 'Enter a reason for the credit note.',
      items_required: 'Add at least one line with a description and quantity.',
      project_effect: 'What happens to the project?',
      reinvoice: 'Invoice again',
      reinvoice_description:
        'The credited amount stays open on the project so you can invoice it again.',
      write_off: 'Write off on the project',
      write_off_description:
        'This amount will not be invoiced again (e.g. already billed in another system). The project total drops with it, so it does not return under "Remaining to invoice".',
      create: 'Create credit note',
      send_email: 'Email credit note to {email}',
      issued_immediately:
        'The credit note gets a number right away and is final. The invoice will no longer show as open.',
      success: 'Credit note {number} issued.',
      success_sent: 'Credit note {number} issued and being sent.',
      success_email_failed:
        'Credit note {number} was issued, but the email could not be sent. Send it again later.',
      error: 'Could not create credit note.',
      negative_invoice:
        'An invoice cannot have a negative total. Use "Credit" on the original invoice instead.',
    },

    email_warning: {
      short: 'Email not delivered',
      banner: 'The email with this invoice did not reach the customer.',
      resend: 'Send again',
    },

    deposit: {
      title: 'Create deposit invoice',
      intro: 'Create a deposit invoice for this project.',
      use_settings: 'Use settings',
      use_settings_description: 'Use the default deposit configured in organization settings.',
      percentage: 'Percentage',
      percentage_description: 'Specify a percentage of the project amount.',
      percentage_label: 'Percentage (%)',
      amount: 'Fixed amount',
      amount_description: 'Specify a fixed amount.',
      amount_label: 'Amount',
      create: 'Create deposit invoice',
      success: 'Deposit invoice created.',
      error: 'Could not create deposit invoice.',
    },

    project_summary: {
      title: 'Invoicing',
      create_invoice: 'Create invoice',
      deposit: 'Deposit invoice',
      deposit_description: 'Request a deposit before work starts.',
      final: 'Final invoice',
      final_description: 'Close out the project with a final invoice.',
      custom: 'Custom invoice',
      custom_description: 'Manually create an invoice for this project.',
      project_total: 'Project total',
      provisional_project_total: 'Provisional project total',
      provisional_project_total_hint: 'Based on the preliminary quote.',
      proforma_zero_hint: 'Preliminary quote, so €0.',
      written_off_hint: 'After writing off {amount}',
      over_invoiced_hint: '{amount} invoiced too much',
      write_off: 'Write off amount',
      write_off_description: 'Write off (part of) the remainder, e.g. paid in cash.',
      write_off_title: 'Write off amount',
      write_off_intro:
        'The written-off amount is deducted from the project total and will not be invoiced.',
      write_off_amount_label: 'Amount (incl. VAT)',
      write_off_amount_hint: 'Left to invoice: {amount} incl. VAT',
      write_off_amount_invalid: 'Enter an amount greater than € 0.',
      write_off_amount_too_high: 'You can write off at most {amount} incl. VAT.',
      write_off_result_full:
        'The full remainder of {amount} incl. VAT will be written off. Nothing is left to invoice.',
      write_off_result_partial:
        '{amount} incl. VAT will be written off. The remaining {rest} incl. VAT can still be invoiced later.',
      write_off_reason_label: 'Reason',
      write_off_reason_placeholder: 'E.g. paid in cash',
      write_off_submit: 'Write off',
      write_off_success: 'Amount written off.',
      excl_vat: 'excl. VAT',
      incl_vat: 'incl. VAT',
      invoiced: 'Invoiced',
      paid: 'Paid',
      outstanding: 'Outstanding',
      remaining_to_invoice: 'Remaining to invoice',
      paid_short: 'Paid',
      empty: 'No invoices yet',
      empty_description: 'Create a deposit or final invoice to get started.',
      cannot_create_final: 'Final invoice cannot be created yet.',
      create_final_title: 'Create final invoice',
      create_final_description:
        'The final invoice will be created based on the project total minus previously invoiced amounts.',
      create_final: 'Create final invoice',
      final_created: 'Final invoice created.',
    },

    public: {
      invoice: 'Invoice',
      number: 'Invoice number',
      date: 'Date',
      due_date: 'Due date',
      bill_to: 'Bill to',
      vat_reverse_charge: 'VAT reverse charge',
      notes: 'Notes',
      payment_instructions: 'Payment instructions',
      not_found: 'Invoice not found',
      not_found_description: 'This link has expired or the invoice is no longer available.',
    },

    settings: {
      title: 'Invoicing settings',
      description: 'Manage how invoices are created, numbered and sent.',
      numbering: 'Invoice numbering',
      numbering_description:
        'Configure how new invoice numbers are generated. Sequence numbers continue when settings change.',
      numbering_preview: 'Preview:',
      invoice_number_prefix: 'Prefix',
      invoice_number_prefix_placeholder: 'F',
      invoice_number_prefix_help: 'E.g. F, INV, or leave empty for no prefix.',
      invoice_number_padding: 'Number of digits',
      invoice_number_padding_help: '4 = 0001, 6 = 000001. Between 1 and 10.',
      invoice_number_include_year: 'Include year in invoice number',
      invoice_number_include_year_help:
        'When enabled the year is included (e.g. F-2026-0001) and the counter resets every new year.',
      defaults: 'Defaults',
      payment_term_days: 'Default payment term (days)',
      default_vat_rate: 'Default VAT rate',
      default_currency: 'Default currency',
      prices_include_vat_default: 'Prices include VAT by default',
      deposit: 'Deposits',
      deposit_enabled: 'Enable deposit invoices',
      deposit_trigger_moment: 'Trigger',
      deposit_percentage: 'Deposit percentage (%)',
      deposit_tiers: 'Tiers',
      deposit_tiers_help:
        'Higher percentage from an order amount (incl. VAT). Below that the deposit percentage applies. A sales order without a quote gets a draft deposit right away.',
      deposit_tier_min_amount: 'From (€ incl. VAT)',
      deposit_tier_percentage: 'Percentage (%)',
      deposit_tier_add: 'Add tier',
      deposit_tier_remove: 'Remove tier',
      deposit_fixed_amount: 'Fixed deposit amount',
      deposit_auto_send: 'Auto send',
      deposit_trigger: {
        proforma_accepted: 'On accepted preliminary quote',
        definitive_accepted: 'On accepted definitive proposal',
      },
      deposit_layout: 'Deposit invoice layout',
      deposit_layout_help:
        'Choose how the lines on a deposit invoice are displayed. The total amount is always correct.',
      deposit_layout_recommended: 'Recommended',
      deposit_layout_itemized_title: 'Lines like the quote',
      deposit_layout_itemized_description:
        'Same lines as the quote, with amounts scaled to the deposit share. Most familiar for the customer.',
      deposit_layout_detailed_title: 'Detailed',
      deposit_layout_detailed_description:
        'Context block listing the work, followed by one line per VAT rate.',
      deposit_layout_per_vat_rate_title: 'Compact per VAT rate',
      deposit_layout_per_vat_rate_description:
        'One line per VAT rate, without context block. VAT-correct and compact.',
      deposit_layout_simple_title: 'Single line',
      deposit_layout_simple_description:
        'One line at the dominant VAT rate. Convenient for single-rate projects; not VAT-correct for mixed rates.',
      deposit_description_template: 'Description template',
      deposit_description_template_placeholder:
        'Deposit {percentage}% as per proposal {proposal_number}',
      deposit_description_template_help:
        'Use the placeholders {percentage}, {proposal_number}, {project_number} and {vat_rate}. Leave empty for the default text.',
      deposit_description_preview: 'Preview:',
      final_invoice: 'Final invoice',
      final_invoice_trigger: 'Trigger',
      final_invoice_auto_send: 'Auto send',
      final_trigger: {
        disabled: 'Disabled',
        manual_only: 'Manual only',
        project_completed: 'On project completion',
        work_order_completed: 'When the installation is completed',
      },
      requires_slim_werken: 'Some options require Slim Werken.',
      requires_slim_innen: 'Some options require Slim Innen.',
      definitive_deviation: 'Definitive proposal difference',
      price_deviation_moved:
        'Whether the agreed price is kept after the measurement is set under Settings → Organization → Proposals → Price difference after measurement.',
      warn_on_definitive_deviation: 'Warn on deviation from definitive proposal',
      reminders: 'Reminders',
      reminders_enabled: 'Enable automatic reminders',
      public_payment: 'Online payment',
      public_payment_enabled: 'Enable online payment via public link',
      merging: 'Draft merging',
      allow_invoice_merging: 'Allow draft merging',
      allow_invoice_merging_description:
        'Allow merging multiple draft invoices for the same customer into a single new draft invoice.',
      template: 'Template',
      payment_instructions: 'Payment instructions',
      payment_instructions_placeholder: 'Text shown on every invoice…',
      footer_text: 'Footer text',
      footer_text_placeholder: 'Optional footer at the bottom of every invoice…',
      default_attachments: 'Default attachments',
      default_attachments_help:
        'These PDFs are sent with every invoice email (including resends), e.g. terms and conditions. Not with reminders or credit notes.',
      add_attachment: 'Add PDF',
      remove_attachment: 'Remove attachment',
      attachment_only_pdf: 'Only PDF files are allowed',
      attachment_too_large: '{name} is too large (max 5MB)',
      attachment_added: 'Attachment added',
      attachment_removed: 'Attachment removed',
      attachment_save_error: 'Saving attachment failed',
      bcc: 'BCC on first send',
      bcc_help:
        'These addresses receive a blind copy (BCC) of the invoice when it is first sent. Not on resends or reminders. A Basecone address adds [VRK] to the subject so the invoice lands in the sales journal.',
      bcc_emails: 'BCC email addresses',
      bcc_emails_placeholder: "accounting{'@'}company.com",
      load_error: 'Could not load settings.',
      saved: 'Settings saved.',
      save_error: 'Could not save settings.',
    },

    payment_link: {
      generate: 'Generate payment link',
      title: 'Mollie payment link',
      intro:
        'Share this payment link or QR code with the customer. They can pay online via Mollie.',
      qr_label: 'Scan to pay',
      scan_with_camera: 'Scan with your phone camera',
      scan_not_bank_app:
        'Open the camera app and point it at the code. The scanner in your banking app will not recognise it.',
      copy_link: 'Copy link',
      copy_success: 'Link copied.',
      open_link: 'Open in new tab',
      expires_at: 'Valid until {date}',
      generating: 'Generating…',
      regenerate: 'Generate new link',
      error: 'Could not generate payment link.',
      not_connected_cta: 'Manage Mollie',
      requires_mollie: 'Connect Mollie first to generate payment links.',
    },
  },

  // ===========================================================================
  // Mollie / Slim Innen
  // ===========================================================================
  mollie: {
    name: 'Mollie',
    description: 'Let customers pay online via iDEAL, credit card and more.',
    badge_test: 'TEST',
    license_required_title: 'Slim Innen required',
    license_required:
      'Mollie is only available with the Slim Innen module. Activate the license to enable online payments.',

    status: {
      connected: 'Connected',
      not_connected: 'Not connected',
      profile: 'Mollie profile',
      organization: 'Mollie organisation',
      mode: 'Mode',
      mode_live: 'Live',
      mode_test: 'Test',
      connected_at: 'Connected at',
      can_accept_live_payments: 'Can accept live payments',
      kyc_pending: 'Mollie is verifying your account',
      kyc_pending_description:
        'Customers cannot pay yet — Mollie is verifying your organisation. This usually takes a few business days.',
      onboarding_incomplete: 'Mollie onboarding incomplete',
      onboarding_incomplete_description:
        'Mollie has not finished your onboarding yet. Open Mollie and complete the missing fields.',
      onboarding_open_link: 'Open Mollie dashboard',
    },

    actions: {
      connect: 'Connect Mollie',
      reconnect: 'Reconnect',
      manage: 'Manage Mollie',
      disconnect: 'Disconnect',
      view_status: 'View status',
      refresh: 'Refresh status',
    },

    connect: {
      success: 'Mollie connected successfully.',
      failed: 'Could not connect to Mollie — please try again.',
      cancelled: 'Mollie connection was cancelled.',
      popup_blocked: 'The popup was blocked. Allow popups or try again.',
    },

    disconnect: {
      title: 'Disconnect Mollie?',
      description:
        'Customers will no longer be able to pay invoices online via Mollie. Existing payments remain visible.',
      confirm: 'Disconnect',
      success: 'Mollie disconnected.',
      error: 'Could not disconnect Mollie.',
    },

    reasons: {
      not_licensed: 'Mollie is only available with the Slim Innen module.',
      not_connected: 'Connect your Mollie account in Integrations first.',
      reauth_required: 'The Mollie connection has expired. Reconnect.',
      not_configured: 'Mollie is currently unavailable. Please try later.',
      no_access_token: 'The Mollie connection has expired. Reconnect.',
    },

    errors: {
      MOLLIE_NOT_CONNECTED: 'Mollie is not connected — enable it in Integrations first.',
      MOLLIE_REAUTH_REQUIRED: 'The Mollie connection has expired — reconnect.',
      MOLLIE_PROFILE_REQUIRED:
        'Mollie requires a website profile before payment links can be created. Open Mollie → Settings → Profiles → New profile.',
      MOLLIE_PROFILE_REQUIRED_action: 'Open Mollie dashboard',
      INVOICE_NOT_PAYABLE: 'This invoice is no longer available for payment.',
      INVOICE_FULLY_PAID: 'This invoice has already been paid in full.',
      INVALID_AMOUNT: 'The invoice amount is invalid for online payment.',
      MOLLIE_PAY_RATE_LIMIT_EXCEEDED: 'Too many attempts. Please try again in a minute.',
      generic: 'Something went wrong with Mollie. Please try again later.',
    },

    public: {
      pay_now: 'Pay now',
      pay_now_description: 'Pay online via iDEAL, credit card and more.',
      redirecting: 'Redirecting to Mollie…',
      already_paid: 'This invoice has already been paid in full.',
      not_payable: 'This invoice cannot be paid online right now.',
      check_status: 'Checking whether your payment was received…',
      payment_received: 'Thanks — your payment has been received.',
    },

    payments_table: {
      mollie_label: 'Processed via Mollie',
      refund_label: 'Refund',
      chargeback_label: 'Chargeback (reversed via bank)',
    },

    work_order_complete: {
      title: 'Customer can pay now',
      subtitle: 'Scan the QR code or share the payment link with the customer.',
      open_link: 'Open payment link',
      close: 'Close',
      invoice_created: 'Invoice {number} created.',
      show_payment_link: 'Show payment link',
      payment_link_error: 'Could not load the payment link.',
      amount_due: 'Amount due',
      show_lines: 'View items ({count})',
      hide_lines: 'Hide items',
    },
  },

  // ===========================================================================
  // ZO Boekhouden
  // ===========================================================================
  zo_boekhouden: {
    name: 'ZO Boekhouden',
    description:
      'Connect your bookkeeping: invoices and payments are sent automatically to ZO Boekhouden. Bank payments come back so invoices in FunnelFlow are marked as paid.',

    status: {
      connected: 'Active',
      not_connected: 'Not connected',
      inactive: 'Inactive',
      active_message:
        'Connection active. New and updated invoices + Mollie payments are forwarded automatically.',
      empty_message:
        'Not connected yet. Ask ZO Boekhouden for the webhook URL and enter it here to get started.',
    },

    settings: {
      webhook_url: 'Webhook URL',
      webhook_url_info: 'ZO endpoint where we send events (invoice.updated, payment.received).',
      webhook_secret: 'Webhook secret',
      webhook_secret_info: 'Shared secret for HMAC signature. Share this securely with ZO.',
      is_active: 'Active',
      is_active_info: 'Turn on once ZO’s URL is known.',
      help: 'ZO fetches invoice details via the External API (this organisation’s API key). Without an active connection, invoices stay in FunnelFlow only.',
    },

    actions: {
      connect: 'Connect',
      manage: 'Manage ZO Boekhouden',
      save: 'Save',
      disconnect: 'Remove connection',
    },

    save: {
      success: 'ZO Boekhouden settings saved.',
      error: 'Could not save ZO Boekhouden settings.',
    },

    disconnect: {
      title: 'Remove ZO Boekhouden connection?',
      description: 'Invoices and payments will no longer be forwarded to ZO Boekhouden.',
      confirm: 'Remove',
      success: 'ZO Boekhouden connection removed.',
      error: 'Could not remove ZO Boekhouden connection.',
    },
  },

  snelstart: {
    name: 'SnelStart',
    description:
      'Post invoices automatically into your SnelStart administration (relations + sales bookings).',

    status: {
      connected: 'Active',
      not_connected: 'Not connected',
      inactive: 'Inactive',
      active_message:
        'Connection active. Invoices with a number are posted to SnelStart as sales bookings.',
      empty_message:
        'Not connected yet. Paste your connection key from SnelStart (Integrations → Custom) to get started.',
    },

    settings: {
      company: 'Administration',
      connection_key: 'Connection key',
      connection_key_info:
        'Key from SnelStart Web → Integrations → Custom. Requires inZicht or inControle package.',
      connection_key_placeholder_existing: 'Leave blank to keep the current key',
      grootboek_hoog: 'Ledger revenue high (21%)',
      grootboek_hoog_info: 'Required to sync standard VAT lines.',
      grootboek_laag: 'Ledger revenue low (9%)',
      grootboek_laag_info: 'Optional; otherwise low falls back to high.',
      grootboek_nul: 'Ledger revenue 0%',
      grootboek_nul_info: 'Optional for exempt lines.',
      grootboek_empty: '— Select an account —',
      is_active: 'Active',
      is_active_info: 'Turn off to pause syncing without removing the connection.',
      help: 'FunnelFlow writes relations and sales bookings to the SnelStart B2B API. Payment matching comes later. Production requires SnelStart certification.',
    },

    actions: {
      connect: 'Connect',
      manage: 'Manage SnelStart',
      save: 'Save',
      disconnect: 'Remove connection',
    },

    save: {
      success: 'SnelStart settings saved.',
      error: 'Could not save SnelStart settings.',
    },

    disconnect: {
      title: 'Remove SnelStart connection?',
      description:
        'Invoices will no longer be posted to SnelStart. Existing bookings in SnelStart remain.',
      confirm: 'Remove',
      success: 'SnelStart connection removed.',
      error: 'Could not remove SnelStart connection.',
    },
  },

  twinfield: {
    name: 'Twinfield',
    description: 'Post issued invoices to Twinfield automatically (debtor + sales transaction).',

    status: {
      connected: 'Active',
      not_connected: 'Not connected',
      inactive: 'Inactive',
      active_message:
        'Connection active. Invoices with a number are posted to Twinfield as sales transactions.',
      inactive_message:
        'Connected, not active yet. Choose an administration, ledger and VAT code, then turn it on.',
      empty_message: 'Not connected yet. Sign in to Twinfield to post invoices automatically.',
      reauth_message: 'Twinfield session expired. Reconnect to keep posting.',
      not_configured: 'Twinfield is not configured on the server yet.',
    },

    settings: {
      office: 'Administration',
      office_info:
        'Switching administration clears ledgers, VAT codes and the link between existing customers and bookings.',
      office_empty: '— Select an administration —',
      grootboek_hoog: 'Ledger revenue high (21%)',
      grootboek_laag: 'Ledger revenue low (9%)',
      grootboek_nul: 'Ledger revenue 0%',
      vat_hoog: 'VAT code high (21%)',
      vat_laag: 'VAT code low (9%)',
      vat_nul: 'VAT code 0%',
      journal: 'Journal',
      destiny: 'Posting status',
      destiny_info:
        'Provisional bookings can still be changed or deleted. Final posts straight to the ledger.',
      destiny_temporary: 'Provisional (recommended)',
      destiny_final: 'Final',
      option_empty: '— Select —',
      is_active: 'Active',
      is_active_info: 'Turn on once the administration, high ledger and high VAT code are set.',
      activate_required: 'Choose an administration, high ledger and high VAT code.',
      help: 'FunnelFlow keeps sending the invoice. Twinfield receives a debtor and a sales transaction with the FunnelFlow invoice number. Payment matching comes later.',
    },

    actions: {
      connect: 'Connect Twinfield',
      reconnect: 'Reconnect',
      manage: 'Manage Twinfield',
      save: 'Save',
      disconnect: 'Remove connection',
    },

    connect: {
      success: 'Twinfield is connected. Choose an administration and ledger next.',
      failed: 'Connecting to Twinfield failed.',
      popup_blocked: 'Allow pop-ups to connect Twinfield.',
    },

    save: {
      success: 'Twinfield settings saved.',
      error: 'Could not save Twinfield settings.',
    },

    disconnect: {
      title: 'Remove Twinfield connection?',
      description:
        'Invoices will no longer be posted to Twinfield. Existing bookings in Twinfield remain.',
      confirm: 'Remove',
      success: 'Twinfield connection removed.',
      error: 'Could not remove Twinfield connection.',
    },
  },

  moneybird: {
    name: 'Moneybird',
    description: 'Send issued invoices to Moneybird automatically and pull payments back.',

    status: {
      connected: 'Active',
      not_connected: 'Not connected',
      inactive: 'Inactive',
      active_message:
        'Connection active. Issued invoices are posted to Moneybird as external sales invoices (with PDF); payments registered there flow back automatically.',
      empty_message:
        'Not connected yet. Create a personal API token in Moneybird (My account → Developers) to get started.',
    },

    settings: {
      administration: 'Administration',
      administration_info:
        'Your token has access to multiple administrations. Choose where invoices should be posted.',
      administration_empty: '— Select an administration —',
      administration_required: 'Select an administration.',
      administration_pick: 'Select the Moneybird administration below and click Connect again.',
      api_token: 'API token',
      api_token_info:
        'Personal API token from Moneybird (My account → Developers → API tokens). Required permissions: Sales invoices and Settings.',
      api_token_placeholder_existing: 'Leave blank to keep the current token',
      api_token_required: 'Enter an API token.',
      tax_rate_high: 'VAT rate high (21%)',
      tax_rate_low: 'VAT rate low (9%)',
      tax_rate_zero: 'VAT rate 0%',
      tax_rate_reverse_charge: 'VAT rate reverse charge',
      tax_rate_reverse_charge_info:
        'Used for reverse-charged invoices. Optional; otherwise falls back to 0%.',
      ledger_account: 'Revenue ledger account',
      ledger_account_info: 'Optional; blank = Moneybird default revenue account.',
      option_empty: '— Select —',
      is_active: 'Active',
      is_active_info: 'Turn off to pause syncing without removing the connection.',
      webhook_ok: 'Webhook registered: payments from Moneybird arrive automatically.',
      webhook_missing:
        'Webhook not registered. Payments from Moneybird will not be pulled in automatically.',
      help: 'FunnelFlow remains the invoice issuer; Moneybird receives an external sales invoice with the FunnelFlow PDF attached. Mollie/iDEAL payments are not (yet) pushed to Moneybird.',
    },

    actions: {
      connect: 'Connect',
      manage: 'Manage Moneybird',
      save: 'Save',
      disconnect: 'Remove connection',
      register_webhook: 'Register again',
    },

    save: {
      success: 'Moneybird settings saved.',
      error: 'Could not save Moneybird settings.',
    },

    webhook: {
      success: 'Webhook registered with Moneybird.',
      error: 'Could not register webhook with Moneybird.',
    },

    disconnect: {
      title: 'Remove Moneybird connection?',
      description:
        'Invoices will no longer be sent to Moneybird and payments will no longer be pulled in. Existing invoices in Moneybird remain.',
      confirm: 'Remove',
      success: 'Moneybird connection removed.',
      error: 'Could not remove Moneybird connection.',
    },
  },

  // ===========================================================================
  // ===========================================================================
  // Organization onboarding wizard
  // ===========================================================================
  onboarding: {
    actions: {
      next: 'Next',
      back: 'Back',
      skip: 'Skip',
      finish: 'Finish',
      upload_pdf: 'Upload PDF',
    },
    fields: {
      company_name: 'Organization name',
      logo: 'Logo',
      street: 'Street',
      postal_code: 'Postal code',
      city: 'City',
      phone: 'Phone',
      kvk: 'Chamber of Commerce no.',
      vat: 'VAT number',
      iban: 'IBAN',
      terms_pdf: 'Terms & conditions (PDF)',
      primary_color: 'Primary color',
      accent_color: 'Accent color',
      reply_to_email: 'Reply-to email',
      email: 'Email address',
      role: 'Role',
      team_emails: 'Invite team members',
    },
    steps: {
      company: {
        title: 'Tell us about your company',
        description:
          'Send a flawless quote within minutes with your branding, CoC details and terms on every proposal.',
        bullet_1: 'Branded proposals with your logo and company details',
        bullet_2: 'Customers accept your terms online',
      },
      branding: {
        title: 'Branding and email',
        description: 'Automatic proposals in your style, ready to sign digitally.',
        bullet_1: 'Proposals in your brand colors',
        bullet_2: 'Customer replies go to your reply-to address',
      },
      products: {
        title: 'Which starter products?',
        description:
          'Build products with variables and rules so customers configure their own setup.',
        bullet_1: 'Pick one or more template products to get started',
        bullet_2: 'Live pricing based on options and dimensions',
      },
      team: {
        title: 'Invite your team',
        description: 'All customers, communication and projects in one place for your whole team.',
        bullet_1: 'Sales and office work in the same CRM',
        bullet_2: 'Installers only see their field work',
      },
    },
    products: {
      hint: 'Select the products you want to start with. You can customize them later.',
    },
    team: {
      hint: 'Invite colleagues so everyone works in the same system.',
      emails_placeholder: 'jane@acme.com, mark@acme.com',
      emails_help: 'Separate multiple emails with commas.',
      add_colleague: 'Add another colleague',
      role_admin: 'Office / owner: settings, team and proposals',
      role_member_label: 'Member',
      role_member: 'Sales: leads, deals and proposals',
      role_installer_label: 'Installer',
      role_installer: 'Field: lands on Today, no settings access',
    },
    checklist: {
      greeting: 'Hello, {name}!',
      subtitle: "Let's set up your workspace.",
      progress: '{done} of {total} steps complete',
      dismiss: 'Continue later',
      banner: {
        title: 'Finish setting up your workspace',
        subtitle: '{done} of {total} steps complete',
        cta: 'View steps',
      },
      steps: {
        profile: 'Company profile',
        profile_description: 'Your company details are set. Adjust them in organization settings.',
        profile_cta: 'Go to settings',
        team: 'Invite team',
        team_description: 'Invite colleagues so sales and field teams work in the same system.',
        team_cta: 'Invite team',
        products: 'Starter products',
        products_description: 'Add products so your configurator can create real quotes.',
        products_cta: 'Go to products',
        funnel: 'Publish first configurator',
        funnel_description: 'Publish your first funnel so customers can submit requests.',
        funnel_cta: 'Go to funnels',
      },
    },
    errors: {
      company_name_required: 'Please enter an organization name.',
      pdf_only: 'Only PDF files are allowed.',
      upload_failed: 'Upload failed.',
      save_failed: 'Save failed. Please try again.',
      load_products: 'Could not load starter products.',
    },
  },

  // Platform Admin (Funnelflow team only)
  // ===========================================================================
  platform: {
    sidebar: {
      section: 'Funnelflow team',
      link: 'Platform admin',
    },
    nav: {
      overview: 'Overview',
      organizations: 'Organizations',
      users: 'Users',
      billing: 'Billing',
      products: 'Products',
      catalog: 'Catalog',
      demo: 'Seed team',
      audit: 'Audit log',
      exit: 'Back to app',
    },
    warning: {
      title: 'You are managing ALL organizations.',
      body: 'Be careful — every change is logged and immediately visible to customers.',
    },
    impersonation: {
      banner_title: 'You are signed in as',
      exit: 'Stop impersonation',
      exiting: 'Restoring…',
      exit_failed: 'Could not stop impersonation.',
    },
    pickers: {
      search_organizations: 'Search an organization…',
      search_licenses: 'Pick a license…',
      search_placeholder: 'Search…',
      loading: 'Loading…',
      no_results: 'No results',
      selected: 'Selected',
      inactive: 'inactive',
    },
    relative: {
      just_now: 'just now',
      seconds: '{n}s',
      minutes: '{n}m',
      hours: '{n}h',
      days: '{n}d',
      months: '{n}mo',
      years: '{n}y',
      ago: '{value} ago',
      in: 'in {value}',
    },
    action_labels: {
      'billing.checkout_link.create': 'Stripe link created',
      'billing.trial.extend': 'Trial extended',
      'products.copy_between_orgs': 'Products copied',
      'user.impersonate.start': 'Signed in as user',
      'user.impersonate.end': 'Impersonation ended',
      'organization.create': 'Organization created',
      'organization.seed_demo': 'Demo org seeded',
      'organization.status.update': 'Org status updated',
      'license.manual.grant': 'Manual license granted',
      'license.cancel': 'License cancelled',
      'license.quantity.update': 'Seat count updated',
    },
    kpis: {
      title: 'KPIs',
      mrr: 'MRR',
      mrr_paying: 'MRR (paying)',
      arr: 'ARR',
      mrr_added_30d: 'New MRR (30d)',
      trial_mrr: 'Trial pipeline',
      trial_mrr_help:
        'Potential MRR if all current trials converted — not counted as real revenue.',
      active_customers: 'Customers',
      trials_active: 'Trials',
      trials_active_summary: '{n} trials active',
      customers_summary: '{n} customers',
      trials_ending_7d: 'Trial ending < 7d',
      new_signups_7d: 'New (7d)',
      new_signups_30d: 'New (30d)',
      churn_30d: 'Churn (30d)',
    },
    chart: {
      title: 'MRR over time',
      mrr_label: 'MRR (paying)',
      trial_mrr_label: 'Trial MRR (potential)',
      load_failed: 'Could not load chart.',
      empty: 'No historical data yet.',
      tooltip: {
        active_customers: 'Paying customers',
        trial_customers: 'Trial customers',
      },
      interval: {
        weekly: 'Weekly',
        monthly: 'Monthly',
      },
      range: {
        12: '12 weeks',
        26: '26 weeks',
        52: '52 weeks',
      },
      disclaimer:
        'Historical MRR is estimated from the current subscription data — re-activations and trial conversions are not always retroactively accurate. Refer to Stripe reporting for exact finance numbers.',
    },
    attention: {
      title: 'Action items',
      empty: 'Nothing to do — everything looks good!',
      past_due: '{n} organizations past_due',
      trials_ending_3d: '{n} trials ending within 3 days',
      orgs_without_license: '{n} active organizations without license',
      suspended: '{n} suspended organizations',
      failed_jobs: "{n} failed jobs in queue '{queue}'",
      queue_unavailable: "Queue '{queue}' unreachable (Redis hiccup)",
      view: 'View',
    },
    activity: {
      title: 'Recent activity',
      empty: 'No activity logged yet.',
      view_all: 'View all',
      view_details: 'Details',
      load_failed: 'Failed to load stats.',
      generated_at: 'Updated {value}',
    },
    landing: {
      title: 'Platform admin',
      description:
        'Tools for the Funnelflow team to manage organizations, users, billing and products across all tenants.',
      refresh: 'Refresh',
      stats: {
        organizations: 'Organizations',
        active: 'Active',
        trials: 'Running trials',
      },
      tiles: {
        organizations: {
          title: 'Manage organizations',
          description: 'List, status and details for every organization.',
        },
        new_organization: {
          title: 'New organization',
          description: 'Create an organization and send the owner invite.',
        },
        users: {
          title: 'Users + impersonation',
          description: 'Cross-org user search and login as customer.',
        },
        checkout_link: {
          title: 'Stripe checkout link',
          description: 'Generate a checkout URL with a custom trial.',
        },
        trial_extend: {
          title: 'Extend trial',
          description: 'Push out the first-billing date for a Stripe sub.',
        },
        manual_license: {
          title: 'Manual license',
          description: 'Grant a license without Stripe (partner / beta / internal).',
        },
        products_copy: {
          title: 'Copy products',
          description: 'Copy feeds, categories and products between orgs.',
        },
        demo_seed: {
          title: 'Seed a team',
          description: 'Copy catalog and pipeline into a team with fake data.',
        },
        audit: {
          title: 'Audit log',
          description: 'Filterable log of every admin action.',
        },
      },
    },
    organizations: {
      title: 'Organizations',
      description: 'List of every Funnelflow organization.',
      new: 'New organization',
      new_title: 'New organization',
      new_description: 'Create an organization and immediately invite the first owner.',
      back_to_list: 'Back to list',
      search_placeholder: 'Search by name or slug…',
      empty_title: 'No organizations found',
      empty_description: 'Adjust your filters or create a new organization.',
      load_failed: 'Failed to load organizations.',
      status: {
        all: 'All',
        active: 'Active',
        suspended: 'Suspended',
        archived: 'Archived',
      },
      col: {
        name: 'Name',
        status: 'Status',
        activity: 'Activity',
        members: 'Members',
        base_license: 'Base license',
        modules: 'Modules',
        created_at: 'Created',
      },
      activity: {
        recent: 'Active',
        quiet: 'Quiet',
        inactive: 'Inactive',
        unknown: 'No data',
        latest: 'Latest activity',
        last_login: 'Login',
        last_proposal: 'Proposal',
        logins: 'Logins',
        proposals: 'Proposals',
        deals: 'Deals',
        orders: 'Purchase orders',
      },
      fields: {
        name: 'Name',
        name_placeholder: 'e.g. Acme Inc.',
        slug: 'Slug',
        slug_placeholder: 'acme',
        slug_help: 'URL-friendly identifier used in internal URLs.',
        owner_email: 'Owner email',
        owner_email_placeholder: "owner{'@'}customer.com",
        owner_role: 'Role',
      },
      roles: {
        admin: 'Admin',
        owner: 'Owner',
      },
      create_submit: 'Create organization',
      create_success: 'Organization created and invite sent.',
      create_failed: 'Could not create organization.',
      result_title: 'Created',
      invite_title: 'Owner invitation',
      invite_existing: 'This user already existed — an invite was sent to their existing account.',
      invite_new:
        'The owner will receive an email to activate their account. Use the link below if the email is not delivered.',
      invite_expires: 'Expires on',
      open_org: 'Open organization',
      create_another: 'Create another',
      actions: {
        new_link: 'Stripe link',
        extend_trial: 'Extend trial',
        manual_license: 'Manual license',
        update_quantity: 'Seats',
        cancel: 'Cancel',
      },
      onboarding: {
        title: 'Onboarding',
        disable: 'Disable',
        enable: 'Enable',
        reset: 'Reset',
        disable_title: 'Disable onboarding?',
        disable_description: 'The wizard and checklist will be hidden for this organization.',
        enable_title: 'Enable onboarding?',
        enable_description: 'Onboarding will follow normal rules again (cutoff / pending).',
        reset_title: 'Reset onboarding?',
        reset_description:
          'The org admin will see the intake again on next login. Existing data is kept.',
        disable_success: 'Onboarding disabled.',
        enable_success: 'Onboarding enabled.',
        reset_success: 'Onboarding reset.',
        disable_failed: 'Could not disable onboarding.',
        enable_failed: 'Could not enable onboarding.',
        reset_failed: 'Could not reset onboarding.',
        status: {
          grandfathered: 'Existing customer',
          pending: 'Intake pending',
          completed: 'Completed',
          disabled: 'Disabled',
        },
      },
      sales_orders: {
        title: 'Sales order',
        on: 'On',
        off: 'Off',
        hint: 'Projects start with a sales order, also without a quote. The order is the source for scope and extra work.',
        enable: 'Turn on',
        disable: 'Turn off',
        enable_title: 'Turn on sales orders?',
        enable_description:
          '{name} will start projects with the sales order wizard, also without a quote. The sales order becomes the source for the project scope, and extra work needs an order.',
        disable_title: 'Turn off sales orders?',
        disable_description:
          '{name} will start projects from a quote again. Existing sales orders stay, but the scope follows the quote again and extra work no longer needs an order.',
        enabled_success: 'Sales orders are on.',
        disabled_success: 'Sales orders are off.',
        failed: 'Could not change sales orders.',
      },
      detail: {
        slug: 'Slug',
        id: 'ID',
        members: 'Members',
        subscriptions: 'Subscriptions',
        counts: 'Counts',
        no_members_title: 'No members yet',
        no_members_description: 'This organization has no active members.',
        no_subs_title: 'No subscriptions',
        no_subs_description: 'Generate a Stripe link or grant a manual license.',
        load_failed: 'Failed to load organization.',
        status_updated: 'Status updated.',
        status_update_failed: 'Could not update status.',
        update_quantity_prompt: 'New seat count:',
        invalid_quantity: 'Invalid quantity.',
        quantity_updated: 'Seat count updated.',
        quantity_update_failed: 'Could not update seat count.',
        cancel_title: 'Cancel subscription?',
        cancel_description:
          '"{name}" will be cancelled. For base licenses all attached modules will be cancelled too. Are you sure?',
        cancel_confirm: 'Yes, cancel',
        cancel_success: 'Subscription cancelled.',
        cancel_failed: 'Cancellation failed.',
        this_subscription: 'this subscription',
        remove_member_action: 'Remove',
        remove_member_title: 'Remove member from team?',
        remove_member_description:
          '"{name}" will be removed from this organization. Their user account and other teams stay intact. Are you sure?',
        remove_member_confirm: 'Yes, remove',
        remove_member_success: 'Member removed from team.',
        remove_member_failed: 'Could not remove member.',
        remove_last_admin_blocked:
          'This is the last admin of the organization and cannot be removed. Make another member an admin first.',
        remove_last_member_blocked:
          'This is the last member of the organization and cannot be removed. An organization must keep at least one member.',
      },
      counts: {
        forms: 'Funnels',
        deals: 'Deals',
        orders: 'Purchase orders',
        submissions: 'Requests',
        products: 'Products',
      },
    },
    users: {
      title: 'Users',
      description: 'Cross-org user search and impersonation.',
      search: 'Search',
      search_placeholder: 'Search by email or name…',
      search_failed: 'Search failed.',
      empty_title: 'No users found',
      empty_description: 'Try a different email or name.',
      no_name: 'No name',
      last_sign_in: 'Last sign in',
      impersonate: 'Login as',
      impersonate_confirm_title: 'Sign in as user?',
      impersonate_confirm_description:
        'You are about to sign in as {label}. Your current session will be saved and can be restored from the banner at the top.',
      impersonate_confirm_submit: 'Yes, sign in',
      impersonate_failed: 'Impersonation failed.',
      col: {
        email: 'Email',
        name: 'Name',
        role: 'Role',
      },
    },
    checkout: {
      title: 'Stripe checkout link',
      description:
        'Generate a checkout URL for an organization with optional trial and price overrides.',
      submit: 'Generate link',
      success: 'Stripe link created.',
      failed: 'Could not generate Stripe link.',
      result_title: 'Result',
      open_in_stripe: 'Open in Stripe',
      send_to_customer: 'Send to customer',
      email_subject: 'Your Funnelflow checkout link',
      email_body:
        'Hi,\n\nClick this link to finish your subscription:\n{url}\n\nThanks,\nFunnelflow',
      trial_ends: 'First billing date {date}',
      advanced: 'Advanced',
      no_modules: 'No modules available.',
      trial: {
        default: 'Default (from license)',
        days: 'Custom number of days',
        date: 'Specific date',
        none: 'No trial',
      },
      fields: {
        organization: 'Organization',
        base_license: 'Base license',
        quantity: 'Seats',
        quantity_range: 'Min {min}, max {max}',
        quantity_min: 'Min {min}',
        modules: 'Modules',
        trial: 'Trial',
        trial_days_hint: 'Days before the first invoice is created.',
        trial_days_unit: 'days',
        trial_date_hint: 'Exact date when the first invoice is created.',
        email_override: 'Email override',
        email_override_placeholder: "billing{'@'}customer.com",
        email_override_help: 'Send the Stripe customer to this email instead of auto-lookup.',
        price_overrides: 'Price overrides',
        price_overrides_help: 'Free Stripe price ID per license for custom deals.',
        success_url: 'Success URL',
        success_url_placeholder: 'https://app.getfunnelflow.com/billing/success',
        cancel_url: 'Cancel URL',
        cancel_url_placeholder: 'https://app.getfunnelflow.com/billing/cancel',
        note: 'Note',
        note_placeholder: 'Free text, stored in subscription.metadata',
      },
      errors: {
        no_organization: 'Pick an organization first.',
        no_license: 'Pick a base license first.',
      },
    },
    trial: {
      title: 'Extend trial',
      description: 'Push out the first-invoice date of an active Stripe subscription.',
      submit: 'Extend trial',
      success: 'Trial extended.',
      failed: 'Could not extend trial.',
      result_title: 'Result',
      warning:
        'Only works for organizations with an active Stripe subscription, not for manual licenses.',
      fields: {
        new_trial_end: 'New trial end date',
        trial_end_hint: 'Date when the first invoice is created.',
      },
      errors: {
        no_stripe_sub: 'No active Stripe subscription found for this organization.',
      },
    },
    manual_license: {
      title: 'Manual license',
      description: 'Grant a license without Stripe — for partners, beta users or internal use.',
      submit: 'Grant license',
      success: 'License granted.',
      failed: 'Could not grant license.',
      warning:
        'No Stripe billing — renewal is manual. The audit log records who did this and when.',
      result_title: 'Result',
      fields: {
        license: 'License',
        quantity: 'Seats',
        start_date: 'Start date',
        end_date: 'End date',
        is_trial: 'Trial license',
        is_trial_help: 'Mark as trial instead of a paid license.',
      },
      errors: {
        conflict: 'This organization already has an active subscription for this license.',
      },
    },
    demo_seed: {
      title: 'Seed a team',
      description:
        'Copy forms, products and pipeline from a source team into a target team. Leads, deals, quotes and invoices are fictional — real customer data stays put.',
      run_dry_run: 'Dry run preview',
      execute: 'Seed team',
      dry_run_title: 'Dry run preview',
      executed_title: 'Team seeded',
      success: 'The team is ready. You can switch into it now.',
      failed: 'Seeding failed.',
      dry_run_failed: 'Dry run failed.',
      switch_failed: 'Could not switch to the team.',
      open_demo: 'Open team',
      open_target: 'Open team',
      default_source: 'Akogo Zonwering',
      default_target: 'Zonwering Demo',
      warning:
        'This wipes the existing contents of “{target}” and refills the team. The source team itself is not changed.',
      confirm_title: 'Reseed this team?',
      confirm_description:
        '“{target}” will be emptied and refilled from {source}, with fictional leads, deals, quotes and invoices. Continue?',
      confirm_submit: 'Yes, seed',
      fields: {
        source: 'Source team',
        source_hint: 'Leave empty to use Akogo Zonwering.',
        target: 'Target team',
        target_hint: 'Leave empty to use the shared “Zonwering Demo” org.',
      },
      copies: {
        structure: 'Yes: forms, products, pipeline, quote templates.',
        fake_data: 'Yes: ~40 fictional leads and deals, spread across the pipeline.',
        examples: 'Yes: sample quotes and fake invoices (no real customer data).',
        never: 'No: real customers, submissions, integrations, API keys.',
      },
      errors: {
        same_org: 'Source and target must be different teams.',
      },
      counts: {
        forms: 'Forms',
        pipelines: 'Pipelines',
        stages: 'Stages',
        feeds: 'Feeds',
        categories: 'Categories',
        products: 'Products',
        designs: 'Designs',
        leads: 'Leads',
        deals: 'Deals',
        proposals: 'Quotes',
        invoices: 'Invoices',
      },
    },
    products: {
      title: 'Copy products',
      description:
        'Copy categories, feeds, products and upsell links from one organization to another — fully or a selected subset.',
      run_dry_run: 'Dry run preview',
      execute: 'Execute for real',
      dry_run_title: 'Dry run preview',
      executed_title: 'Copy completed',
      success: 'Products copied.',
      failed: 'Copy failed.',
      dry_run_failed: 'Dry run failed.',
      dry_run_label: 'Type',
      is_dry_run: 'Dry run',
      is_executed: 'Executed',
      open_target: 'Open target organization',
      warning: 'Always start with a dry run to see what will be copied.',
      confirm_title: 'Copy products?',
      confirm_description:
        'You are about to copy {products} products and {categories} categories to "{target}". Continue?',
      confirm_submit: 'Yes, copy',
      fields: {
        source: 'Source organization',
        target: 'Target organization',
      },
      counts: {
        categories: 'Categories',
        feeds: 'Feeds',
        products: 'Products',
        category_links: 'Category links',
        upsells_remapped: 'Upsells remapped',
      },
      errors: {
        same_org: 'Source and target must be different organizations.',
        catalog_failed: 'Failed to load source catalog.',
        no_selection: 'Select at least one feed, category or product.',
      },

      // ---- Source catalog / selection ----
      selection: {
        title: 'What do you want to copy?',
        description:
          'Pick the full catalog or a specific selection. When selecting, the related feeds and categories are always included automatically.',
        load_source_first: 'Pick a source organization to load its catalog first.',
        loading_catalog: 'Loading catalog…',
        empty: 'Source organization has no products.',
        feed_label: 'Feed',
        no_feed: 'No feed',
        no_image: 'No image',
        product_count: '{n} products',
        search_placeholder: 'Search by title or SKU…',
        select_all: 'Select all',
        deselect_all: 'Deselect all',
        showing_first: 'First {n} results',
      },

      mode: {
        all: 'Full catalog',
        feeds: 'By feed',
        categories: 'By category',
        products: 'By product',
      },

      summary: {
        title: 'Summary',
        full_copy: 'The full catalog will be copied.',
        partial_copy: 'Selection:',
        products: '{n} products',
        feeds: '{n} feeds',
        categories: '{n} categories',
      },

      result: {
        mode_full: 'Full catalog',
        mode_partial: 'Selection',
        requested: 'Requested',
        resolved: 'Resolved',
        requested_products: '{n} product IDs',
        requested_feeds: '{n} feed IDs',
        requested_categories: '{n} category IDs',
      },
    },
    audit: {
      title: 'Audit log',
      description: 'Every change made via /platform/* — both success and error are logged.',
      load_failed: 'Could not load audit log.',
      empty_title: 'No audit log entries',
      empty_description: 'Adjust your filters to see results.',
      detail_title: 'Audit log details',
      filters: {
        action: 'Action',
        status: 'Status',
        from: 'From',
        to: 'To',
        actor_user_id: 'Actor user ID',
        target_org: 'Target org ID',
        all_actions: 'All actions',
        all_statuses: 'All statuses',
      },
      col: {
        created_at: 'Time',
        actor: 'Actor',
        action: 'Action',
        status: 'Status',
        target_org: 'Target org',
      },
      actor: 'Actor',
      action: 'Action',
      target_org: 'Target organization',
      status: 'Status',
      created_at: 'Created at',
      payload: 'Payload',
      copy: 'Copy',
      copied: 'Copied',
    },
  },

  // ============================================================
  // Stats Dashboard
  // ============================================================
  stats_dashboard: {
    title: 'Stats',
    description: 'Revenue, funnel, margin and team in one overview',
    vat_note: 'Amounts excl. VAT',
    nav_label: 'Stats',
    refresh: 'Refresh',
    refresh_widget: 'Reload widget',
    last_updated: 'Updated {when}',
    load_failed: 'Failed to load stats',
    empty_data: 'No data in this period',

    filters: {
      period_label: 'Period',
      pipeline_label: 'Pipeline',
      pipeline_all: 'All pipelines',
      scope_label: 'Scope',
      scope_organization: 'Organization',
      scope_user: 'My data',
      custom_from: 'From',
      custom_to: 'To',
    },
    periods: {
      '7d': 'Last 7 days',
      '30d': 'Last 30 days',
      '90d': 'Last 90 days',
      mtd: 'Month to date',
      qtd: 'Quarter to date',
      ytd: 'Year to date',
      all: 'All time',
      custom: 'Custom',
    },

    error: {
      timeout_title: 'Too slow to load',
      timeout_description: 'This widget is slow to respond — try again or shrink the period.',
      failed_title: 'Could not load widget',
      failed_description: 'Something went wrong loading this section. Try again.',
      retry: 'Try again',
    },

    kpis: {
      title: 'KPIs',
      sold: 'Sold',
      sold_hint: 'Accepted proposals in this period',
      sold_tooltip:
        'Sold revenue is the unique sales value excl. VAT. Preliminary and final quotes within ' +
        'the same deal count as a single sale: the revenue stays on the first acceptance date, ' +
        'while the amount and line items come from the current accepted final quote once it ' +
        'exists. If there is no final quote yet, we use the current accepted preliminary quote. ' +
        'Additional/extra-work quotes count separately.',
      installed: 'Installed',
      installed_hint: 'Installations completed in this period',
      installed_tooltip:
        'Revenue from installation work orders completed in this period. Measurement visits are excluded, and a project with multiple installation visits is split so the amount is not double-counted.',
      planned: 'Planned',
      planned_hint: 'Installations with an appointment in this period',
      planned_tooltip:
        'Revenue from installation work orders whose appointment falls in this period. Confirmed and tentative appointments both count. Measurement visits are excluded.',
      collected: 'Collected',
      collected_hint: 'Paid invoices in this period',
      avg_ticket: 'Avg ticket',
      avg_ticket_hint: 'Average paid invoice value',
      win_rate: 'Win rate',
      win_rate_hint: 'Won / (won + lost)',
      counts: {
        accepted_proposals: '{n} proposals accepted',
        planned_work_orders: '{n} installations on the calendar',
        completed_work_orders: '{n} installations completed',
        paid_invoices: '{n} invoices paid',
        won_deals: '{n} won',
        lost_deals: '{n} lost',
      },
    },

    funnel: {
      title: 'Funnel',
      description: 'From request to payment — conversions are relative to requests.',
      conversion_short: 'Conv.',
      steps: {
        submissions: 'Requests',
        deals: 'Deals',
        proposals_sent: 'Proposals sent',
        proposals_accepted: 'Proposals accepted',
        invoices_created: 'Invoices created',
        invoices_paid: 'Invoices paid',
      },
    },

    revenue_timeline: {
      title: 'Revenue over time',
      description:
        'Pick sold, planned or realized for the chart. Amounts excl. VAT, per {interval}.',
      legend: {
        sold: 'Sold',
        planned: 'Planned',
        realized: 'Realized',
        ordered: 'Ordered',
        invoiced: 'Invoiced',
        paid: 'Paid',
      },
      legend_hint: 'Click to toggle a series',
      interval: {
        daily: 'day',
        weekly: 'week',
        monthly: 'month',
      },
      hero_meta: 'Peak: {peakLabel} ({peakValue}) · average {avg} per {interval}',
      of_sold: 'of sold',
      ratio_hint: '{ratio} of sold revenue reached this stage',
    },

    pipeline: {
      title: 'Open pipeline',
      description: 'What is currently open per stage',
      no_open: 'No open deals',
      column_count: 'deals',
      column_value: 'value',
      total_label: 'Total',
      total_format: '{count} deals · {value}',
    },

    health: {
      title: 'Financial health',
      description: 'Trailing-365 base for DSO and backlog',
      metrics: {
        dso: 'DSO',
        dso_hint: 'Days sales outstanding',
        sales_cycle: 'Sales cycle',
        sales_cycle_hint: 'Avg days from create to won',
        backlog: 'Backlog',
        backlog_hint: 'Days of revenue in unbilled jobs',
        accounts_receivable: 'AR',
        accounts_receivable_hint: 'Unpaid invoices',
        backlog_value: 'Backlog value',
        backlog_value_hint: 'Unbilled jobs',
        sold_backlog_value: 'Sold backlog',
        sold_backlog_value_hint: 'Sold but not yet invoiced',
        sold_backlog_count: 'Open proposals',
        sold_backlog_count_hint: 'Accepted without invoice',
        sold_backlog_days: 'Sold backlog days',
        sold_backlog_days_hint: 'At current run-rate',
        annual_revenue: 'Annual revenue',
        annual_revenue_hint: 'Trailing 365 days',
      },
    },

    leaderboard: {
      title: 'Top performers',
      sellers_title: 'Top sellers',
      sellers_description: 'Based on accepted proposals',
      installers_title: 'Top installers',
      installers_description: 'Based on completed work orders',
      empty: 'No one on the leaderboard yet',
      headers: {
        name: 'Name',
        count: '#',
        value: 'Value',
      },
      count_orders: '{n} jobs',
      count_proposals: '{n} proposals',
    },

    reject_reasons: {
      title: 'Top rejection reasons',
      description: 'Why proposals were rejected in this period',
      empty: 'No rejections in this period',
      count_proposals: '{n} proposals',
      total: '{n} rejected · {value}',
    },

    products: {
      title: 'Products',
      description: 'Sold and invoiced per product and category',
      tab_products: 'Top products',
      tab_categories: 'By category',
      empty: 'No products in this period',
      headers: {
        rank: '#',
        product: 'Product',
        category: 'Category',
        sold: 'Sold',
        invoiced: 'Invoiced',
        units: 'Units',
        share: 'Share',
      },
      totals: {
        sold: 'Total sold',
        invoiced: 'Total invoiced',
        products_with_id: 'Unique products',
        unknown: 'Unknown',
        unknown_share: '{share} without product link',
      },
      concentration: {
        top_n: 'Top {n} = {share} of sold',
        single: 'Top product = {share} of sold',
      },
      legend: {
        sold: 'Sold',
        invoiced: 'Invoiced',
      },
      donut_center: 'Sold',
      unknown_product: 'Unknown product',
      no_category: 'No category',
      sold_breakdown: '{units} units · {proposals} proposals',
      invoiced_breakdown: '{units} units · {proposals} proposals',
    },
    installer_stats: {
      title: 'Installer stats',
      description: 'Per installer per day — average invoice value + hours',
      headers: {
        name: 'Installer',
        work_orders: 'Work orders',
        total_value: 'Total',
        avg_per_day: 'Avg €/day',
        hours: 'Hours',
        days: 'Days',
      },
      empty: 'No installers with work in this period',
      filter_label: 'Installer',
      filter_all: 'All installers',
    },

    // ============================================================
    // Margin widgets (2026-05-12)
    // Reads from proposal_items.metadata.margin_snapshot — only
    // stamped on proposals created after the migration, so coverage
    // is initially low and grows organically.
    // ============================================================
    margin_group: {
      title: 'Gross margin',
      subtitle: 'Based on lines with a margin snapshot',
    },
    margin_totals: {
      title: 'Gross margin',
      description: 'Revenue, cost and margin for this period vs. previous',
      empty: 'Gross margin will appear once you accept new proposals',
      headline_label: 'Gross margin in this period',
      margin_on_revenue: '{margin} on {revenue} revenue',
      delta_vs_previous: '{delta} vs. previous period',
      no_previous_period: 'No previous period to compare against',
      no_previous_period_short: 'No previous period',
      previous_period_revenue: 'On {revenue} revenue',
      cells: {
        revenue: 'Revenue',
        cost: 'Cost',
        margin_value: 'Margin amount',
        previous_margin_pct: 'Previous margin%',
      },
      coverage: {
        ok_title: 'Based on {pct} of lines',
        warn_title: 'Only {pct} of lines',
        unknown_title: 'Coverage unknown',
        detail: '{covered} of {total} lines with snapshot',
      },
    },
    margin_products: {
      title: 'Margin per product',
      description: 'Best and worst performing margins in this period',
      empty: 'No products with margin data in this period yet',
      best_title: 'Top margin',
      best_hint: 'Best margin first',
      best_empty: 'No products with positive margin yet',
      worst_title: 'Lowest margin',
      worst_hint: 'Worst margin first',
      worst_empty: 'No flagged products',
      unknown_product: 'Unknown product',
      totals: {
        product_count: 'Unique products',
        revenue: 'Revenue',
        margin: 'Margin amount',
      },
      meta: {
        revenue: '{value} revenue',
        cost: '{value} cost',
        units: '{n} units',
      },
      flag_below_min: 'Below {min} min.',
    },
    margin_under_threshold: {
      title: 'Below minimum margin',
      description: 'Proposal lines with margin below the configured floor',
      empty: 'No minimum margin set on your products',
      all_clear_title: 'No proposals below minimum margin',
      all_clear_description:
        'Every accepted line in this period meets or exceeds its floor. Nice work!',
      unknown_product: 'Unknown product',
      qty_x: '{n} units',
      totals: {
        flagged_count: 'Flagged lines',
        flagged_value: 'Flagged amount',
        flagged_margin_loss: 'Estimated margin loss',
      },
      headers: {
        date: 'Date',
        product: 'Product',
        applied: 'Applied',
        min: 'Min.',
        gap: 'Gap',
        amount: 'Amount',
      },
    },

    // ============================================================
    // Forecast widget (Phase 3 — 2026-05-12)
    // ============================================================
    forecast: {
      title: 'Forecast {year}',
      title_window: 'Forecast within filter',
      description: 'Target vs. sold, planned and realized',
      description_window: 'Target vs. actual within the selected period',
      empty_no_target: 'Set a revenue target to track your progress here',
      annual_target: 'Annual target',
      ytd_sold: 'YTD sold',
      ytd_planned: 'YTD planned',
      ytd_realized: 'YTD realized',
      ytd_target: 'YTD target',
      ytd_gap: 'Gap',
      window_sold: 'Sold',
      window_planned: 'Planned',
      window_realized: 'Realized',
      window_target: 'Window target',
      window_gap: 'Gap',
      pace: 'Status',
      legend: {
        target: 'Target (cumulative)',
        sold: 'Sold (cumulative)',
        planned: 'Planned',
        realized: 'Realized',
      },
      status: {
        ahead: '{delta} ahead',
        on_track: 'On track',
        behind: '{delta} behind',
        achieved: 'Target reached',
        missed: 'Target missed',
        no_target: 'No target set',
      },
      mode: {
        year: 'Year',
        window: 'Filter',
      },
      mode_aria: 'Forecast view mode',
      interval: {
        daily: 'per day',
        weekly: 'per week',
        monthly: 'per month',
      },
      projection_distribution: 'EOY projection',
      projection_linear: 'Linear projection',
      above_target: 'above target',
      below_target: 'below target',
      pattern_used: 'Pattern',
    },
  },

  documents: {
    title: 'Documents',
    add: 'Add document',
    uploading: 'Uploading...',
    empty_title: 'No documents yet',
    empty_deal: 'Upload contracts, drawings or other files. They carry over to the project.',
    empty_project:
      'The signed proposal is listed here, along with files from the deal and anything you upload.',
    signed_proposal: 'Signed proposal',
    signed_proforma: 'Signed pro forma',
    signed_additional: 'Signed variation',
    uploaded: 'Uploaded',
    from_deal: 'From deal',
    from_project: 'From project',
    download: 'Download',
    delete: 'Delete',
    delete_title: 'Delete document?',
    delete_description: '"{name}" is also removed from the linked deal or project.',
    delete_confirm: 'Yes, delete',
    deleted: 'Document deleted',
    load_failed: 'Could not load documents',
    upload_failed: 'Upload failed',
    download_failed: 'Download failed',
    delete_failed: 'Could not delete document',
  },
};
